/**
 * Created by: Hensi Murcia
 * On: 11/19/19
 * drawer.js: javascript for the drawer.html
 */
"use strict";

import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  setDisplay,
  checkDevice,
  closeModal,
  openCommonModal,
  sameDay,
  showToast,
  getAudioTime,
  formatMessageDate,
  formatTime,
  sendTextMessage,
  disableButton,
  addSizeToGoogleProfilePic,
  linkify,
  sendGifMessage,
  closeMyModal,
  getCookie,
  setCookie,
  deleteCookie,
  appId,
  dragElement,
  saveFile,
  saveLocalFile,
  getDayAbbr,
  formatMilTime,
  reformatPaste,
  getCountryName,
  getCountryIndex,
  removeTags,
  formatDurationHMS,
  sendVoiceMsg,
  validateURL,
  scrollLeft,
  scrollRight,
  GroupType,
  copyInput,
} from "./common";
import phPersonImg from "url:../images/person_placeholder.svg";
import phRadioImg from "url:../images/radio_placeholder.svg";
import phBannerImg from "url:../images/wave_rnb.svg";
import phTrashIcon from "url:../images/trash.svg";
import phPlayingIcon from "url:../images/playing.svg";
import phYTPlayIcon from "url:../images/yt_play_btn.svg";
import phDownloadIcon from "url:../images/download.svg";
import grayHeartIcon from "url:../images/ic_gray_heart.svg";
import HeartIcon from "url:../images/ic_red_heart.svg";
import phAddPerson from "url:../images/add_person.svg";
import phAcceptPerson from "url:../images/accept_person.svg";
import phXPerson from "url:../images/x_person.svg";
import phReqCancel from "url:../images/req_cancel.svg";
import phReply from "url:../images/reply_white.svg";
import phForward from "url:../images/forward_white.svg";
import phShare from "url:../images/share_white.svg";
import phLoading from "url:../images/loading.svg";
import phImage from "url:../images/image.svg";
import sndAttention from "url:../sounds/attention.mp3";
import phPodcast from "url:../images/podcast.svg";
import AgoraRTC from "agora-rtc-sdk-ng";

const podcastFeedParser = require("@podverse/podcast-feed-parser");
import IcecastMetadataStats from "icecast-metadata-stats";
import { defAppRef, vapidKey } from "./config";
//var internetradio = require("node-internet-radio");
//var http = require("http");
//import nodeInternetRadio from "./radio";
// var testStream = "http://stream.zeno.fm/bmv92smzzbruv";
// nodeInternetRadio.getStationInfo(testStream, function(error, station) {
//     console.log(error);
//     console.log(station);
//   });
var currentUserId;
var cUser;
var currentChat, currentChatType;
var currentElement;
var currentChatId;
var currentChatRef,
  participantsRef,
  participantList = [];
var chatBmRef;
var petitionsRef;
var userName;
var profileImage;
var email;
var userInfo;
var lastDate;
var btnSend;
var btnAttach;
var messageCount = 0;
var inImageUpload = document.getElementById("inImageUpload");
var uploadFile;
var authListener;
var inProfileUpload;
var ui;
var rMessage;
var rKey;
var trans;
var newUser;
var onlineRef;
var pendingRadioUser = false;
var onlineBroadcastRef, roleRef, liveVideoRef, cohostVideoRef;
var hostName = "";
var isCreator, hasPermission, radioStarted;
var currentRadioName;
var isNewUserContent = false;
var colorArray = [];
var userArray = [];
var chatUserArray = [];
var chatUserKeyArray = [];
var chatsArray = [];
var chatsKeyArray = [];
var hostKeyArray = [];
var ytVideoList = [];
var ytVideoIdList = [];
var initVideoId;
var onlineSent = false;
var webRef;
var isFavorite;
var radioLikesRef;
var vCoins = 2;
var requestConfig;
var reqDefaultConfig;
var unlockTime;
var timeRef, djConfigRef, vCoinRef;
var requestmessage = true;
var lastSearch;
var radioDjsRef,
  radioAdminsRef,
  onlineUsersRef,
  reqVideoRef,
  userReqVideoRef,
  watchRef;
var radioInfo;
var userData;
var isEmail;
var webSent = false;
var rtc, option, streamInfo;
var isVideoLive = false;
var isMainHost = false;
var isCohost = false;
var agoraStarted = false;
var isDjLive = false;
var currentChannel;
var joined = false;
var reqInfo;
var radioHost;
var hasYtVideo;
var isYtwatching;
var player;
var videoPlaying;
var clientLoaded;
var int00;
var radioVerified = true;
var btnViewUserSkd,
  bSchedule,
  bSettings,
  divAdminSkd,
  secSchedule,
  skdEmpty,
  skdList,
  btnAddSkd,
  btnManageSkd;
var btnSkdBack,
  btnSettingsBack,
  btnSkdCont,
  btnSkdSubmit,
  btnSkdUpImg,
  btnSkdPre,
  btnFullSkd,
  btnToggleNotification;
var ulDays;
var dNone, divDayCont, divAddSkd, btnAddSkdBack;
var inBcastName, inSkdIcon;
var imgSkdIcon;
var divSkdVerify, divSkdBtns, lstSkdNow, dSkdPreview;
var curSkdSeg = 0,
  curDaySeg;
var showClass, copyShowKey, copyShowClass;
var typeZero = false;
var addSkdModal, uploadProgressModal;
var aUploadIcon;
var userSkdRef, groupSkdRef, allowLinkRef;
var daySkdArray = [];
var daySkdKeyArray = [];
var curDay;
var skdTodayArray = [];
var skdTodayKeyList = [];
var adLoaded = false;
var callDurationInterval;
var divPodImg;
var groupRef;
var groupInfo;
var fragsInitiated;
var podPlayer;
var episodeList = [];
var currentEpisode = 0;
var audioPlayId;
var userLikeRef;
var MIC_PERMISSION, CAM_PERMISSION;
var recorder, stream, chunks, mediaOptions, recCanceled;
var allowNum = 1;
var allowLink;
var picker;
var recordTimer;
var recTimeDuration;
var onlineTimer;
var group;
var gRole;
let notificationAllowed,
  startMsgLs = true,
  messaging;
let dbUserSub, cTopic, subOn, notificationKey;
let notificationModal;

$(document).ready(function () {
  $(function () {
    // Makemoji.init('48c5728254635f8aa686190ca85ed87a874f34ea', "#inContainer", {"trending": true, "unicode": false});
    // var textField = document.getElementById('makemojifield');
    // var trendingBar = document.getElementById('makemojitrendingbar');
    initViews();
    translatePage();
    checkDevice();

    btnSend = document.getElementById("btnSend");
    btnAttach = document.getElementById("btnAttach");
    var titleHome = document.getElementById("titleHome");
    var divTypeHere = document.getElementById("divTypeHere");
    var textContainer = document.getElementById("textContainer");
    inProfileUpload = document.getElementById("inProfileUpload");

    getCurrentUserId();
    getTopRadios();
    initListeners();
    checkPemissions();
    //initMarquee();

    picker.on("emoji", (emoji) => {
      textContainer.textContent += emoji;
      divTypeHere.style.visibility = "hidden";
      btnRecordAudio.style.display = "none";
      btnSend.style.display = "block";
    });
    btnMoji.addEventListener("click", () => {
      picker.togglePicker(btnMoji);
      //$(textContainer).focus();
      var inEmojiSearch = emojiRoot.querySelector("input.emoji-picker__search");
      if (inEmojiSearch != null) {
        inEmojiSearch.placeholder = trans.searchEmojis;
      }
      if (!picker.pickerVisible) {
        setTimeout(function () {
          $(textContainer).focus();
        }, 100);
      }
    });
    textContainer.addEventListener("click", function () {
      setTimeout(function () {
        $(textContainer).focus();
      }, 100);
    });
    textContainer.addEventListener(
      "input",
      function () {
        // console.log("children: " + textContainer.childNodes.length);
        if (textContainer.textContent.trim() == "") {
          textContainer.textContent = "";
          divTypeHere.style.visibility = "visible";
          btnRecordAudio.style.display = "block";
          btnSend.style.display = "none";
          pWarning.style.display = "none";
        } else {
          divTypeHere.style.visibility = "hidden";
          btnRecordAudio.style.display = "none";
          btnSend.style.display = "block";
          if (!allowLink) {
            checkIsLink(textContainer.textContent.trim());
          }
        }
      },
      false
    );
    reformatPaste();
    // spCl.addEventListener("change", function () {
    //   if (spCl.textContent.trim() != "") {
    //     console.log("the gif rec: " + spCl.textContent);

    //     uploadGif(spCl.textContent);
    //   }
    // });
    $(spCl).change(function () {
      if (spCl.textContent.trim() != "") {
        console.log("the gif rec: " + spCl.textContent);

        uploadGif(spCl.textContent);
      }
    });
    // $(document).keydown(function (e) {
    //   if (e.keyCode == 13 && !e.shiftKey) {
    //     e.preventDefault();
    //     btnSend.click();
    //   }
    // });
    textContainer.addEventListener("keyup", function (e) {
      if (13 === e.keyCode && !e.shiftKey) {
        e.preventDefault();
        btnSend.click();
      }
    });
    titleHome.addEventListener(
      "click",
      function () {
        if (currentUserId) {
          mnuProfile.click();
        } else {
          initUserLogin(295);
          //window.location.replace("../index.html");
        }
      },
      false
    );

    btnSend.addEventListener(
      "click",
      function () {
        if (!currentUserId) {
          initUserLogin(306);
          return;
        }
        if (pWarning.style.display && pWarning.style.display == "block") {
          $(pWarning).shake();
          return;
        }
        if (
          chunks != null &&
          recorder != null &&
          recorder.state != "inactive"
        ) {
          recorder.stop();
          btnRecordAudio.style.display = "block";
          btnSend.style.display = "none";
          textContainer.focus();
        } else {
          textContainer.innerHTML = textContainer.innerHTML
            .trim()
            .replace(/<br\s*[\/]?>/gi, "\n");
          var input = textContainer.textContent.trim();

          var chatRef, bmRef;
          bmRef = firebase
            .database()
            .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + currentChatId);
          switch (currentChatType) {
            case "RadioChat":
              chatRef = firebase.database().ref("Chats/" + currentChatId);
              break;
            case "privateChat":
              chatRef = firebase
                .database()
                .ref("PrivateChat/" + currentUserId + "/" + currentChatId);
              break;
            case "GroupChat":
              chatRef = firebase
                .database()
                .ref("GroupChats/" + currentChatId + "/chat/" + currentUserId);
              break;
            case "podChat":
              chatRef = firebase.database().ref("podChat/" + currentChatId);
              break;
          }
          if (input.length > 0) {
            sendTextMessage(
              input,
              bmRef,
              chatRef,
              rMessage,
              rKey,
              currentChatType,
              userInfo,
              currentChat,
              currentChatId,
              null,
              participantList
            );
            textContainer.textContent = "";
            textContainer.focus();
            btnRecordAudio.style.display = "block";
            btnSend.style.display = "none";
            divTypeHere.style.visibility = "visible";
            if (rKey) {
              rKey = null;
              rMessage = null;
              setDisplay(replyContent, "none");
            }
          }
        }
      },
      false
    );

    btnRemoveReply.addEventListener(
      "click",
      function () {
        rKey = null;
        rMessage = null;
        setDisplay(replyContent, "none");
      },
      false
    );

    window.onunload = noTimeout;
    window.onbeforeunload = warning;

    window.onclick = function (event) {
      if (event.target == largeRadioImage) {
        closeModal(largeRadioImage);
      } else if (event.target == largeImageView) {
        closeModal(largeImageView);
      } else if (!event.target.matches(".dropbtn")) {
        hideDropdowns();
      }
    };

    radioLogo.addEventListener("click", function () {
      setDisplay(largeRadioImage, "flex");
    });
  });
});
function checkIsLink(s) {
  var radioLink = window.location.href;
  const myArray = s.split(" ");
  for (let word of myArray) {
    if (validateURL(word)) {
      if (word != radioLink) {
        pWarning.style.display = "block";
      }
      break;
    } else {
      pWarning.style.display = "none";
    }
  }
}
function initViews() {
  picker = new EmojiButton({
    autoHide: false,
    rootElement: emojiRoot,
  });
  btnManageSkd = document.getElementById("btnManageSkd");
  btnViewUserSkd = document.getElementById("btnViewUserSkd");
  bSchedule = document.getElementById("bSchedule");
  divAdminSkd = document.getElementById("divAdminSkd");
  bSettings = document.getElementById("bSettings");
  secSchedule = document.getElementById("secSchedule");
  skdEmpty = document.getElementById("skdEmpty");
  skdList = document.getElementById("skdList");
  btnAddSkd = document.getElementById("btnAddSkd");
  btnSkdBack = document.getElementById("btnSkdBack");
  btnSettingsBack = document.getElementById("btnSettingsBack");
  ulDays = document.getElementById("ulDays");
  dNone = document.getElementById("dNone");
  divDayCont = document.getElementById("divDayCont");
  divAddSkd = document.getElementById("divAddSkd");
  btnAddSkdBack = divAddSkd.querySelector("button.btn-back");
  btnSkdCont = document.getElementById("btnSkdCont");
  btnSkdSubmit = document.getElementById("btnSkdSubmit");
  inBcastName = document.getElementById("inBcastName");
  btnSkdUpImg = document.getElementById("btnSkdUpImg");
  imgSkdIcon = document.getElementById("imgSkdIcon");
  divSkdVerify = document.getElementById("divSkdVerify");
  btnSkdPre = document.getElementById("btnSkdPre");
  divSkdBtns = document.getElementById("divSkdBtns");
  inSkdIcon = document.getElementById("inSkdIcon");
  addSkdModal = document.getElementById("addSkdModal");
  uploadProgressModal = document.getElementById("uploadProgressModal");
  aUploadIcon = document.getElementById("aUploadIcon");
  btnFullSkd = document.getElementById("btnFullSkd");
  lstSkdNow = document.getElementById("lstSkdNow");
  dSkdPreview = document.getElementById("sSkdPreview");
  divPodImg = podChat.querySelector(".toolbar img");
  podPlayer = document.getElementById("podPlayer");
  var divReadClose = epReadFull.querySelector("button");
  btnToggleNotification = document.getElementById("btnToggleNotification");
  notificationModal = document.getElementById("notificationModal");

  $(divReadClose).click(function (e) {
    e.stopPropagation();
    setDisplay(epReadFull, "none");
  });
  initPodListeners();
  initDiscoverTab();
}
function showNotificationModal() {
  setDisplay(notificationModal, "flex");
}
function initDiscoverTab() {
  let btnFavL = document.getElementById("btnFavLeft");
  let btnFavR = document.getElementById("btnFavRight");
  let btnL = document.getElementById("btnDisLeft");
  let btnR = document.getElementById("btnDisRight");
  let discList = document.getElementById("discoverList");
  let inRadioSearch = document.getElementById("inRadioSearch");
  let parentDiscList = document.getElementById("discoverListParent");
  let btnSearchPods = document.getElementById("btnSearchPods");
  let divSearchResults = document.getElementById("divSearchResults");
  let divSearchParent = document
    .getElementById("radios")
    .querySelector(".searchbar.disc");
  let btnSearchRadios = document.getElementById("btnSearchRadios");
  let btnCancelSearch = document.getElementById("btnDiscSearchCancel");
  let favRadioList = document.getElementById("divFavRadios");
  $(btnL).click(function (e) {
    e.stopPropagation();
    scrollLeft(discList, btnR, btnL, "block", 200);
  });

  $(btnR).click(function (e) {
    e.stopPropagation();
    scrollRight(discList, btnR, btnL, "block", 200);
  });
  $(btnSearchRadios).click(function (e) {
    e.stopPropagation();
    if (GroupType.radio != group) {
      divSearchResults.textContent = "";
    }
    group = GroupType.radio;
    setDisplay(divSearchParent, "flex");
    setDisplay(divSearchResults, "block");
    setDisplay(parentDiscList, "none");
    inRadioSearch.placeholder = trans.searchRadios;
    inRadioSearch.focus();
  });
  $(btnSearchPods).click(function (e) {
    e.stopPropagation();
    if (GroupType.podcast != group) {
      divSearchResults.textContent = "";
    }
    group = GroupType.podcast;
    setDisplay(divSearchParent, "flex");
    setDisplay(divSearchResults, "block");
    setDisplay(parentDiscList, "none");
    inRadioSearch.placeholder = trans.searchPods;
    inRadioSearch.focus();
  });
  $(btnCancelSearch).click(function (e) {
    e.stopPropagation();
    inRadioSearch.value = "";
    setDisplay(divSearchParent, "none");
    setDisplay(divSearchResults, "none");
    setDisplay(parentDiscList, "block");
    setDisplay(divNoResults, "none");
  });

  $(btnFavL).click(function (e) {
    e.stopPropagation();
    scrollLeft(favRadioList, btnFavR, btnFavL, "block", 200);
  });

  $(btnFavR).click(function (e) {
    e.stopPropagation();
    scrollRight(favRadioList, btnFavR, btnFavL, "block", 200);
  });
}
function searchPods(lSearch, searchLoad) {
  let divSearchResults = document.getElementById("divSearchResults");
  var searchQuery = firebase
    .database()
    .ref("podcast")
    .orderByChild("lcTitle")
    .startAt(lSearch)
    .endAt(lSearch + "\uf8ff");
  searchQuery.once("value", function (data) {
    if (data.exists()) {
      setDisplay(searchLoad, "none");
      setDisplay(divNoResults, "none");
      data.forEach(function (pod) {
        if (document.getElementById("search" + pod.key)) {
          divSearchResults.textContent = "";
        }
        addPodcast(pod.key, pod.val(), "divSearchResults", "search");
      });
    } else {
      setDisplay(searchLoad, "none");
      divNoResults.textContent = trans.radioNotFound.replace("$name", lSearch);
      setDisplay(divNoResults, "block");
      divSearchResults.textContent = "";
    }
  });
}

function addPodcast(key, podcast, parent, ext) {
  var id = ext ? ext + key : key;
  var oldDiv = document.getElementById(id);
  const container = document.createElement("div");
  container.innerHTML = RADIO_TEMPLATE;
  const div = container.firstChild;

  oldDiv = document.getElementById(id);
  div.setAttribute("id", id);
  var parentList = document.getElementById(parent);
  var divLikes = div.querySelector(".likes");

  if (podcast.likes) {
    divLikes.textContent = "❤️ " + podcast.likes;
    setDisplay(divLikes, "block");
  } else {
    setDisplay(divLikes, "none");
  }
  const nameElement = div.querySelector(".name");
  nameElement.textContent = podcast.title;
  div.querySelector(".imgRadio").src = podcast.icon ? podcast.icon : phPodcast;

  if (oldDiv) {
    parentList.replaceChild(div, oldDiv);
  } else {
    const listChildren = parentList.children;
    if (listChildren.length === 0) {
      parentList.appendChild(div);
    } else {
      parentList.insertBefore(div, parentList.children[0]);
    }
  }

  div.addEventListener(
    "click",
    function () {
      displayChat(key, podcast, "podChat", true);
      // if (verified) {
      //   //displayChat(podId, podcast, "podChat", true);
      // } else {
      //   currentChatId = id;
      //   radioInfo = podcast;
      //   if (currentUserId == radioInfo.admin_ID) {
      //     isCreator = true;
      //     initEditModal(false);
      //     setDisplay(editRadioModal, "flex");
      //   }
      // }
    },
    false
  );
}
function searchRadios(lSearch, searchLoad) {
  var searchQuery = firebase
    .database()
    .ref("Radio Stations")
    .orderByChild("info/lowCaseName")
    .startAt(lSearch)
    .endAt(lSearch + "\uf8ff");
  searchQuery.once("value", function (data) {
    if (data.exists()) {
      setDisplay(searchLoad, "none");
      setDisplay(divNoResults, "none");
      data.forEach(function (radio) {
        if (document.getElementById(radio.key + "search")) {
          divSearchResults.textContent = "";
          addRadio(radio.key, radio.val().info, "divSearchResults", true);
        } else {
          addRadio(radio.key, radio.val().info, "divSearchResults", true);
        }
      });
    } else {
      setDisplay(searchLoad, "none");
      divNoResults.textContent = trans.radioNotFound.replace("$name", lSearch);
      setDisplay(divNoResults, "block");
      divSearchResults.textContent = "";
    }
  });
}
function checkPemissions() {
  navigator.permissions.query({ name: "microphone" }).then(function (result) {
    if (result.state == "granted") {
      MIC_PERMISSION = "g";
    } else if (result.state == "prompt") {
      MIC_PERMISSION = "p";
    } else if (result.state == "denied") {
      MIC_PERMISSION = "d";
    }
    result.onchange = function () {
      if (result.state == "granted" || result.state == "prompt") {
        MIC_PERMISSION = "g";
        showToast(trans.permissionGranted);
      } else {
        MIC_PERMISSION = "d";
        showToast(trans.permissionDenied);
      }
    };
  });

  mediaOptions = {
    video: {
      tag: "video",
      type: "video/webm",
      ext: ".mp4",
      gUM: { video: true, audio: true },
    },
    audio: {
      tag: "audio",
      type: "audio/mp3",
      ext: ".mp3",
      gUM: { audio: true },
    },
  };

  initMediaListeners();
}
function initMediaListeners() {
  let btnRecordAudio = document.getElementById("btnRecordAudio");
  let btnCancelRec = document.getElementById("btnCancelRec");
  btnRecordAudio.onclick = (e) => {
    if (MIC_PERMISSION === "g" || MIC_PERMISSION === "p") {
      recordAudio();
    } else {
      permissionModal.querySelector(".p1").textContent = trans.micPermission;
      permissionModal.querySelector(".p2").textContent = trans.checkSettings;
      setDisplay(permissionModal, "flex");
    }
  };
  $(btnCancelRec).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    cancelVoiceRec();
  });
}
function cancelVoiceRec() {
  if (recorder != null && recorder.state != "inactive") {
    recCanceled = true;
    recorder.stop();
    chunks = [];
  }
  textContainer.focus();
}
function recordAudio() {
  navigator.mediaDevices
    .getUserMedia(mediaOptions.audio.gUM)
    .then((_stream) => {
      stream = _stream;

      recorder = new MediaRecorder(stream);
      recorder.ondataavailable = (e) => {
        chunks.push(e.data);
        if (recorder.state == "inactive") {
          stopRecTimer();
          if (!recCanceled) {
            makeLink();
          } else {
            recCanceled = false;
            showToast(trans.voiceMsgDeleted);
            timeSpan.innerHTML = "0:00";
            setDisplay(typeArea, "flex");
            setDisplay(recordContainer, "none");
            setDisplay(btnRecordAudio, "block");
            setDisplay(btnSend, "none");
          }
        }
      };
      setDisplay(typeArea, "none");
      setDisplay(recordContainer, "flex");
      setDisplay(btnRecordAudio, "none");
      setDisplay(btnSend, "block");
      chunks = [];
      recorder.start();
      startRecTimer(new Date().getTime());
    })
    .catch(function (e) {
      showToast(trans.permissionDenied);
    });
}
function stopRecTimer() {
  if (recordTimer != null) {
    clearInterval(recordTimer);
    recordTimer = null;
  }
}
function stopOnlineTimer() {
  if (onlineRef != null) {
    onlineRef.remove();
  }
  if (onlineTimer != null) {
    clearInterval(onlineTimer);
    onlineTimer = null;
  }
}

function startOnlineTimer() {
  onlineTimer = setInterval(initOnline(), 30000);
}
function initOnline() {
  if (onlineRef != null) {
    onlineRef.set(new Date().getTime());
  }
}
function startRecTimer(countDownDate) {
  recordTimer = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    recTimeDuration = now - countDownDate;
    var timeX = getAudioTime(recTimeDuration);
    document.getElementById("timeSpan").innerHTML = timeX;
  }, 1000);
}
function makeLink() {
  let blob = new Blob(chunks, { type: mediaOptions.audio.type });
  let url = URL.createObjectURL(blob);
  srcRec.src = url;
  var time = Math.floor(audRec.duration * 1000);
  if (isNaN(time)) {
    time = recTimeDuration;
  }
  var strTime = time.toString();
  var chatRef, bmRef;
  bmRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + currentChatId);
  switch (currentChatType) {
    case "RadioChat":
      chatRef = firebase.database().ref("Chats/" + currentChatId);
      break;
    case "privateChat":
      chatRef = firebase
        .database()
        .ref("PrivateChat/" + currentUserId + "/" + currentChatId);
      break;
    case "GroupChat":
      chatRef = firebase
        .database()
        .ref("GroupChats/" + currentChatId + "/chat/" + currentUserId);
      break;
    case "podChat":
      chatRef = firebase.database().ref("podChat/" + currentChatId);
      break;
  }
  sendVoiceMsg(
    blob,
    bmRef,
    chatRef,
    rMessage,
    rKey,
    currentChatType,
    userInfo,
    currentChat,
    currentChatId,
    null,
    participantList,
    strTime
  );
  textContainer.focus();
  btnRecordAudio.style.display = "block";
  btnSend.style.display = "none";
  timeSpan.innerHTML = "0:00";
  setDisplay(typeArea, "flex");
  setDisplay(recordContainer, "none");
  if (rKey) {
    rKey = null;
    rMessage = null;
    setDisplay(replyContent, "none");
  }
  $(textContainer).focus();
}

function initPodListeners() {
  const iPlay = `<i class="fas fa-play"></i>`;
  const iPause = `<i class="fas fa-pause"></i>`;
  var btnPlayPod = document.getElementById("btnPlayPod");
  btnPrevEp.addEventListener("click", function () {
    prevPodEpisode();
  });

  btnPlayPod.addEventListener("click", function () {
    //var playerSrc =podPlayer.querySelector('source');
    //var feed = playerSrc != null? playerSrc.src:null;
    if (podPlayer.paused) {
      if (podPlayer.readyState > 0) {
        podPlayer.play();
      } else {
        podPlayer.load();
      }
    } else {
      podPlayer.pause();
    }
  });
  btnNextEp.addEventListener("click", function () {
    //var playerSrc =podPlayer.querySelector('source');
    //var feed = playerSrc != null? playerSrc.src:null;
    nextPodEpisode();
  });
  podPlayer.onended = function () {
    btnPlayPod.title = trans.play;
    nextPodEpisode();
  };
  podPlayer.onerror = function () {
    btnPlayPod.title = trans.errorMess;
    setDisplay(epLoading, "none");
  };
  podPlayer.oncanplay = function () {
    //btnPlayPod.title = trans.pause;
    //podPlayer.play();
    setDisplay(epLoading, "none");
  };
  podPlayer.onplay = function () {
    btnPlayPod.title = trans.pause;
    btnPlayPod.classList.replace("tPlay", "tPause");
    setDisplay(epLoading, "none");
    btnPlayPod.innerHTML = iPause;
  };
  podPlayer.onpause = function () {
    btnPlayPod.title = trans.play;
    btnPlayPod.classList.replace("tPause", "tPlay");
    btnPlayPod.innerHTML = iPlay;
  };
  podPlayer.onloadstart = function () {
    //btnPlayPod.title = trans.pause;
    setDisplay(epLoading, "block");
  };

  var podTabs = podChat.querySelectorAll(".tablinks");
  podTabs[0].addEventListener("click", function () {
    openPodTab("home");
  });
  podTabs[1].addEventListener("click", function () {
    if (currentUserId != null) {
      openPodTab("chat");
    } else {
      initUserLogin(886);
    }
  });

  btnPodChat.addEventListener("click", function () {
    if (currentUserId != null) {
      openPodTab("chat");
    } else {
      initUserLogin(894);
    }
  });
}
function nextPodEpisode() {
  var totalEp = episodeList.length - 1;
  var c = podEpisodeList.children;
  if (currentEpisode < totalEp) {
    var divEp = c[currentEpisode + 1];
    divEp.querySelector(".epPlay").click();
  } else {
    var divEp = c[0];
    divEp.querySelector(".epPlay").click();
  }
}
function prevPodEpisode() {
  var totalEp = episodeList.length - 1;
  var c = podEpisodeList.children;
  if (c == 0 || totalEp <= 0) {
    return;
  }
  if (currentEpisode != 0) {
    var divEp = c[currentEpisode - 1];
    divEp.querySelector(".epPlay").click();
  } else {
    var divEp = c[totalEp];
    divEp.querySelector(".epPlay").click();
  }
}
function hideDropdowns() {
  var dropdowns = document.getElementsByClassName("dropdown-content");
  var i;
  for (i = 0; i < dropdowns.length; i++) {
    var openDropdown = dropdowns[i];
    if (openDropdown.classList.contains("show")) {
      openDropdown.classList.remove("show");
    } else {
      setDisplay(openDropdown, "none");
    }
  }
}
function uploadGif(url) {
  if (!currentUserId) {
    initUserLogin(937);
    return;
  }
  if (!url) {
    return;
  }
  var input = textContainer.textContent.trim(); //Makemoji.getHTML();

  var chatRef, bmRef;
  bmRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + currentChatId);
  switch (currentChatType) {
    case "RadioChat":
      chatRef = firebase.database().ref("Chats/" + currentChatId);
      break;
    case "privateChat":
      chatRef = firebase
        .database()
        .ref("PrivateChat/" + currentUserId + "/" + currentChatId);
      break;
    case "GroupChat":
      chatRef = firebase
        .database()
        .ref("GroupChats/" + currentChatId + "/chat/" + currentUserId);
      break;
    case "podChat":
      chatRef = firebase.database().ref("podChat/" + currentChatId);
      break;
  }
  //send gif message
  sendGifMessage(
    input,
    bmRef,
    chatRef,
    rMessage,
    rKey,
    currentChatType,
    userInfo,
    currentChat,
    currentChatId,
    url,
    participantList
  );

  textContainer.textContent = "";
  textContainer.focus();
  divTypeHere.style.visibility = "visible";
  if (rKey) {
    rKey = null;
    rMessage = null;
    setDisplay(replyContent, "none");
  }
  setDisplay(gifView, "none");
  $(textContainer).focus();
}
// function initMarquee() {
//   $(".marquee").marquee({
//     direction: "left",
//     duration: 15000,
//   });
// }
function initListeners() {
  var sidepanelClose = sidePanel.querySelector(".btnClose");
  mnuMenu.addEventListener("click", function () {
    //openChats();
    if (currentUserId) {
      openNav();
    } else {
      initUserLogin(1006);
    }
  });

  mnuChats.addEventListener("click", function () {
    openChats();
  });

  mnuProfile.addEventListener("click", function () {
    //openNav();
    if (currentUserId) {
      panProfile.click();
    } else {
      initUserLogin(1019);
    }
  });
  sidepanelClose.addEventListener("click", function () {
    closeNav();
  });
  panAddRadio.addEventListener("click", function () {
    openModal("newRadioModal", "flex");
  });

  panLogout.addEventListener("click", function () {
    openModal();
  });
  downloadApp.querySelector(".close").addEventListener("click", function () {
    closeModal("downloadApp");
  });
  largeRadioImage
    .querySelector(".close")
    .addEventListener("click", function () {
      closeModal("largeRadioImage");
    });
  largeImageView.querySelector(".close").addEventListener("click", function () {
    closeModal("largeImageView");
  });
  myModal.querySelector(".close").addEventListener("click", function () {
    closeMyModal();
  });
  chatRulesModal
    .querySelector(".btn-close")
    .addEventListener("click", function () {
      closeModal("chatRulesModal");
    });
  btnLogout.addEventListener("click", function () {
    logout();
  });
  btnNo.addEventListener("click", function () {
    closeMyModal();
  });
  newRadioModal.querySelector(".close").addEventListener("click", function () {
    closeModal("newRadioModal");
  });
  newRadioModal
    .querySelector(".btnBlue")
    .addEventListener("click", function () {
      openNewRadio();
    });
  newRadioModal
    .querySelector(".btnGray")
    .addEventListener("click", function () {
      closeModal("newRadioModal");
    });

  btnTranslate.addEventListener("click", function () {
    showDropdown();
  });
  aEn.addEventListener("click", function () {
    translatePage("en");
  });
  aEs.addEventListener("click", function () {
    translatePage("es");
  });
  btnChats.addEventListener("click", function (event) {
    if (currentUserId != null) {
      openTab(event, "chats", 0);
    } else {
      //show login box
      initUserLogin(1085);
    }
  });
  btnRadios.addEventListener("click", function (event) {
    openTab(event, "radios", 1);
    inRadioSearch.focus();
  });
  btnFriends.addEventListener("click", function (event) {
    if (currentUserId != null) {
      openTab(event, "friendsList", 2);
      inFSearch.focus();
    } else {
      //show login box
      initUserLogin(1098);
    }
  });
  panSearch.addEventListener("click", function () {
    closeNav();
    navBox.style.display = "flex";
    btnFriends.click();
  });
  panFriend.addEventListener("click", function () {
    closeNav();
    navBox.style.display = "flex";
    btnRequests.click();
  });
  panMyRadios.addEventListener("click", function () {
    closeNav();
    navBox.style.display = "flex";
    btnRadios.click();
  });
  btnRequests.addEventListener("click", function (event) {
    if (currentUserId != null) {
      openTab(event, "requests", 3);
    } else {
      //show login box
      initUserLogin(1121);
    }
  });
  switchRequest.addEventListener("click", function () {
    toggleSwitch();
  });
  btnTabRadio.addEventListener("click", function (event) {
    openTabRadio(event, "tabRadio");
    //imgBannerTop.style.height = "100px";
  });
  btnTabPet.addEventListener("click", function (event) {
    openTabRadio(event, "tabPetitions");
    //imgBannerTop.style.height = "100px";
  });
  btnTabChat.addEventListener("click", function (event) {
    if (currentUserId != null) {
      openTabRadio(event, "tabChat");
    } else {
      initUserLogin(1139);
    }
  });
  goLiveModal.querySelector(".close").addEventListener("click", function () {
    closeModal("goLiveModal");
  });
  addMessageModal
    .querySelector(".close")
    .addEventListener("click", function () {
      closeModal("addMessageModal");
    });
  chatUserModal.querySelector(".close").addEventListener("click", function () {
    closeModal("chatUserModal");
  });
  requestAdModal.querySelector(".close").addEventListener("click", function () {
    closeModal("requestAdModal");
  });
  requestAdModal
    .querySelector(".btnBlue")
    .addEventListener("click", function () {
      btnWatchAd.click();
    });
  requestAdModal
    .querySelector(".redBtn")
    .addEventListener("click", function () {
      closeModal("requestAdModal");
    });
  loaderModal.querySelector(".close").addEventListener("click", function () {
    closeModal("loaderModal");
  });
  updatingLoaderModal
    .querySelector(".close")
    .addEventListener("click", function () {
      closeModal("updatingLoaderModal");
    });
  confirmModal.querySelector(".close").addEventListener("click", function () {
    closeModal("confirmModal");
  });
  editRadioModal.querySelector(".close").addEventListener("click", function () {
    closeModal("editRadioModal");
    editAudio.load();
  });
  radioInfoModal.querySelector(".close").addEventListener("click", function () {
    closeModal("radioInfoModal");
  });
  permissionModal
    .querySelector(".close")
    .addEventListener("click", function () {
      closeModal("permissionModal");
    });
  permissionModal
    .querySelector(".btnBlue")
    .addEventListener("click", function () {
      closeModal("permissionModal");
    });
  imgUpload.addEventListener("click", function () {
    getImage("register");
  });

  inRadioSearch.addEventListener(
    "keyup",
    function (event) {
      if (event.keyCode === 13) {
        //cancel the deafult button if needed
        event.preventDefault();
        btnSearchRad.click();
      }
    },
    false
  );

  inRadioSearch.addEventListener("input", function () {
    if (inRadioSearch.value.trim() == "") {
      setDisplay(divNoResults, "none");
      divSearchResults.textContent = "";
    }
  });
  inChatSearch.addEventListener("keyup", function (event) {
    if (event.keyCode === 13) {
      //cancel the deafult button if needed
      event.preventDefault();
      btnSearchChat.click();
    }
  });

  inChatSearch.addEventListener("input", function () {
    searchChats();
  });

  btnSearchChat.addEventListener("click", function () {
    if (inChatSearch.value.trim().length > 0) {
      searchChats();
    }
  });
  inFSearch.addEventListener("input", function () {
    divFSearchResults.textContent = "";
    if (inFSearch.value.trim() == "") {
      setDisplay(divNoFResults, "none");
      divFSearchResults.textContent = "";
    } else {
      for (let index = 0; index < friends.children.length; index++) {
        const element = friends.children[index];
        if (
          element
            .querySelector(".name")
            .textContent.toLowerCase()
            .startsWith(inFSearch.value.trim().toLowerCase())
        ) {
          var userInf =
            chatUserArray[
              chatUserKeyArray.indexOf(element.id.replace("friend", ""))
            ];
          if (
            !document.getElementById(
              element.id.replace("friend", "") + "search"
            )
          ) {
            displayFriend(element.id.replace("friend", ""), userInf, "search");
          }
        }
      }
    }
  });

  inFSearch.addEventListener("keyup", function (event) {
    if (event.keyCode === 13) {
      //cancel the default button if needed
      event.preventDefault();
      btnSearchF.click();
    }
  });

  btnSearchF.addEventListener("click", function () {
    if (inFSearch.value.trim().length > 0) {
      findFriends(inFSearch.value.trim());
    }
  });

  btnSearchRad.addEventListener("click", function () {
    if (inRadioSearch.value.trim().length > 0) {
      var searchLoad = radios.querySelector(".searchLoad");
      setDisplay(searchLoad, "block");
      var search = inRadioSearch.value.trim();
      var lSearch = search.toLowerCase();

      switch (group) {
        case GroupType.radio:
          searchRadios(lSearch, searchLoad);
          break;
        case GroupType.podcast:
          searchPods(lSearch, searchLoad);
          break;
        default:
          break;
      }
    }
  });

  btnNewRequest.addEventListener("click", function () {
    if (currentUserId) {
      if (requestConfig.allow) {
        if (vCoins > 0) {
          setDisplay(petitionBox, "block");
          setDisplay(btnNewRequest, "none");
        } else {
          if (requestConfig.ads) {
            //if(adError)
            //reset vcoins, ads = false ... line 454 ChatRadioFragment
            setDisplay(requestAdModal, "flex");
          } else if (new Date().getTime() >= unlockTime) {
            vCoins = requestConfig.max;
            setDisplay(petitionBox, "block");
            setDisplay(btnNewRequest, "none");
            setDisplay(divWaitTime, "none");
            if (vCoins > 1) {
              divReqLeft.textContent = trans.requestsLeftPl.replace(
                "num",
                vCoins
              );
            } else {
              divReqLeft.textContent = trans.requestsLeft.replace(
                "num",
                vCoins
              );
            }
          } else {
            showToast(
              trans.waitTime.replace(
                "$time",
                formatMessageDate(new Date(unlockTime))
              )
            );
          }
        }
      } else {
        showToast(trans.requestsDenied);
      }
    } else {
      //show login box
      initUserLogin(1338);
    }
  });

  btnWatchAd.addEventListener("click", function () {
    vCoins++;
    vCoinRef.set(vCoins);
    if (vCoins > 1) {
      divReqLeft.textContent = trans.requestsLeftPl.replace("num", vCoins);
    } else {
      divReqLeft.textContent = trans.requestsLeft.replace("num", vCoins);
    }
    if (vCoins >= requestConfig.max) {
      setDisplay(btnWatchAd, "none");
      setDisplay(divAdNote, "none");
      setDisplay(divAdParent, "none");
    }
    showToast(trans.adReward);
  });

  imgMore.addEventListener("click", function () {
    divMore.classList.toggle("show");
  });
  divRadioInfo.addEventListener("click", function () {
    initRadioInfoModal();
    setDisplay(radioInfoModal, "flex");
  });
  imgSettings.addEventListener("click", function () {
    if (isCreator) {
      initEditModal(true);
      setDisplay(radioInfoModal, "none");
      setDisplay(editRadioModal, "flex");
    }
  });

  divUpdateBanner.addEventListener("click", function () {
    inBannerUpload.click();
  });

  upLogo.addEventListener("click", function () {
    inLogoUpload.click();
  });

  inBannerUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      imgBanner.src = URL.createObjectURL(this.files[0]); // set src to blob url
    }
  });

  inLogoUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      imgLogo.src = URL.createObjectURL(this.files[0]); // set src to blob url
    }
  });

  editRadioModal
    .querySelector(".btn-blue")
    .addEventListener("click", function () {
      if (isCreator) {
        submitRadioChanges();
      }
    });

  divEditInfo.addEventListener("click", function () {
    if (isCreator) {
      initEditModal(true);
      setDisplay(editRadioModal, "flex");
    }
  });
  let dGetRadioWidget = document.getElementById("dGetRadioWidget");
  dGetRadioWidget.addEventListener(
    "click",
    function () {
      if (hasPermission) {
        getRadioWidget();
      }
    },
    false
  );
  inRadioStream.addEventListener("input", function () {
    editAudio.innerHTML = "";
    var radioUrl = inRadioStream.value.trim();
    var source = document.createElement("source"); //document.getElementById('radioStream');
    source.src = radioUrl;
    editAudio.appendChild(source);
    var backupSource = document.createElement("source");
    var backUpUrl;
    if (radioUrl.endsWith("/")) {
      backUpUrl = radioUrl + ";";
    } else if (radioUrl.endsWith("/;")) {
      //backupSource.src = radioStream;
      backUpUrl = radioUrl;
    } else {
      //backupSource.src = radioStream + "/;";
      backUpUrl = inRadioStream.value.trim() + "/;";
    }

    backupSource.src = backUpUrl;
    editAudio.appendChild(backupSource);
    editAudio.load();
    var note = editRadioModal.querySelector(".notes.redText");
    note.style.display = radioUrl.includes("https://") ? "none" : "block";
    aRadioLink.href = radioUrl;
  });

  panAbout.addEventListener("click", function () {
    openInNewTab("about.html");
  });
  panProfile.addEventListener("click", function () {
    setDisplay(userEditModal, "flex");
    closeNav();
  });

  $(".rightScr")
    .mousedown(function () {
      int00 = setInterval(function () {
        scrollWin(100, 0, ytVideos);
      }, 50);
    })
    .mouseup(function () {
      clearInterval(int00);
    });
  $(".leftScr")
    .mousedown(function () {
      int00 = setInterval(function () {
        scrollWin(-100, 0, ytVideos);
      }, 50);
    })
    .mouseup(function () {
      clearInterval(int00);
    });

  $(divPodImg).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    imgHolder.src = divPodImg.src;
    setDisplay(largeImageView, "flex");
    magnify("imgHolder", 3);
  });
  $(imgBannerTop).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    imgHolder.src = imgBannerTop.src;
    setDisplay(largeImageView, "flex");
    magnify("imgHolder", 2);
  });
  notificationModal
    .querySelector(".close")
    .addEventListener("click", function () {
      closeModal("notificationModal");
    });
  notificationModal
    .querySelector(".btn-later")
    .addEventListener("click", function () {
      closeModal("notificationModal");
    });
  notificationModal
    .querySelector(".btnBlue")
    .addEventListener("click", function () {
      closeModal("notificationModal");
      requestNotificationPermission(cTopic);
    });
  btnToggleNotification.addEventListener("click", function () {
    if (notificationAllowed) {
      if (subOn) {
        //remove sub notification
        initNotificationSub(cTopic, notificationKey);
      } else {
        initNotificationSub(cTopic);
      }
    } else {
      showNotificationModal();
    }
  });

  initLiveVideoModal();
  initYtSearchModal();
  initRadioEventListeners();
}
function getRadioWidget() {
  let radioWidgetModal = document.getElementById("radioWidgetModal");
  let btnCopy = document.getElementById("btnCopyWidget");
  let btnClose = radioWidgetModal.querySelector(".tClose");
  let inWidget = document.getElementById("inWidget");
  var link = window.location.href;
  inWidget.textContent = `<iframe src="${link}" style="border:0px #ffffff none;" name="chatm-radioWidget" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" height="400px" width="600px" allowfullscreen></iframe>`;
  $(btnClose).unbind();
  $(btnCopy).unbind();
  $(btnClose).click(function (e) {
    e.stopPropagation();
    setDisplay(radioWidgetModal, "none");
  });
  $(btnCopy).click(function (e) {
    e.stopPropagation();
    copyInput(inWidget);
    showToast(trans.copied);
    setDisplay(radioWidgetModal, "none");
  });
  setDisplay(radioWidgetModal, "flex");
}
function initRadioEventListeners() {
  showClass = {
    host: null,
    start: null,
    end: null,
    mStart: null,
    mEnd: null,
    name: null,
    uid: null,
    icon: null,
    day: "",
    enDate: null,
    stDate: null,
    tz: null,
  };

  curDaySeg = new Date().getDay();
  showSeg(
    divAddSkd.querySelector(".segments"),
    divAddSkd.querySelector(".steps"),
    -1,
    curSkdSeg,
    "flex"
  );
  btnViewUserSkd.addEventListener("click", function () {
    if (hasPermission) {
      setDisplay(bSettings, "flex");
      setDisplay(radioTabs, "none");
      setDisplay(tabPetitions, "none");
      getUserSkd();
    }
  });
  btnManageSkd.addEventListener("click", function () {
    //display
    setDisplay(divAdminSkd, "flex");
    setDisplay(radioTabs, "none");
    setDisplay(tabPetitions, "none");
    getGroupSkd();
  });
  btnSettingsBack.addEventListener("click", function () {
    setDisplay(bSettings, "none");
    setDisplay(radioTabs, "flex");
    setDisplay(tabPetitions, "flex");
  });
  divAdminSkd
    .querySelector("button.btn-back")
    .addEventListener("click", function () {
      setDisplay(divAdminSkd, "none");
      setDisplay(radioTabs, "flex");
      setDisplay(tabPetitions, "flex");
    });
  btnSkdBack.addEventListener("click", function () {
    setDisplay(bSchedule, "none");
    setDisplay(radioTabs, "flex");
    setDisplay(tabRadio, "flex");
  });

  btnAddSkd.addEventListener("click", function () {
    divAddSkd.querySelector(".pTitle").textContent = trans.addNewSkd;
    setDisplay(bSettings, "none");
    setDisplay(divAddSkd, "flex");
  });

  btnAddSkdBack.addEventListener("click", function () {
    setDisplay(bSettings, "flex");
    setDisplay(divAddSkd, "none");
    resetAddSkd(false);
  });

  btnSkdCont.addEventListener("click", function () {
    if (validateSeg()) {
      showSeg(
        divAddSkd.querySelector(".segments"),
        divAddSkd.querySelector(".steps"),
        curSkdSeg,
        ++curSkdSeg,
        "flex"
      );
    }
  });

  btnSkdPre.addEventListener("click", function () {
    showSeg(
      divAddSkd.querySelector(".segments"),
      divAddSkd.querySelector(".steps"),
      curSkdSeg,
      --curSkdSeg,
      "flex"
    );
  });

  btnSkdSubmit.addEventListener("click", function () {
    submitSkd();
  });

  aUploadIcon.addEventListener("click", function () {
    getImage("skd");
  });

  inSkdIcon.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      imgSkdIcon.src = URL.createObjectURL(this.files[0]);
      divSkdVerify.querySelector("img").src = URL.createObjectURL(
        this.files[0]
      );
    }
  });

  addSkdModal.querySelector(".close").addEventListener("click", function () {
    setDisplay(addSkdModal, "none");
  });

  btnFullSkd.addEventListener("click", function () {
    setDisplay(bSchedule, "flex");
    setDisplay(radioTabs, "none");
    setDisplay(tabRadio, "none");
  });
  var x = 0;
  var lstDays = ulDays.querySelectorAll("li");
  for (let index = 0; index < lstDays.length; index++) {
    x = index == 6 ? 0 : index + 1;
    initDayClick(x, lstDays[index]);
    //console.log("day: " + x);
  }
  prepareSegs();
  btnRemoveLive.addEventListener("click", function () {
    removeLiveError();
  });
  $("#chatRulesModal input[name=linkP]").click(function () {
    setAllowLink(parseInt(this.value));
  });
}
function removeLiveError() {
  var liveVideoRef = firebase
    .database()
    .ref(`Radio Stations/${currentChatId}/liveVideo`);
  liveVideoRef.remove();
}
function getGroupSkd() {
  if (groupSkdRef) {
    return;
  }
  const skdList = divAdminSkd.querySelector(".dList");
  const skdEmpty = divAdminSkd.querySelector(".dEmpty");
  groupSkdRef = firebase.database().ref(`groupSkd/${currentChatId}`);
  groupSkdRef.on("child_added", function (data) {
    if (skdList.children.length == 0) {
      setDisplay(skdEmpty, "none");
    }
    getSkd(data.key, skdList, "admin", null, true);
  });
  groupSkdRef.on("child_removed", function (data) {
    var skdKey = data.key;
    var key = skdKey + "admin";
    var nowSkdKey = skdKey + "pv";
    deleteElement(key);
    deleteElement(nowSkdKey);
    if (skdList.children.length == 0) {
      setDisplay(skdEmpty, "flex");
    }
  });
}
function setAllowLink(selected) {
  if (allowLinkRef != null) {
    allowLinkRef.set(selected, function (error) {
      if (!error) {
        showToast(trans.updated_successfully);
      }
    });
  }
}
function initDayClick(day, elDay) {
  elDay.addEventListener("click", function () {
    initRadioSkd(day);
  });
}
function getUserSkd() {
  if (userSkdRef) {
    return;
  }

  userSkdRef = firebase
    .database()
    .ref(`userSkd/${currentUserId}/${currentChatId}`);
  userSkdRef.on("child_added", function (data) {
    if (skdList.children.length == 0) {
      setDisplay(skdEmpty, "none");
    }
    getSkd(data.key, skdList, null, null, false);
  });
  userSkdRef.on("child_removed", function (data) {
    deleteElement(data.key);
    if (skdList.children.length == 0) {
      setDisplay(skdEmpty, "flex");
    }
  });
}

function getSkd(key, parent, ext, nDay, isGroupSkd) {
  var skdRef = firebase.database().ref(`skd/${key}`);
  skdRef.once("value", function (data) {
    if (data.exists()) {
      showSkd(data.key, data.val(), parent, ext, isGroupSkd);
      if (!isGroupSkd && nDay != null && nDay == curDay) {
        addTodaySkd(data.key, data.val());
      }
    }
  });
}

var USER_SKD_TEMP =
  '<div class="light-blue-shadow-btm-round horizFlex centerItems v-item">' +
  '<img class="skd-icon" src="' +
  phImage +
  '" alt="Broadcast icon" width="60px" height="60px">' +
  '<div class="verticalFlex mainTop">' +
  '<p class="boldText mar-unset name" translate="no"></p>' +
  '<p class="mar-unset hours"></p>' +
  '<p class="mar-unset days"></p>' +
  "</div>" +
  '<button class="edit opas" title="" style="display: none;"><i class="fas fa-edit"></i></button>' +
  '<button class="delete opas" title="" style="display: none;"><i class="fas fa-trash-alt"></i></button>' +
  "</div>";
function showSkd(key, data, parent, ext, isGroupSkd) {
  const container = document.createElement("div");
  container.innerHTML = USER_SKD_TEMP;
  const div = container.firstChild;
  var oldDiv;
  if (ext) {
    oldDiv = document.getElementById(key + ext);
    div.setAttribute("id", key + ext);
  } else {
    oldDiv = document.getElementById(key);
    div.setAttribute("id", key);
  }

  var imgIcon = div.querySelector("img");
  $(imgIcon).on("error", function () {
    imgIcon.src = phImage;
  });

  imgIcon.src = data.icon ? data.icon : phImage;
  if (!ext || isGroupSkd) {
    var btnDelete = div.querySelector(".delete");
    var btnEdit = div.querySelector(".edit");
    setDisplay(btnDelete, "block");
    setDisplay(btnEdit, "block");
    btnDelete.title = trans.delete;
    $(btnDelete).click(function (e) {
      e.stopPropagation();
      //confirm delete
      confirmSkdDelete(key, data);
    });
    if (isGroupSkd) {
      setDisplay(btnEdit, "none");
    } else {
      setDisplay(btnEdit, "block");
      $(btnEdit).click(function (e) {
        e.stopPropagation();
        //confirm delete
        editSkd(key, data, isGroupSkd);
      });
    }
  }
  $(div).click(function (e) {
    e.stopPropagation();
    //check if from user (show options)
  });

  div.querySelector(".name").textContent = data.name;
  var start = data.stDate ? formatTime(new Date(data.stDate)) : data.start;
  var end = data.enDate ? formatTime(new Date(data.enDate)) : data.end;
  div.querySelector(".hours").textContent = start + " - " + end;
  div.querySelector(".days").textContent = formatDays(data.day);
  if (oldDiv) {
    $(oldDiv).off("click");
    parent.replaceChild(div, oldDiv);
  } else {
    parent.appendChild(div);
  }
}
function editSkd(key, data, isGroupSkd) {
  resetAddSkd(false);
  copyShowClass = data;
  copyShowKey = key;
  divAddSkd.querySelector(".pTitle").textContent = trans.editSkd;
  var segments = divAddSkd.querySelectorAll(".seg");
  //seg 1
  var inStartHour = segments[0].querySelector('input[name="hour"]');
  var inStartMinute = segments[0].querySelector('input[name="minute"]');
  var selStartAmPm = segments[0].querySelector("select");
  var tStart = data.start;
  inStartHour.value = tStart.substring(0, tStart.indexOf(":"));
  inStartMinute.value = tStart.substring(
    tStart.indexOf(":") + 1,
    tStart.length - 3
  );
  selStartAmPm.selectedIndex = data.start.includes("AM") ? "0" : "1";

  //seg 2
  var inEndHour = segments[1].querySelector('input[name="hour"]');
  var inEndMinute = segments[1].querySelector('input[name="minute"]');
  var selEndAmPm = segments[1].querySelector("select");
  var tEnd = data.end;
  inEndHour.value = tEnd.substring(0, tEnd.indexOf(":"));
  inEndMinute.value = tEnd.substring(tEnd.indexOf(":") + 1, tEnd.length - 3);
  selEndAmPm.selectedIndex = tEnd.includes("AM") ? "0" : "1";

  //seg 3
  var days = data.day;
  for (let index = 0; index < days.length; index++) {
    const chk = segments[2].querySelector(`input[value="${days[index]}"]`);
    chk.checked = true;
  }

  //seg 4
  var inBcastName = segments[3].querySelector("#inBcastName");
  inBcastName.value = data.name;

  //seg 5
  var imgIcon = segments[4].querySelector("#imgSkdIcon");
  imgIcon.src = data.icon ? data.icon : phImage;

  setDisplay(isGroupSkd ? divAdminSkd : bSettings, "none");
  setDisplay(divAddSkd, "flex");
}
function confirmSkdDelete(key, data) {
  confirmModal.querySelector(".message").textContent = trans.delSkd;
  var btnYes = confirmModal.querySelector(".btnBlue");
  var btnNo = confirmModal.querySelector(".btnRed");
  $(btnYes).unbind();
  $(btnYes).click(function (e) {
    e.stopPropagation();
    setDisplay(confirmModal, "none");
    deleteSkd(key, data, false);
  });

  $(btnNo).unbind();
  $(btnNo).click(function (e) {
    e.stopPropagation();
    setDisplay(confirmModal, "none");
  });

  setDisplay(confirmModal, "flex");
}

function deleteSkd(key, data, isEditing) {
  if (!isEditing) {
    uploadProgressModal.querySelector(".text").textContent = trans.removing;
    setDisplay(uploadProgressModal, "flex");
  }

  var userSkdRef = firebase
    .database()
    .ref(`userSkd/${data.uid}/${currentChatId}/${key}`);
  var groupSkdRef = firebase.database().ref(`groupSkd/${currentChatId}/${key}`);
  groupSkdRef.remove(function (error) {
    userSkdRef.remove(function (error) {
      if (error) {
        showToast(trans.errorMess);
      } else {
        //delete from radio skd
        var radSkdRef = firebase.database().ref(`radioSkd/${currentChatId}`);
        var days = data.day;
        var wait = days.length;
        for (let i = 0; i < days.length; i++) {
          const day = days[i];
          radSkdRef.child(`${day}/${key}`).remove(function (error) {
            if (error) {
              showToast(trans.errorMess);
              setDisplay(uploadProgressModal, "none");
              wait--;
            } else {
              wait--;
              if (wait == 0) {
                //Delete show reference
                var skdRef = firebase.database().ref(`skd/${key}`);
                skdRef.remove(function (error) {
                  if (error) {
                    showToast(trans.errorMess);
                  } else {
                    const storageRef = firebase.storage().ref();
                    var skdIconRef = storageRef.child(`skd/${key}/icon`);
                    skdIconRef
                      .delete()
                      .then(() => {
                        showToast(
                          isEditing ? trans.skdUpdated : trans.skdRemoved
                        );
                      })
                      .catch((error) => {
                        // Uh-oh, an error occurred!
                        showToast(
                          isEditing ? trans.skdUpdated : trans.skdRemoved
                        );
                      });
                  }
                  setDisplay(uploadProgressModal, "none");
                });
              }
            }
          });
        }
      }
    });
  });
}
function submitSkd() {
  setDisplay(uploadProgressModal, "flex");
  showClass.host = userInfo.name;
  showClass.uid = currentUserId;
  var skdRef = firebase.database().ref(`skd`);
  var showId = skdRef.push().key;
  //get showId
  //Upload icon
  if (inSkdIcon.files && inSkdIcon.files[0]) {
    uploadSkdIcon(inSkdIcon.files[0], showId);
  } else {
    //Upload skd
    uploadSkd(showId);
  }
}
function uploadSkdIcon(file, showId) {
  uploadProgressModal.querySelector(".text").textContent = trans.upIcon;
  var storageRef = firebase.storage().ref("skd/" + showId + "/icon");
  var uploadTask = storageRef.put(file);
  uploadTask.on(
    "state_changed",
    function () {},
    function (error) {
      var errorMess;
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          errorMess = trans.errorImage;
          break;
        case "storage/canceled":
          errorMess = trans.errorUploadCancel;
          break;
        case "storage/unknown":
          // Unknown error occur, inspect error.serverResponse
          errorMess = trans.errorUnknown;
          break;
      }
      setDisplay(uploadProgressModal, "none");
      if (errorMess) {
        showToast(errorMess);
      }
    },
    function () {
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        showClass.icon = downloadURL;
        uploadSkd(showId);
      });
    }
  );
}

function uploadSkd(showId) {
  uploadProgressModal.querySelector(".text").textContent = trans.upSkdInfo;
  var skdRef = firebase.database().ref(`skd/${showId}`);
  skdRef.set(showClass, function (error) {
    if (!error) {
      uploadUserSkd(showId);
    } else {
      setDisplay(uploadProgressModal, "none");
    }
  });
}
function uploadUserSkd(showId) {
  var userSkdRef = firebase
    .database()
    .ref(`userSkd/${currentUserId}/${currentChatId}/${showId}`);
  userSkdRef.set(showClass.mStart, function (error) {
    if (!error) {
      uploadGroupSkd(showId);
    } else {
      setDisplay(uploadProgressModal, "none");
    }
  });
}
function uploadGroupSkd(showId) {
  var groupSkdRef = firebase
    .database()
    .ref(`groupSkd/${currentChatId}/${showId}`);
  groupSkdRef.set(showClass.stDate, function (error) {
    if (!error) {
      uploadRadioSkd(showId);
    } else {
      setDisplay(uploadProgressModal, "none");
    }
  });
}
function uploadRadioSkd(showId) {
  var radioSkdRef = firebase.database().ref(`radioSkd/${currentChatId}`);
  var days = showClass.day;
  var wait = days.length;
  for (let x = 0; x < days.length; x++) {
    const day = days[x];
    radioSkdRef
      .child(`${day}/${showId}`)
      .set(showClass.mStart, function (error) {
        if (!error) {
          wait--;
          if (wait == 0) {
            //skd added successfully

            if (copyShowKey) {
              deleteSkd(copyShowKey, copyShowClass, true);
            } else {
              setDisplay(uploadProgressModal, "none");

              setDisplay(addSkdModal, "flex");
              setTimeout(function () {
                $(addSkdModal).fadeOut(3000);
              }, 3000);
            }
            resetAddSkd(true);
          }
        } else {
          showToast(trans.errorMess);
          setDisplay(uploadProgressModal, "none");
          wait--;
        }
      });
  }
}

function resetAddSkd(showSettings) {
  resetShowClass();
  copyShowClass = null;
  copyShowKey = null;
  $("#divSkdVerify img").attr("src", "");
  $("#divSkdVerify .verticalFlex p").text("");
  $("#divAddSkd .errNote").text("");
  $("#divAddSkd .errNote").css("display", "none");
  $('#divAddSkd input[type="checkbox"]').prop("checked", false);
  $('#divAddSkd input[type="text"]').val("");
  $('#divAddSkd input[type="number"]').val("");
  inSkdIcon.value = "";
  imgSkdIcon.src = phImage;
  divSkdVerify.querySelector("img").src = phImage;
  var oldSeg = curSkdSeg;
  curSkdSeg = 0;
  showSeg(
    divAddSkd.querySelector(".segments"),
    divAddSkd.querySelector(".steps"),
    oldSeg,
    curSkdSeg,
    "flex"
  );
  resetSteps(divAddSkd);
  setDisplay(divAddSkd, "none");
  if (showSettings) {
    setDisplay(bSettings, "flex");
  }
}

function resetSteps(parent) {
  var dots = parent.querySelectorAll(".step");
  dots.forEach((dot) => {
    dot.className = "step";
  });
  dots[0].className += " active";
}

function resetShowClass() {
  showClass = {
    host: null,
    start: null,
    end: null,
    mStart: null,
    mEnd: null,
    name: null,
    uid: null,
    icon: null,
    day: "",
    enDate: null,
    stDate: null,
    tz: null,
  };
}
function prepareSegs() {
  var segments = divAddSkd.querySelectorAll(".seg");
  var inStartHour = segments[0].querySelector('input[name="hour"]');
  var inStartMinute = segments[0].querySelector('input[name="minute"]');
  var selStartAmPm = segments[0].querySelector("select");
  var inEndHour = segments[1].querySelector('input[name="hour"]');
  var inEndMinute = segments[1].querySelector('input[name="minute"]');
  var selEndAmPm = segments[1].querySelector("select");

  $(inStartHour).on("input", function () {
    setHour(inStartHour, inStartMinute, selStartAmPm, inStartHour.value);
  });

  $(inStartMinute).on("input", function () {
    setMinute(inStartMinute, selStartAmPm, inStartMinute.value);
  });

  $(inEndHour).on("input", function () {
    setHour(inEndHour, inEndMinute, selEndAmPm, inEndHour.value);
  });

  $(inEndMinute).on("input", function () {
    setMinute(inEndMinute, selEndAmPm, inEndMinute.value);
  });
}

function setHour(inHour, inMinute, selAmPm, hr) {
  if (hr.length == 1 && hr == 0 && !typeZero) {
    typeZero = true;
  } else if (hr != 0 && hr.length == 1) {
    typeZero = false;
    inHour.value = "0" + hr;
  }
  if (hr >= 10 && hr <= 24) {
    typeZero = false;
    if (hr.length > 2) {
      hr = hr.substr(1);
    }
    if (hr > 12) {
      var nHr = hr - 12;
      inHour.value = nHr > 9 ? nHr : "0" + nHr;

      if (hr < 24) {
        selAmPm.selectedIndex = "1";
      } else {
        selAmPm.selectedIndex = "0";
      }
    } else {
      inHour.value = hr;
    }

    inMinute.focus();
  } else if (hr > 24) {
    typeZero = false;
    var lastNum = hr.slice(-1);
    inHour.value = hr.replace(lastNum, "");

    inMinute.focus();
    inMinute.value = "0" + lastNum;
    //Show time error
  } else if (typeZero && hr.length == 2) {
    if (hr == 0) {
      typeZero = false;
      inHour.value = "12";
      selAmPm.selectedIndex = "0";

      inMinute.focus();
    } else if (hr > 0) {
      typeZero = false;
      inMinute.focus();
    }
  }
}

function setMinute(inMinute, selAmPm, min) {
  if (min.length == 1 && min == 0 && !typeZero) {
    typeZero = true;
  } else if (min != 0 && min.length == 1) {
    typeZero = false;
    inMinute.value = "0" + min;
  }

  if (min >= 60 || (min.length > 2 && min == 0)) {
    typeZero = false;
    inMinute.value = "00";
    //inMinute.value = min.substr(1);
    selAmPm.focus();
  } else if (min >= 10) {
    typeZero = false;
    if (min.length > 2) {
      min = min.substr(1);
      inMinute.value = min;
    } else {
      selAmPm.focus();
    }
  } else if (typeZero && min.length == 2) {
    typeZero = false;
    selAmPm.focus();
  } else if (min.length > 2) {
    min = min.substr(1);
    inMinute.value = min;
    selAmPm.focus();
  }
}

function validateSeg() {
  var valid = true;

  switch (curSkdSeg) {
    case 0:
    case 1:
      valid = verifyTimeSeg();
      break;
    case 2:
      valid = verifyDaysSeg();
      break;
    case 3:
      valid = verifyBcastName();
      break;
    case 4:
      valid = verifyBcastIcon();
      break;
  }
  if (valid) {
    var dots = divAddSkd.querySelector(".steps").getElementsByClassName("step");
    dots[curSkdSeg].className += " finish";
  }
  return valid;
}

function verifyTimeSeg() {
  var valid = true;
  var segments = divAddSkd.querySelectorAll(".seg");
  var errorNote = segments[curSkdSeg].querySelector(".errNote");
  var inStartHour = segments[curSkdSeg].querySelector('input[name="hour"]');
  var inStartMinute = segments[curSkdSeg].querySelector('input[name="minute"]');
  var selStartAmPm = segments[curSkdSeg].querySelector("select");
  var hrs = inStartHour.value.trim();
  var mins = inStartMinute.value.trim();

  if (hrs == "") {
    valid = false;
    errorNote.textContent = trans.errorHr;
    setDisplay(errorNote, "block");
    $(inStartHour).shake();
  } else if (mins == "") {
    valid = false;
    errorNote.textContent = trans.errorMin;
    setDisplay(errorNote, "block");
    $(inStartMinute).shake();
  } else {
    var hr = parseInt(hrs);
    var mH;
    if (mins == "0") {
      mins = "00";
    }
    if (hrs == "0") {
      hrs = "12";
    }
    if (curSkdSeg == 0) {
      if (selStartAmPm.value == "am") {
        mH = hr == 12 ? "00" : hrs;
      } else {
        mH = hr < 12 ? hr + 12 : hrs;
      }
      showClass.start =
        hrs + ":" + mins + " " + selStartAmPm.value.toUpperCase();
      showClass.mStart =
        mH + ":" + mins + " " + selStartAmPm.value.toUpperCase();
      var startTime = new Date();
      startTime.setHours(mH, mins);
      showClass.stDate = startTime.getTime();
    } else {
      if (selStartAmPm.value == "am") {
        mH = hr == 12 ? hr + 12 : hrs;
      } else {
        mH = hr < 12 ? hr + 12 : hrs;
      }
      showClass.end = hrs + ":" + mins + " " + selStartAmPm.value.toUpperCase();
      showClass.mEnd = mH + ":" + mins + " " + selStartAmPm.value.toUpperCase();
      var endTime = new Date();
      endTime.setHours(mH, mins);
      showClass.enDate = endTime.getTime();
    }
    showClass.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    errorNote.textContent = "";
    setDisplay(errorNote, "none");
  }
  return valid;
}

function verifyDaysSeg() {
  showClass.day = "";
  var valid = false;
  var segments = divAddSkd.querySelectorAll(".seg");
  var errorNote = segments[curSkdSeg].querySelector(".errNote");
  var days = divAddSkd.querySelectorAll('.seg p[role="checkbox"] input');
  days.forEach((elChk) => {
    if (elChk.checked) {
      valid = true;
      showClass.day += elChk.value;
    }
  });
  if (!valid) {
    errorNote.textContent = trans.errorDays;
    setDisplay(errorNote, "block");
    $(errorNote).shake();
  } else {
    setDisplay(errorNote, "none");
  }
  return valid;
}

function verifyBcastName() {
  var valid = true;
  var segments = divAddSkd.querySelectorAll(".seg");
  var errorNote = segments[curSkdSeg].querySelector(".errNote");

  var name = inBcastName.value.trim();
  if (name == "") {
    valid = false;
    errorNote.textContent = trans.errorDays;
    setDisplay(errorNote, "block");
    $(inBcastName).shake();
  } else {
    errorNote.textContent = "";
    setDisplay(errorNote, "none");
    showClass.name = name;
  }
  return valid;
}

function verifyBcastIcon() {
  var valid = false;
  var segments = divAddSkd.querySelectorAll(".seg");
  var errorNote = segments[curSkdSeg].querySelector(".errNote");
  if (inSkdIcon.files && inSkdIcon.files[0]) {
    valid = true;
    errorNote.textContent = "";
    setDisplay(errorNote, "none");
  } else if (copyShowKey && copyShowClass.icon) {
    valid = true;
    showClass.icon = copyShowClass.icon;
    errorNote.textContent = "";
    setDisplay(errorNote, "none");
  } else if (userInfo.profileImage) {
    valid = true;
    showClass.icon = userInfo.profileImage;
    errorNote.textContent = "";
    setDisplay(errorNote, "none");
  } else {
    errorNote.textContent = trans.errorBcastIcon;
    setDisplay(errorNote, "block");
    $(imgSkdIcon).shake();
  }

  //Setup verify segment
  if (valid) {
    divSkdVerify.querySelector("p.name").textContent = showClass.name;
    var hours = showClass.start + " - " + showClass.end;
    divSkdVerify.querySelector("p.hours").textContent = hours;
    divSkdVerify.querySelector("p.days").textContent = formatDays(
      showClass.day
    );
    if (showClass.icon) {
      divSkdVerify.querySelector("img").src = showClass.icon;
    }
  } else {
    divSkdVerify.querySelector("img").src = phImage;
    divSkdVerify.querySelector("p.name").textContent = "";
    divSkdVerify.querySelector("p.hours").textContent = "";
    divSkdVerify.querySelector("p.days").textContent = "";
  }
  return valid;
}

function formatDays(days) {
  var nDays = "";
  for (let i = 0; i < days.length; i++) {
    const day = days[i];
    switch (day) {
      case "m":
        nDays += trans.mon + ", ";
        break;
      case "t":
        nDays += trans.tue + ", ";
        break;
      case "w":
        nDays += trans.wed + ", ";
        break;
      case "r":
        nDays += trans.thu + ", ";
        break;
      case "f":
        nDays += trans.fri + ", ";
        break;
      case "s":
        nDays += trans.sat + ", ";
        break;
      case "u":
        nDays += trans.sun + ", ";
        break;
    }
  }

  return nDays.trim().slice(0, -1);
}

function showSeg(segParent, stepParent, oldPos, pos, display) {
  var segs = segParent.getElementsByClassName("seg");
  if (oldPos != -1) {
    segs[oldPos].style.display = "none";
  }
  if (display == "flex") {
    $(segs[pos]).fadeIn("slow");
  } else {
    segs[pos].style.display = display;
  }

  //Hide/show back button
  if (pos == 0) {
    setDisplay(btnSkdPre, "none");
    divSkdBtns.className = divSkdBtns.className.replace(
      "space-btw",
      "space-end"
    );
  } else {
    setDisplay(btnSkdPre, "block");
    divSkdBtns.className = divSkdBtns.className.replace(
      "space-end",
      "space-btw"
    );
  }

  //set submit visibility
  if (pos == segs.length - 1) {
    setDisplay(btnSkdCont, "none");
    setDisplay(btnSkdSubmit, "block");
  } else {
    setDisplay(btnSkdCont, "block");
    setDisplay(btnSkdSubmit, "none");
  }

  showStep(stepParent, pos, oldPos);
}

function showStep(element, pos, oldPos) {
  var dots = element.getElementsByClassName("step");
  if (oldPos != -1) {
    dots[oldPos].className = dots[oldPos].className.replace(" active", "");
  } else {
    dots[0].className = dots[0].className.replace(" active", "");
  }
  dots[pos].className += " active";
}

function scrollWin(x, y, element) {
  //window.scrollBy(x, y);
  element.scrollLeft += x;
  element.scrollLeft += y;
}
function initYtSearchModal() {
  divYtSearch.querySelector(".close").addEventListener("click", function () {
    closeModal("divYtSearch");
  });

  // inSearch.addEventListener('click', function () {
  //     checkInput(inSearch.value.trim());
  // });

  inSearch.addEventListener("keyup", function (event) {
    if (13 === event.keyCode && !event.shiftKey) {
      //"Enter" key on keyboard
      //cancel the deafult button if needed
      event.preventDefault();
      checkInput(inSearch.value.trim());
    }
  });
  imgSearchYt.addEventListener("click", function () {
    checkInput(inSearch.value.trim());
  });
}

function checkInput(input) {
  setDisplay(ytLoading, "flex");
  if (input == "") {
    setDisplay(ytLoading, "none");
    $(inSearch).shake();
    return;
  }

  if (input.startsWith("http")) {
    var videoId = getYoutubeId(input);
    if (videoId != null) {
      sendWatchVideo(videoId, null);
    } else {
      setDisplay(ytLoading, "none");
      $(inSearch).shake();
      showToast(trans.error_yt_link);
    }
  } else {
    searchYoutube(input);
  }
}

function searchYoutube(input) {
  divFound.innerHTML = "";
  execute(input);
}

function execute(input) {
  var key = "AIzaSyBAWC4jyQAA-kiS4T105Z4Snpt8rjP2vYM";
  var maxResults = 30;
  $.get(
    "https://www.googleapis.com/youtube/v3/search?key=" +
      key +
      "&part=snippet&maxResults=" +
      maxResults +
      "&q=" +
      input,
    function (data) {
      var list = data.items;
      if (list) {
        for (var i = 0; i < list.length; i++) {
          var youtube = {
            videoId: list[i].id.videoId,
            thumb: list[i].snippet.thumbnails.default.url,
            title: list[i].snippet.title,
            channel: list[i].snippet.channelTitle,
            desc: list[i].snippet.description,
            name: userInfo.name,
            uid: currentUserId,
            date: 0,
          };
          addYtVideo(youtube.videoId, youtube, true, "divFound");
        }
        setDisplay(ytLoading, "none");
        showToast(trans.error_not_found.replace("$input", input));
      } else {
        setDisplay(ytLoading, "none");
        showToast(trans.error_not_found.replace("$input", input));
      }
    }
  );
}

function sendWatchVideo(videoId, youtube) {
  if (youtube == null) {
    youtube = {
      videoId: videoId.toString(),
      name: userInfo.name,
      uid: currentUserId,
      date: 0,
    };
  }
  if (chkEveryone.checked) {
    if (!isDjLive) {
      youtube.date = new Date().getTime();
    } else if (radioHost && radioHost.hostId == currentUserId) {
      youtube.date = new Date().getTime();
    }
  }
  watchRef.child(videoId.toString()).set(youtube, function (error) {
    if (!error) {
      showToast(trans.watch_invite_sent);
    }
    setDisplay(ytLoading, "none");
    closeModal("divYtSearch");
    inSearch.value = "";
  });
}
function getYoutubeId(url) {
  var regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
  var match = url.match(regExp);
  if (match && match[2].length == 11) {
    return match[2];
  } else {
    return null;
  }
}

function initLiveVideoModal() {
  let btnReqPermission = reqVideoModal.querySelector(".redBtn");
  let btnStartVideo = liveVideoModal.querySelector(".redBtn");
  let reqMessage = reqVideoModal.querySelector(".message");
  let btnELVmodal = endLiveModal.querySelector(".redBtn");
  let btnLVHEnd = liveVideoContainerHeader.querySelector(".close");
  let divELVMess = endLiveModal.querySelector(".liveMessage");
  reqVideoModal.querySelector(".close").addEventListener("click", function () {
    closeModal("reqVideoModal");
  });
  endLiveModal.querySelector(".close").addEventListener("click", function () {
    closeModal("endLiveModal");
  });

  btnLVHEnd.addEventListener("click", function () {
    if (isMainHost || isCohost) {
      divELVMess.textContent = trans.endVideo;
    } else {
      divELVMess.textContent = trans.exitVideo;
    }
    setDisplay(endLiveModal, "flex");
  });

  btnELVmodal.addEventListener("click", function () {
    closeModal("endLiveModal");
    if (isMainHost || isCohost) {
      endStream();
    } else {
      leaveChannel();
      setDisplay(liveVideoContainer, "none");
    }
  });

  liveVideoModal.querySelector(".close").addEventListener("click", function () {
    closeModal("liveVideoModal");
  });

  btnStartVideo.addEventListener("click", function () {
    closeModal("liveVideoModal");
    setDisplay(liveVideoModal, "none");
    //set whether should screen record or not\
    joinChannel(true, radCamera.checked);
  });
  btnReqPermission.addEventListener("click", function () {
    if (userInfo != null) {
      setDisplay(reqVideoModal, "none");
      requestPermission();
    }
  });

  btnCancelReq.addEventListener("click", function () {
    if (userReqVideoRef) {
      userReqVideoRef.remove(function (error) {
        if (error) {
          showToast(trans.errorMess);
          //userReqVideoRef.off();
        }
      });
    }
  });
  btnLiveVideo.addEventListener("click", function () {
    if (isDjLive || isVideoLive) {
      //Check if DJ has allowed others to cohost
      if (
        (streamInfo != null && streamInfo.cohost) ||
        (reqInfo && reqInfo.allow)
      ) {
        setDisplay(liveVideoModal, "flex");
      } else {
        var xName = hostName ? hostName : streamInfo ? streamInfo.name : "";
        reqMessage.textContent = trans.streamPermission.replace("$name", xName);
        setDisplay(reqVideoModal, "flex");
      }
    } else {
      setDisplay(liveVideoModal, "flex");
    }
  });

  btnStopStream.addEventListener("click", function () {
    endStream();
  });

  //dragElement(document.getElementById("liveVideoContainer"));
  dragElement(document.getElementById("requestDiv"));
}

function requestPermission() {
  if (!userReqVideoRef) {
    userReqVideoRef = firebase
      .database()
      .ref(`Radio Stations/${currentChatId}/reqVideo/${currentUserId}`);
  }

  var user = {
    name: userInfo.name,
    profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
    date: new Date().getTime(),
    allow: false,
  };

  userReqVideoRef.set(user, function (error) {
    if (!error) {
      showToast(trans.pReqSent);
      setDisplay(btnCancelReq, "block");
    } else {
      showToast(trans.errorMess);
    }
  });
}

function openInNewTab(url) {
  var win = window.open(url, "_blank");
  win.focus();
}
function initRadioInfoModal() {
  if (radioInfo) {
    radioInfoModal.querySelector(".white-text").textContent =
      radioInfo.radio_Name;
    radioDescription.textContent = radioInfo.radio_Description;
    radioLocation.innerHTML = trans.locationSpan + radioInfo.radio_location;
    if (radioInfo.website) {
      if (!radioInfo.website.includes("//")) {
        radioWeb.href = "//" + radioInfo.website;
      } else {
        radioWeb.href = radioInfo.website;
      }

      radioWeb.textContent = radioInfo.website;
    } else {
      radioInfo.href = window.location.href;
      radioWeb.textContent = window.location.href;
    }
  }
}
function initEditModal(isVerified) {
  if (radioInfo) {
    radioVerified = isVerified;
    inLogoUpload.value = "";
    inBannerUpload.value = "";
    var radioError = editRadioModal.querySelector(".notes.redText");
    setDisplay(radioError, "none");
    imgBanner.src = radioInfo.banner ? radioInfo.banner : phBannerImg;
    setDisplay(imgBanner, "block");
    imgLogo.src = radioInfo.radio_image ? radioInfo.radio_image : phRadioImg;
    setDisplay(imgLogo, "block");
    inAdminName.value = radioInfo.admin_Name ? radioInfo.admin_Name : "";
    inRadioName.value = radioInfo.radio_Name;
    inSlogan.value = radioInfo.radio_Slogan ? radioInfo.radio_Slogan : "";
    inDescription.value = radioInfo.radio_Description
      ? radioInfo.radio_Description
      : "";
    if (radioInfo.radio_location) {
      countries.selectedIndex = "1";
      countries.options[1].textContent = radioInfo.radio_location;
    } else {
      countries.selectedIndex = "0";
    }
    inPhone.value = radioInfo.phone_no ? radioInfo.phone_no : "";
    inRadioEmail.value = radioInfo.radio_email ? radioInfo.radio_email : "";
    if (radioInfo.website) {
      if (!radioInfo.website.includes("http")) {
        inWebsite.value = "http://" + radioInfo.website;
      } else {
        inWebsite.value = radioInfo.website;
      }
    } else {
      inWebsite.value = "";
    }
    //inWebsite.value = radioInfo.website? radioInfo.website:'';
    inWMessage.value = radioInfo.welcome ? radioInfo.welcome : "";
    editAudio.innerHTML = "";
    if (radioInfo.radio_Stream) {
      // if (currentChatId.includes("-LzcAYbo1_r3PIJzlzOU")) {
      //   var ecoBackup = document.createElement("source");
      //   ecoBackup.src = "https://sslstream.online:7030/stream/";
      //   editAudio.appendChild(ecoBackup);
      //   inRadioStream.value = "https://sslstream.online:7030/stream/";
      // } else {
      //   inRadioStream.value = radioInfo.radio_Stream;
      // }
      inRadioStream.value = radioInfo.radio_Stream;
      if (!inRadioStream.value.includes("https")) {
        setDisplay(radioError, "block");
        aRadioLink.href = inRadioStream.value.trim();
      }
      var source = document.createElement("source"); //document.getElementById('radioStream');
      source.src = radioInfo.radio_Stream;
      editAudio.appendChild(source);
      var backupSource = document.createElement("source");
      var backUpUrl;
      if (radioInfo.radio_Stream.endsWith("/")) {
        backUpUrl = radioInfo.radio_Stream + ";";
      } else if (radioInfo.radio_Stream.endsWith("/;")) {
        //backupSource.src = radioStream;
        backUpUrl = radioInfo.radio_Stream;
      } else {
        //backupSource.src = radioStream + "/;";
        backUpUrl = radioInfo.radio_Stream + "/;";
      }

      backupSource.src = backUpUrl;
      editAudio.appendChild(backupSource);
      editAudio.load();
    } else {
      inRadioStream.value = "";
    }
    //srcAudio.src = radioInfo.radio_Stream? radioInfo.radio_Stream: '';
  }
}
function submitRadioChanges() {
  setDisplay(updatingLoaderModal, "flex");
  setDisplay(editRadioModal, "none");
  var changes = 0;
  var radioId = currentChatId;
  var radioRef;
  if (radioVerified) {
    radioRef = firebase.database().ref("Radio Stations/" + radioId + "/info");
  } else {
    radioRef = firebase.database().ref("verify/radio/" + radioId + "/info");
  }

  if (inBannerUpload.value) {
    changes++;

    var storageRef = firebase
      .storage()
      .ref("Radio Stations/" + radioId + "/Banner");
    var uploadTask = storageRef.put(inBannerUpload.files[0]);
    uploadTask.on(
      "state_changed",
      function () {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      },
      function (error) {
        var errorMess;
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            errorMess = trans.errorImage;
            break;
          case "storage/canceled":
            errorMess = trans.errorUploadCancel;
            break;
          case "storage/unknown":
            // Unknown error occur, inspect error.serverResponse
            errorMess = trans.errorUnknown;
            break;
        }
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }

        showToast(errorMess);
      },
      function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          //console.log('File available at', downloadURL);
          radioRef.child("banner").set(downloadURL, function (error) {
            if (error) {
              showToast(trans.errorMess);
            }
            changes--;
            if (changes == 0) {
              setDisplay(updatingLoaderModal, "none");
              showToast(trans.changesMade);
            }
          });
        });
      }
    );
  }
  if (inLogoUpload.value) {
    changes++;

    var storageRef = firebase
      .storage()
      .ref("Radio Stations/" + radioId + "/Logo");
    var uploadTask = storageRef.put(inLogoUpload.files[0]);
    uploadTask.on(
      "state_changed",
      function () {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      },
      function (error) {
        var errorMess;
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            errorMess = trans.errorImage;
            break;
          case "storage/canceled":
            errorMess = trans.errorUploadCancel;
            break;
          case "storage/unknown":
            // Unknown error occur, inspect error.serverResponse
            errorMess = trans.errorUnknown;
            break;
        }
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }

        showToast(errorMess);
      },
      function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          //console.log('File available at', downloadURL);
          radioRef.child("radio_image").set(downloadURL, function (error) {
            if (error) {
              showToast(trans.errorMess);
            }
            changes--;
            if (changes == 0) {
              setDisplay(updatingLoaderModal, "none");
              showToast(trans.changesMade);
            }
          });
        });
      }
    );
  }
  if (
    inAdminName.value.trim().length > 0 &&
    inAdminName.value.trim() != radioInfo.admin_Name
  ) {
    changes++;
    radioRef
      .child("admin_Name")
      .set(inAdminName.value.trim(), function (error) {
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }
        if (!error) {
          showToast(trans.changesMade);
        }
      });
  }
  if (
    inRadioName.value.trim().length > 0 &&
    inRadioName.value.trim() != radioInfo.radio_Name
  ) {
    changes++;
    radioRef
      .child("radio_Name")
      .set(inRadioName.value.trim(), function (error) {
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }
        if (!error) {
          showToast(trans.changesMade);
        }
      });
  }
  if (
    inSlogan.value.trim().length > 0 &&
    inSlogan.value.trim() != radioInfo.radio_Slogan
  ) {
    changes++;
    radioRef.child("radio_Slogan").set(inSlogan.value.trim(), function (error) {
      changes--;
      if (changes == 0) {
        setDisplay(updatingLoaderModal, "none");
      }
      if (!error) {
        showToast(trans.changesMade);
      }
    });
  }
  if (
    inDescription.value.trim().length > 0 &&
    inDescription.value.trim() != radioInfo.radio_Description
  ) {
    changes++;
    radioRef
      .child("radio_Description")
      .set(inDescription.value.trim(), function (error) {
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }
        if (!error) {
          showToast(trans.changesMade);
        }
      });
  }
  if (countries.selectedIndex != 1 && countries.selectedIndex != 0) {
    changes++;
    radioRef
      .child("radio_location")
      .set(
        countries.options[countries.selectedIndex].textContent,
        function (error) {
          changes--;
          if (changes == 0) {
            setDisplay(updatingLoaderModal, "none");
          }
          if (!error) {
            showToast(trans.changesMade);
          }
        }
      );
  }
  if (
    inPhone.value.trim().length > 0 &&
    inPhone.value.trim() != radioInfo.phone_no
  ) {
    changes++;
    radioRef.child("phone_no").set(inPhone.value.trim(), function (error) {
      changes--;
      if (changes == 0) {
        setDisplay(updatingLoaderModal, "none");
      }
      if (!error) {
        showToast(trans.changesMade);
      }
    });
  }
  if (
    inRadioEmail.value.trim().length > 0 &&
    inRadioEmail.value.trim() != radioInfo.radio_email
  ) {
    changes++;
    radioRef
      .child("radio_email")
      .set(inRadioEmail.value.trim(), function (error) {
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }
        if (!error) {
          showToast(trans.changesMade);
        }
      });
  }
  if (
    inWebsite.value.trim().length > 0 &&
    inWebsite.value.trim() != radioInfo.website
  ) {
    changes++;
    radioRef.child("website").set(inWebsite.value.trim(), function (error) {
      changes--;
      if (changes == 0) {
        setDisplay(updatingLoaderModal, "none");
      }
      if (!error) {
        showToast(trans.changesMade);
      }
    });
  }
  if (
    inWMessage.value.trim().length > 0 &&
    inWMessage.value.trim() != radioInfo.welcome
  ) {
    changes++;
    radioRef.child("welcome").set(inWMessage.value.trim(), function (error) {
      changes--;
      if (changes == 0) {
        setDisplay(updatingLoaderModal, "none");
      }
      if (!error) {
        showToast(trans.changesMade);
      }
    });
  }
  var radioURL;
  // if (radioId.includes("-LzcAYbo1_r3PIJzlzOU")) {
  //   radioURL = "https://sslstream.online:7030/stream/";
  // } else {
  //   radioURL = radioInfo.radio_Stream;
  // }
  radioURL = radioInfo.radio_Stream;
  if (
    inRadioStream.value.trim().length > 0 &&
    inRadioStream.value.trim() != radioInfo.radio_Stream &&
    inRadioStream.value.trim() != radioURL
  ) {
    changes++;
    radioRef
      .child("radio_Stream")
      .set(inRadioStream.value.trim(), function (error) {
        changes--;
        if (changes == 0) {
          setDisplay(updatingLoaderModal, "none");
        }
        if (!error) {
          showToast(trans.changesMade);
        }
      });
  }
  if (changes == 0) {
    setDisplay(updatingLoaderModal, "none");
    showToast(trans.noChanges);
  }
}

function searchChats() {
  var load = chats.querySelector(".searchLoad");
  setDisplay(divNoChatResults, "none");
  setDisplay(load, "block");
  divChatSearchResults.textContent = "";
  if (inChatSearch.value.trim() == "") {
    setDisplay(divNoChatResults, "none");
    divChatSearchResults.textContent = "";
  } else {
    for (let index = 0; index < recentChats.children.length; index++) {
      const element = recentChats.children[index];
      if (
        element
          .querySelector(".name")
          .textContent.toLowerCase()
          .startsWith(inChatSearch.value.trim().toLowerCase())
      ) {
        var bookmark = chatsArray[chatsKeyArray.indexOf(element.id)];
        if (!document.getElementById(element.id + "csearch")) {
          addBookmark(element.id, bookmark, "csearch");
        }
      }
    }
    if (divChatSearchResults.children.length == 0) {
      setDisplay(divNoChatResults, "block");
      divNoChatResults.textContent = trans.radioNotFound.replace(
        "$name",
        inChatSearch.value.trim()
      );
    }
  }
  setDisplay(load, "none");
}

function warning() {
  if (currentUserId) {
    // if (onlineRef) {
    //   stopOnlineTimer();
    // }
    if (onlineSent) {
      webRef.child("online").set(false);
    }
    if (isVideoLive && isMainHost) {
      liveVideoRef.remove();
      cohostVideoRef.remove();
    }
    if (userReqVideoRef) {
      userReqVideoRef.remove();
    }
    if (reqVideoRef) {
      reqVideoRef.remove();
    }
    return false;
  }
}

function findFriends(search) {
  if (lastSearch == search) {
    return;
  }
  divFSearchResults.textContent = "";
  var searchLoad = friendsList.querySelector(".searchLoad");
  setDisplay(searchLoad, "block");
  var lSearch = search.toLowerCase();
  var searchQuery = firebase
    .database()
    .ref("Users")
    .orderByChild("info/lowCaseName")
    .startAt(lSearch)
    .endAt(lSearch + "\uf8ff");
  searchQuery.once("value", function (data) {
    if (data.exists()) {
      setDisplay(searchLoad, "none");
      lastSearch = search;
      setDisplay(divNoFResults, "none");
      data.forEach(function (user) {
        var infoUser = user.val().info;
        if (!chatUserKeyArray.includes(user.key)) {
          var friendInfo = {
            email: infoUser.email,
            name: infoUser.name,
            lowCaseName: infoUser.lowCaseName,
            profile_Image: infoUser.profile_Image
              ? infoUser.profile_Image
              : null,
            message: null,
            date_created: null,
          };

          chatUserKeyArray.push(user.key);
          chatUserArray.push(friendInfo);
        }
        if (document.getElementById(user.key + "search")) {
          divFSearchResults.textContent = "";
          displayFriend(user.key, user.val().info, "search");
        } else {
          displayFriend(user.key, user.val().info, "search");
        }
      });
    } else {
      setDisplay(searchLoad, "none");
      divNoFResults.textContent = trans.radioNotFound.replace("$name", search);
      setDisplay(divNoFResults, "block");
      divFSearchResults.textContent = "";
    }
  });
}

function showConfirmModal(id, name, friendInfo) {
  var btnYes = confirmModal.querySelector(".btnBlue");
  var btnNo = confirmModal.querySelector(".redBtn");
  var message = confirmModal.querySelector(".message");
  message.textContent = trans.confirmRemove.replace("$name", name);

  $(btnYes).unbind();
  $(btnYes).click(function (e) {
    e.stopPropagation();
    removeFriend(id, name, friendInfo);
    setDisplay(confirmModal, "none");
  });

  $(btnNo).unbind();
  $(btnYes).click(function (e) {
    e.stopPropagation();
    setDisplay(confirmModal, "none");
  });
  setDisplay(confirmModal, "flex");
}

function noTimeout() {
  if (onlineSent) {
    webRef.child("online").set(false);
  }
  if (onlineRef) {
    stopOnlineTimer();
  }
  //clearTimeout(timeout);
}
function getCurrentUserId() {
  authListener = firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      cUser = user;
      var url = window.location.href;
      if (url.indexOf("chat/") > -1) {
        // if (url.includes("?group=")) {
        //   currentChatId = url.substring(url.lastIndexOf("=") + 1);
        //   initGroupChat()
        //   //window.location.search
        // }else
        if (url.includes("$v=") || url.includes("ur=")) {
          currentChatId = url.substring(url.lastIndexOf("=") + 1);
          initUvRadioSearch(false);
        } else if (url.includes("pod/") || url.includes("p=")) {
          startPodSearch(url, false);
        } else {
          var radioName;
          if (url.includes("%")) {
            var newUrl = decodeURIComponent(url);
            radioName = newUrl.substring(newUrl.lastIndexOf("/") + 1);
          } else {
            radioName = url.substring(url.lastIndexOf("/") + 1);
          }
          if (radioName.includes("r=")) {
            radioName = radioName.replace("r=", "");
          }
          radioName = radioName.replace(/--/g, "_");
          radioName = radioName.replace(/-/g, " ");
          radioName = radioName.replace(/_/g, "-");
          startRadioSearch(radioName, false);
        }
      } else {
        initWelActivity(false, false);
      }
      currentUserId = firebase.auth().currentUser.uid;
      if (firebase.auth().currentUser.email) {
        email = firebase.auth().currentUser.email;
        isEmail = true;
      } else {
        email = firebase.auth().currentUser.phoneNumber;
        isEmail = false;
      }
      //console.log("email: " + email);
      userInfo = {
        userId: currentUserId,
        email: email,
        profileImage: null,
        name: null,
      };
      reqDefaultConfig = {
        max: 2,
        ads: true,
        time: 30,
        allow: true,
      };
      requestConfig = reqDefaultConfig;
      requestmessage = getCookie("requestMessage") == "";
      resetButtons(true);
      getProfileInfo();
      loadBookmarks();
      loadRadios();
      loadFriends();
      loadReceivedRequests();
      loadSentRequests();
      requestNotificationPermission();
    } else {
      resetButtons(false);
      initNewUserContent();
      var url = window.location.href;
      if (url.indexOf("chat/") > -1) {
        //was here
        if (url.includes("$v=") || url.includes("ur=")) {
          currentChatId = url.substring(url.lastIndexOf("=") + 1);
          initUvRadioSearch(true);
        } else if (url.includes("pod/") || url.includes("p=")) {
          startPodSearch(url, true);
        } else {
          var radioName;
          if (url.includes("%")) {
            var newUrl = decodeURIComponent(url);
            radioName = newUrl.substring(newUrl.lastIndexOf("/") + 1);
          } else {
            radioName = url.substring(url.lastIndexOf("/") + 1);
          }
          if (radioName.includes("r=")) {
            radioName = radioName.replace("r=", "");
          }
          radioName = radioName.replace(/--/g, "_");
          radioName = radioName.replace(/-/g, " ");
          radioName = radioName.replace(/_/g, "-");
          startRadioSearch(radioName, true);
        }

        document.getElementById("navBox").style.display = "none";
      } else {
        //show welcome screen
        initWelActivity(true, false);
        //window.location.replace("../login.html");
      }
    }
  });
}

function requestNotificationPermission(topic) {
  Notification.requestPermission()
    .then((permission) => {
      notificationAllowed = permission === "granted";
      if (notificationAllowed) {
        if (startMsgLs) {
          startMsgLs = false;
          startServiceWorker();
          initMessageLs();
        }

        if (topic) {
          initNotificationSub(topic);
        }
      }
    })
    .catch((e) => {
      Promise.resolve(Notification.requestPermission()).then(function (
        permission
      ) {
        // Do something
      });
    });
}
function startServiceWorker() {
  if (navigator.serviceWorker) {
    // Register the SW
    navigator.serviceWorker
      .register(new URL("../firebase-messaging-sw.js", import.meta.url), {
        scope: "/",
        updateViaCache: "none",
      })
      .then(function (registration) {
        //setDisplay(btnToggleNotification, "block");
        registration.update();
        // .then((result) => {
        //   setDisplay(btnToggleNotification, "block");
        // });
        // registration.addEventListener("updatefound", () => {
        //   setDisplay(btnToggleNotification, "none");
        //   console.log("====================================");
        //   console.log(`service update found`);
        //   console.log("====================================");
        //   registration.update().then(() => {
        //     setDisplay(btnToggleNotification, "block");
        //   });
        // });

        // registration.unregister().then((boolean) => {
        //   // if boolean = true, unregister is successful
        //   console.log("====================================");
        //   console.log(`unregistered: `, boolean);
        //   console.log("====================================");
        // });
      })
      .catch((e) => {
        console.log("could not register service", e);
      });

    // navigator.serviceWorker
    //   .getRegistration("../firebase-messaging-sw.js")
    //   .then((registration) => {
    //     if (registration) {
    //       console.log("====================================");
    //       console.log(`registration found`);
    //       console.log("====================================");
    //     } else {
    //       console.log("====================================");
    //       console.log(`registration not found`);
    //       console.log("====================================");
    //     }
    //   });

    // navigator.serviceWorker.getRegistrations().then(function (registrations) {
    //   console.log("====================================");
    //   console.log(`registrations found: ${registrations.length}`);
    //   console.log("====================================");
    //   for (let registration of registrations) {
    //     registration.unregister();
    //   }
    // });
  }
}
function initMessageLs() {
  messaging = getMessaging(defAppRef);
  onMessage(messaging, (payload) => {
    console.log("====================================");
    console.log("Message received", payload);
    console.log("====================================");
  });
}
function initNotificationSub(topic, key) {
  getToken(messaging, { vapidKey: vapidKey })
    .then((currentToken) => {
      if (currentToken) {
        saveToken(currentToken);
        if (topic) {
          let dbSubTopic = firebase.database().ref(`subTopic`);
          if (key) {
            dbSubTopic.child(key).remove(function (error) {
              showToast(
                error ? trans.notificationOffError : trans.notificationOff
              );
            });
          } else {
            let sub = {
              token: currentToken,
              topic: topic,
              uid: userInfo.userId,
              date: new Date().getTime(),
              web: true,
            };

            dbSubTopic.push().set(sub, function (error) {
              showToast(
                error ? trans.notificationOnError : trans.notificationOn
              );
            });
          }
        }
      } else {
        showNotificationModal();
        //https://firebase.google.com/docs/cloud-messaging/js/topic-messaging#node.js

        //https://firebase.google.com/docs/cloud-messaging/js/receive
      }
    })
    .catch((err) => {
      //could not get token error
      console.log("====================================");
      console.log("error: notification: ", err);
      console.log("====================================");
      showToast(trans.errorSubToken);
    });
}
function saveToken(token) {
  let dbUserToken = firebase
    .database()
    .ref(`userToken/${userInfo.userId}/${token}`);
  dbUserToken.set(true, function (error) {
    if (!error) {
    }
  });
}
function getTopRadios() {
  //load top 10 radios
  let topRadios = document.getElementById("topRadios");
  tabRadio.querySelector(".reqs").style.display = "flex";

  var radiosRef = firebase
    .database()
    .ref("Radio Stations")
    .orderByChild("info/numLikes")
    .limitToLast(10);
  radiosRef.on("child_added", function (data) {
    var radio = data.val().info;

    if (radio.radio_Name) {
      const key = data.key;
      var radioRef = firebase
        .database()
        .ref("Radio Stations/" + key + "/info")
        .orderByChild("info/numLikes")
        .limitToLast(10);
      setDisplay(topRadios, "block");
      addRadio(key, radio, "divTopRadios", true);
      radioRef.on("child_changed", function (data) {
        var radio = data.val(); //.info;
        if (radio.radio_Name) {
          addRadio(key, radio, "divTopRadios", true);
        }
      });

      radioRef.on("child_removed", function () {
        deleteElement(key + "top");
        removeBkm(key, true);
      });
    }
  });
}
function initWelActivity(login, showNotFound) {
  let divWelcome = document.getElementById("divWelcome");
  let notFound = document.getElementById("notFound");
  let insWel = document.getElementById("instructWelcome");
  let dWelLogin = document.getElementById("dWelLogin");
  let btnLogin = dWelLogin.querySelector("button");

  setDisplay(notFound, showNotFound ? "flex" : "none");
  notFound.querySelector("p").textContent = trans.groupNotFound;
  divWelcome.style.display = "flex";
  divWelcome.querySelector(".boldText").textContent = trans.greeting;

  if (login) {
    //show login instruction
    insWel.querySelector("span").textContent = trans.welNewUser;
    setDisplay(dWelLogin, "flex");
    $(btnLogin).off("click");
    $(btnLogin).click(function () {
      initUserLogin(3332);
    });
  } else {
    setDisplay(dWelLogin, "none");
  }
}
function startPodSearch(url, isLogin) {
  var podName = getCleanUrl(url);
  var isUrlId = podName.includes("id=");
  var child = isUrlId ? "url" : "title";
  var searchTerm = isUrlId
    ? podName //.substring(podName.lastIndexOf("id=") + 3)
    : podName
        .replace("p=", "")
        .replace(/--/g, "_")
        .replace(/-/g, " ")
        .replace(/_/g, "-");
  var podRef = firebase.database().ref("podcast");
  podRef
    .orderByChild(child)
    .equalTo(searchTerm)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        snapshot.forEach(function (childSnapshot) {
          var podcast = childSnapshot.val();
          var podId = "pod=" + childSnapshot.key;
          if (podcast.title) {
            displayChat(podId, podcast, "podChat", true);
          } else {
            currentChatId = podId;
            removeBkm(podId, false);
          }

          return true; //search only once
          // ...
        });
      } else {
        //console.log("radio does not exist");
        document.getElementById("divWelcome").style.display = "flex";
        document.getElementById("normalChat").style.display = "none";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("inputArea").style.display = "none";
        notFound.querySelector("p").textContent = trans.groupNotFound;
        setDisplay(notFound, "flex");
        initWelActivity(isLogin, true);
      }
    });
}

function getCleanUrl(url) {
  if (url.includes("%")) {
    url = decodeURIComponent(url);
  }
  return url.substring(url.lastIndexOf("/") + 1);
}
function resetButtons(reset) {
  let imgFavorite = document.getElementById("imgFavorite");
  let divFavorite = document.getElementById("divFavorite");
  let messageNone = document.getElementById("messageNone");
  if (reset) {
    $(imgFavorite).off("click");
    $(divFavorite).off("click");
    $(messageNone).off("click");
  } else {
    $(imgFavorite).click(function () {
      initUserLogin(3397);
    });
    $(divFavorite).click(function () {
      initUserLogin(3400);
    });
    $(messageNone).click(function () {
      initUserLogin(3403);
    });
  }
}

function initUserLogin(line) {
  console.log("====================================");
  console.log("called from: " + line);
  console.log("====================================");
  var registerModal = document.getElementById("registerUser");
  let btnEmailLogin = document.getElementById("btnEmailLogin");
  let btnPhoneLogin = document.getElementById("btnPhoneLogin");
  let btnNext = document.getElementById("btnNext");
  let btnLoginNew = document.getElementById("btnLoginNew");
  let optionParent = registerModal.querySelector(".optionParent");
  let emailOptions = document.getElementById("emailOptions");
  let phoneOptions = document.getElementById("phoneOptions");
  let btnCancelLogin = document.getElementById("btnCancelLogin");
  let btnCancelPhone = document.getElementById("btnCancelPhone");
  let dActionBtns = document.getElementById("dActionBtns");
  let etEmail = document.getElementById("etEmail");
  let etPassword = document.getElementById("etPassword");
  let cbParent = document.getElementById("cbParent");
  let cbRemember = document.getElementById("cbRememberMe");
  let btnClose = registerModal.querySelector(".close");
  let loading = document.getElementById("loading");
  let passInputParent = registerModal.querySelector(".passParent");
  let passOptions = registerModal.querySelector(".passOptions");
  setDisplay(registerModal, "flex");

  $(btnClose).off("click");
  $(btnEmailLogin).off("click");
  $(btnCancelLogin).off("click");
  $(btnPhoneLogin).off("click");
  $(btnNext).off("click");
  $(btnLoginNew).off("click");
  $(etEmail).off("keyup");
  $(etPassword).off("keyup");
  $(btnCancelPhone).off("click");

  btnClose.addEventListener("click", function () {
    clearLogin();
    setDisplay(registerModal, "none");
  });
  btnEmailLogin.addEventListener(
    "click",
    function () {
      setDisplay(emailOptions, "block");
      setDisplay(phoneOptions, "none");
      setDisplay(optionParent, "none");
      etEmail.focus();
    },
    false
  );
  btnCancelLogin.addEventListener(
    "click",
    function () {
      clearLogin();
    },
    false
  );

  btnCancelPhone.addEventListener(
    "click",
    function () {
      clearLogin();
    },
    false
  );

  btnPhoneLogin.addEventListener(
    "click",
    function () {
      initPhoneOption();
      setDisplay(emailOptions, "none");
      setDisplay(phoneOptions, "block");
    },
    false
  );

  btnNext.addEventListener(
    "click",
    function () {
      if (etEmail.value && etEmail.value.includes("@")) {
        etEmail.disabled = true;
        setDisplay(loading, "block");
        setDisplay(btnNext, "none");
        setDisplay(passInputParent, "flex");
        setDisplay(btnLoginNew, "block");
        checkEmail(etEmail.value);
      } else {
        showToast(trans.errorEmail);
        setDisplay(loading, "none");
      }
    },
    false
  );

  btnLoginNew.addEventListener(
    "click",
    function () {
      if (!etPassword.value) {
        showToast(trans.errorPass);
        return;
      }
      if (newUser) {
        createUserEmailPass(etEmail.value, etPassword.value);
      } else {
        loginUserEmailPass(etEmail.value, etPassword.value);
      }
    },
    false
  );

  etEmail.addEventListener("keyup", function (event) {
    if ("Enter" === event.key) {
      event.preventDefault();
      if (etEmail.disabled) {
        btnLoginNew.click();
      } else {
        btnNext.click();
      }
    }
  });
  etPassword.addEventListener("keyup", function (event) {
    if ("Enter" === event.key) {
      event.preventDefault();
      btnLoginNew.click();
    }
  });
}
function clearLogin() {
  var registerModal = document.getElementById("registerUser");
  let etEmail = document.getElementById("etEmail");
  let etPassword = document.getElementById("etPassword");
  let cbRemember = document.getElementById("cbRememberMe");
  let optionParent = registerModal.querySelector(".optionParent");
  let emailOptions = document.getElementById("emailOptions");
  let phoneOptions = document.getElementById("phoneOptions");
  let passInputParent = registerModal.querySelector(".passParent");
  let passOptions = registerModal.querySelector(".passOptions");
  let divPassInfo = document.getElementById("divPassInfo");
  let btnLoginNew = document.getElementById("btnLoginNew");
  let btnNext = document.getElementById("btnNext");
  let loading = document.getElementById("loading");

  etEmail.disabled = false;
  etEmail.value = "";
  etPassword.value = "";
  cbRemember.checked = false;
  setDisplay(divPassInfo, "none");
  setDisplay(btnNext, "block");
  setDisplay(btnLoginNew, "none");
  setDisplay(phoneOptions, "none");
  setDisplay(emailOptions, "none");
  setDisplay(passOptions, "none");
  setDisplay(passInputParent, "none");
  setDisplay(optionParent, "flex");
  setDisplay(loading, "none");
}
function loginUserEmailPass(email, pass) {
  let loading = document.getElementById("loading");
  setDisplay(loading, "block");
  firebase
    .auth()
    .signInWithEmailAndPassword(email, pass)
    .then(function () {
      //var petitionBox = document.getElementById('petitionBox');
      //setDisplay(petitionBox,"block");
      var newUserBox = document.getElementById("newUserBox");
      setDisplay(newUserBox, "none");
      noRequests.textContent = trans.noSongRequests;
      messageNone.textContent = trans.noMessages;
      currentUserId = firebase.auth().currentUser.uid;
      email = firebase.auth().currentUser.email;
      setDisplay(registerUser, "none");
      setDisplay(loading, "none");
    })
    .catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      showToast(errorCode + ": " + errorMessage);
      setDisplay(loading, "none");
    });
}

function createUserEmailPass(email, pass) {
  setDisplay(loading, "block");
  firebase
    .auth()
    .createUserWithEmailAndPassword(email, pass)
    .then(function (user) {
      if (user) {
        //var petitionBox = document.getElementById('petitionBox');
        //setDisplay(petitionBox,"block");
        var newUserBox = document.getElementById("newUserBox");
        setDisplay(newUserBox, "none");
        noRequests.textContent = trans.noSongRequests;
        messageNone.textContent = trans.noMessages;
        currentUserId = firebase.auth().currentUser.uid;
        email = firebase.auth().currentUser.email;
        setDisplay(registerUser, "none");
        setDisplay(loading, "none");
        //getProfileInfo();
      } else {
        showToast(trans.errorRegister);
        setDisplay(loading, "none");
      }
    })
    .catch(function (error) {
      // Handle Errors here.
      var errorMessage = error.message;
      showToast(errorMessage);
      setDisplay(loading, "none");
    });
}

function checkEmail(email) {
  var registerModal = document.getElementById("registerUser");
  let etPassword = document.getElementById("etPassword");
  let passInputParent = registerModal.querySelector(".passParent");
  let passOptions = registerModal.querySelector(".passOptions");
  let etEmail = document.getElementById("etEmail");
  let divPassInfo = document.getElementById("divPassInfo");
  firebase
    .auth()
    .fetchSignInMethodsForEmail(email)
    .then(function (signInMethods) {
      if (
        signInMethods.indexOf(
          firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
        ) != -1
      ) {
        divPassInfo.textContent = trans.welcomeBack;
        etPassword.placeholder = trans.password;
        newUser = false;
        // User can sign in with email/password.
      } else {
        divPassInfo.textContent = trans.createPass;
        etPassword.placeholder = trans.anyPass;
        newUser = true;
      }
      etPassword.focus();
      setDisplay(divPassInfo, "block");
      setDisplay(loading, "none");
    })
    .catch(function (error) {
      showToast(error);
      setDisplay(loading, "none");
      // Some error occur, you can inspect the code: error.code
    });
}

function initNewUserContent() {
  isNewUserContent = true;
  //var petitionBox = document.getElementById('petitionBox');
  //setDisplay(petitionBox,"none");
  let btnTabPet = document.getElementById("btnTabPet");
  let dAdParent = document.getElementById("divAdParent");
  let divWaitTime = document.getElementById("divWaitTime");
  let divDjOptions = document.getElementById("divDjOptions");
  let btnRadios = document.getElementById("btnRadios");
  btnRadios.click();
  setDisplay(dAdParent, "none");
  setDisplay(btnTabPet, "none");
  setDisplay(divWaitTime, "none");
  setDisplay(divDjOptions, "none");
  var newUserBox = document.getElementById("newUserBox");
  setDisplay(newUserBox, "none");
  noRequests.textContent = trans.petNewUser;
  messageNone.textContent = trans.chatNewUser;
  var btnNewUser = document.getElementById("btnNewUser");

  btnNewUser.addEventListener(
    "click",
    function () {
      initUserLogin(3679);
    },
    false
  );
}

function initPhoneOption() {
  if (!ui) {
    let phoneUi = document.getElementById("phoneUi");
    ui = new firebaseui.auth.AuthUI(firebase.auth());

    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function () {
          let inRemember = document.getElementById("inRemember");
          let remember = inRemember.checked;
          firebase
            .auth()
            .setPersistence(
              remember
                ? firebase.auth.Auth.Persistence.LOCAL
                : firebase.auth.Auth.Persistence.SESSION
            );
          var newUserBox = document.getElementById("newUserBox");
          setDisplay(newUserBox, "none");
          noRequests.textContent = trans.noSongRequests;
          messageNone.textContent = trans.noMessages;
          currentUserId = firebase.auth().currentUser.uid;
          email = firebase.auth().currentUser.phoneNumber;
          setDisplay(loading, "none");
          showToast("Welcome!");
          //setDisplay(registerRadio,"block");
          setDisplay(registerUser, "none");
          return false;
        },
        signInFailure: function (error) {
          // Some unrecoverable error occur during sign-in.
          // Return a promise when error handling is completed and FirebaseUI
          // will reset, clearing any UI. This commonly occurs for error code
          // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
          // occurs. Check below for more details on this.
          setDisplay(loading, "none");
          showToast(error);
          return handleUIError(error);
        },
        uiShown: function () {
          // The widget is rende.
          // Hide the loader.
          setDisplay(loading, "none");
        },
      },
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "normal", // 'invisible' or 'compact'
            badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
          },
          //loginHint: '+11234567890'
        },
      ],
      // Terms of service url.
      tosUrl: "https://chatmurcianys.com/about#terms",
      // Privacy policy url.
      privacyPolicyUrl: "https://chatmurcianys.com/about#privacy",
    };

    ui.start(phoneUi, uiConfig);
  }
}

function startRadioSearch(radioName, isLogin) {
  var radiosRef = firebase.database().ref("Radio Stations");
  radiosRef
    .orderByChild("info/radio_Name")
    .equalTo(radioName)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        snapshot.forEach(function (childSnapshot) {
          var radio = childSnapshot.val().info;
          var radioId = childSnapshot.key + "radio";
          if (radio.radio_Name) {
            displayChat(radioId, radio, "RadioChat", true);
          } else {
            currentChatId = radioId;
            removeBkm(radioId, true);
          }

          return true; //search only once
          // ...
        });
      } else {
        //console.log("radio does not exist");
        document.getElementById("divWelcome").style.display = "flex";
        document.getElementById("normalChat").style.display = "none";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("inputArea").style.display = "none";
        notFound.querySelector("p").textContent = trans.radioNotExist;
        setDisplay(notFound, "flex");
        initWelActivity(isLogin, true);
      }
    });
}

function initUvRadioSearch(isLogin) {
  var uvRadioRef = firebase
    .database()
    .ref("verify/radio/" + currentChatId + "/info");
  uvRadioRef.once("value", function (snapshot) {
    if (snapshot.exists()) {
      radioInfo = snapshot.val();
      if (currentUserId == radioInfo.admin_ID) {
        isCreator = true;
        initEditModal(false);
        setDisplay(editRadioModal, "flex");
      } else {
        document.getElementById("divWelcome").style.display = "flex";
        document.getElementById("normalChat").style.display = "none";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("inputArea").style.display = "none";
        notFound.querySelector("p").textContent = trans.radioNotExist;
        setDisplay(notFound, "flex");
        initWelActivity(isLogin, true);
      }
    } else {
      //console.log("radio does not exist");
      document.getElementById("divWelcome").style.display = "flex";
      document.getElementById("normalChat").style.display = "none";
      document.getElementById("radioChat").style.display = "none";
      document.getElementById("inputArea").style.display = "none";
      notFound.querySelector("p").textContent = trans.radioNotExist;
      setDisplay(notFound, "flex");
      initWelActivity(isLogin, true);
    }
  });
}
function getProfileInfo() {
  var userNameRef = firebase.database().ref("Users/" + currentUserId + "/info"); ///name
  //var userProfileImageRef = firebase.database().ref('Users/' + currentUserId + '/info/profile_Image');
  userNameRef.on("value", function (snapshot) {
    if (snapshot != null && snapshot.val() && snapshot.val().name) {
      userData = snapshot.val();
      userName = userData.name;
      userInfo.name = userName;
      //divWelcome.querySelector(".wName").textContent = userName;
      divWelcome.querySelector(".boldText").textContent = trans.greet.replace(
        "@name",
        userInfo ? userInfo.name : ""
      );
      document.getElementById("username").textContent = userName;
      titleHome.textContent = userName;
      if (userData.profile_Image) {
        profileImage = userData.profile_Image;
        userInfo.profileImage = profileImage;
        document.getElementById("imgProfile").src = profileImage;
        //document.getElementById('btnNavProfile').src = profileImage;//'url(' + addSizeToGoogleProfilePic(profileImage) + ')';
      }
      if (pendingRadioUser) {
        var existsRef = firebase
          .database()
          .ref("Radio Stations/" + currentChatId + "/info/radio_Name");
        existsRef.once("value", function (snapshot) {
          if (snapshot.exists()) {
            disableButton(btnSend, false);
            //console.log('button enabled');

            onlineRef = firebase
              .database()
              .ref(`on/${currentChatId}/${currentUserId}`);
            initOnline();
            startOnlineTimer();
            checkRadioLikes();
          } else {
            removeBkm(currentChatId, true);
          }
        });
        pendingRadioUser = false;
      }
      initUserModal();
      if (!webSent) {
        webSent = true;
        sendWebCs();
      }
    } else {
      //console.log("name does not exist");
      createUserProfile();
    }
  });
}

function initUserModal() {
  var divUserImg = userEditModal.querySelector(".img-thumbnail");
  var divChanges = userEditModal.querySelectorAll(".blueText.point.under");
  var divChangeEmail = divChanges[0];
  var divChangePass = divChanges[1];
  var divEmail = userEditModal.querySelector("div.grayBorder.email");
  var divContents = userEditModal.querySelectorAll(".modal-content");
  var inputs = userEditModal.querySelectorAll("input.blueBorder");
  var inCurrentPass = userEditModal.querySelector("input.redBorder");
  var spUndo = userEditModal.querySelector(".undo");
  var imgUser = userEditModal.querySelector("img");
  var notes = userEditModal.querySelector(".notes");
  var btns = userEditModal.querySelectorAll("button");
  var btnUpNameImg = btns[0];
  var btnCancel = btns[1];
  var btnSubmit = btns[2];
  var btnAuth = btns[3];
  var passChange = false;
  var nameChanged = false;
  inImage.value = "";
  imgUser.src = userData.profile_Image ? userData.profile_Image : phPersonImg;
  divChangePass.style.display = isEmail ? "block" : "none";
  btnUpNameImg.disabled = true;
  userEditModal.querySelector(".close").addEventListener("click", function () {
    closeModal("userEditModal");
    inImage.value = "";
    inputs[0].value = userData.name;
    inputs[1].value = userData.email;
    inputs[2].value = "";
    inCurrentPass.value = "";
    imgUser.src = userData.profile_Image ? userData.profile_Image : phPersonImg;
    nameChanged = false;
  });
  divEmail.textContent = userData.email;
  divChangeEmail.style.display = isEmail ? "block" : "none";
  divChangePass.style.display = isEmail ? "block" : "none";
  if (isEmail) {
    divChangePass.addEventListener("click", function () {
      //inputs[2].classList.toggle("show");
      passChange = true;
      setDisplay(divContents[0], "none");
      setDisplay(divContents[1], "flex");
      setDisplay(inputs[1], "none");
      setDisplay(inputs[2], "block");
    });

    divChangeEmail.addEventListener("click", function () {
      passChange = false;
      setDisplay(divContents[0], "none");
      setDisplay(divContents[1], "flex");
      setDisplay(inputs[1], "block");
      setDisplay(inputs[2], "none");
    });
    btnAuth.addEventListener("click", function () {
      var cPass = inCurrentPass.value.trim();
      if (cPass.length > 0) {
        var cential = firebase.auth.EmailAuthProvider.cential(email, cPass);
        cUser
          .reauthenticateWithCential(cential)
          .then(function () {
            // User re-authenticated.
            setDisplay(updatingLoaderModal, "flex");
            if (passChange) {
              var nPass = inputs[2].value.trim();
              if (nPass.length > 0) {
                changePassword(nPass, btnCancel, btnAuth, btnSubmit);
              } else {
                $(inputs[2]).shake();
                showToast(trans.noChanges);
                setDisplay(updatingLoaderModal, "none");
              }
            } else {
              var nEmail = inputs[1].value.trim();
              if (nEmail.length > 0 && nEmail != userData.email) {
                changeEmail(nEmail, btnCancel, btnAuth, btnSubmit);
              } else {
                $(inputs[1]).shake();
                showToast(trans.noChanges);
                setDisplay(updatingLoaderModal, "none");
              }
            }
          })
          .catch(function (error) {
            // An error happened.
            showToast(trans.errorMess);
          });
      } else {
        showToast(trans.errorPass);
        $(inCurrentPass).shake();
      }
    });

    btnCancel.addEventListener("click", function () {
      setDisplay(divContents[0], "flex");
      setDisplay(divContents[1], "none");
      inputs[2].value = "";
      inputs[1].value = userData.email;
      inCurrentPass.value = "";
    });

    btnSubmit.addEventListener("click", function () {
      if (passChange) {
        var nPass = inputs[2].value.trim();
        if (nPass.length > 0) {
          setDisplay(updatingLoaderModal, "flex");
          changePassword(nPass, btnCancel, btnAuth, btnSubmit);
        } else {
          $(inputs[2]).shake();
          showToast(trans.noChanges);
          setDisplay(updatingLoaderModal, "none");
        }
      } else {
        var nEmail = inputs[1].value.trim();
        if (nEmail.length > 0 && nEmail != userData.email) {
          setDisplay(updatingLoaderModal, "flex");
          changeEmail(nEmail, btnCancel, btnAuth, btnSubmit);
        } else {
          $(inputs[1]).shake();
          showToast(trans.noChanges);
          setDisplay(updatingLoaderModal, "none");
        }
      }
    });
  }

  inImage.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      imgUser.src = URL.createObjectURL(this.files[0]);
      setDisplay(spUndo, "block");
      btnUpNameImg.disabled = false;
    } else {
      imgUser.src = userData.profile_Image
        ? userData.profile_Image
        : phPersonImg;
      inImage.value = "";
      setDisplay(spUndo, "none");
      if (!nameChanged) {
        btnUpNameImg.disabled = true;
      }
    }
  });

  divUserImg.addEventListener("click", function () {
    inImage.click();
  });

  spUndo.addEventListener("click", function (event) {
    //event.preventDefault();
    event.stopPropagation();
    inImage.value = "";
    imgUser.src = userData.profile_Image ? userData.profile_Image : phPersonImg;
    setDisplay(spUndo, "none");
    if (!nameChanged) {
      btnUpNameImg.disabled = true;
    }
  });

  userEditModal.querySelector("img").src = userData.profile_Image
    ? userData.profile_Image
    : phPersonImg;
  inputs[0].value = userData.name;
  if (isEmail) {
    inputs[1].type = "email";
    inputs[1].disabled = false;
  } else {
    inputs[1].type = "tel";
    inputs[1].disabled = true;
  }
  inputs[1].value = userData.email;
  var allowNameChange = false;
  if (userData.name_change && userData.name_change == "no") {
    allowNameChange = true;
  } else {
    var year = userData.date_created + 1000 * 60 * 60 * 24 * 365;
    allowNameChange = userData.date_created >= year;
  }
  inputs[0].disabled = !allowNameChange;
  if (allowNameChange) {
    inputs[0].addEventListener("input", function () {
      var nName = inputs[0].value.trim();
      if (nName.length > 0 && userData.name != nName) {
        setDisplay(notes, "block");
        nameChanged = true;
        btnUpNameImg.disabled = false;
      } else {
        setDisplay(notes, "none");
        nameChanged = false;
        if (!inImage.value) {
          btnUpNameImg.disabled = true;
        }
      }
    });
  }

  btnUpNameImg.addEventListener("click", function () {
    setDisplay(userEditModal, "none");
    var nName = inputs[0].value.trim();
    if (nName != "" || inImage.value != "") {
      updateProfile(nName);
    }
  });
}

function changePassword(pass, btnCancel, btnAuth, btnSubmit) {
  setDisplay(updatingLoaderModal, "flex");
  var inCPassword = userEditModal.querySelector("input.redBorder");
  var noteAuth = userEditModal.querySelector(".noteAuth");
  setDisplay(noteAuth, "none");
  setDisplay(inCPassword, "none");
  setDisplay(btnAuth, "none");
  setDisplay(btnSubmit, "block");
  cUser
    .updatePassword(pass)
    .then(function () {
      //update success
      setDisplay(updatingLoaderModal, "none");

      btnCancel.click();
      showToast(trans.passChanged);
    })
    .catch(function (error) {
      //error
      var noteAuth = userEditModal.querySelector(".noteAuth");
      setDisplay(noteAuth, "block");
      setDisplay(updatingLoaderModal, "none");
      switch (error.code) {
        case "auth/weak-password":
          noteAuth.textContent = trans.weakPass;
          break;
        case "auth/requires-recent-login":
          noteAuth.textContent = trans.noteAuthenticate;
          inCPassword.value = "";
          setDisplay(inCPassword, "block");
          setDisplay(btnAuth, "block");
          setDisplay(btnSubmit, "none");
          $(inCPassword).shake();
          break;
        default:
          btnCancel.click();
          showToast(trans.errorMess);
          break;
      }
    });
}

function changeEmail(email, btnCancel, btnAuth, btnSubmit) {
  setDisplay(updatingLoaderModal, "flex");
  var inCPassword = userEditModal.querySelector("input.redBorder");
  var noteAuth = userEditModal.querySelector(".noteAuth");
  setDisplay(noteAuth, "none");
  setDisplay(inCPassword, "none");
  setDisplay(btnAuth, "none");
  setDisplay(btnSubmit, "block");
  cUser
    .updateEmail(email)
    .then(function () {
      //update success
      var userRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/info/");
      userRef.child("email").set(email);
      setDisplay(updatingLoaderModal, "none");

      btnCancel.click();
      showToast(trans.emailChanged);
    })
    .catch(function (error) {
      //error
      setDisplay(noteAuth, "block");
      setDisplay(inCPassword, "none");
      setDisplay(updatingLoaderModal, "none");
      switch (error.code) {
        case "auth/invalid-email":
          noteAuth.textContent = trans.errorFemail;
          break;
        case "auth/email-already-in-use":
          noteAuth.textContent = trans.errorFemailUsed;
          break;
        case "auth/requires-recent-login":
          noteAuth.textContent = trans.noteAuthenticate;
          inCPassword.value = "";
          setDisplay(inCPassword, "block");
          setDisplay(btnAuth, "block");
          setDisplay(btnSubmit, "none");
          $(inCPassword).shake();
          break;
        default:
          btnCancel.click();
          showToast(trans.errorMess);
          break;
      }
    });
}

function updateProfile(nName) {
  setDisplay(updatingLoaderModal, "flex");
  var changes = 0;
  if (nName.length > 0 && nName != userData.name) {
    changes++;
  }

  if (inImage.value) {
    changes++;
  }
  var userRef = firebase.database().ref("Users/" + currentUserId + "/info/");
  if (nName.length > 0 && nName != userData.name) {
    var nDate = new Date().getTime();
    userRef.child("name_change").set("yes", function (error) {
      if (error) {
        showToast(trans.errorMess);
        if (changes <= 0) {
          setDisplay(updatingLoaderModal, "none");
        }
      } else {
        userRef.child("date_created").set(nDate, function (error) {
          if (error) {
            showToast(trans.errorMess);
            if (changes <= 0) {
              setDisplay(updatingLoaderModal, "none");
            }
          } else {
            userRef.child("name").set(nName, function (error) {
              if (error) {
                showToast(trans.errorMess);
                if (changes <= 0) {
                  setDisplay(updatingLoaderModal, "none");
                }
              } else {
                userRef
                  .child("lowCaseName")
                  .set(nName.toLowerCase(), function (error) {
                    if (error) {
                      showToast(trans.errorMess);
                      if (changes <= 0) {
                        setDisplay(updatingLoaderModal, "none");
                      }
                    } else {
                      changes--;
                      if (changes <= 0) {
                        setDisplay(updatingLoaderModal, "none");
                        showToast(trans.changesMade);
                      }
                    }
                  });
              }
            });
          }
        });
      }
    });
  }

  if (inImage.value) {
    var picRef = firebase
      .storage()
      .ref("User Profile Images/" + currentUserId + "/Images/Profile Pic");
    var uploadTask = picRef.put(inImage.files[0]);
    uploadTask.on(
      "state_changed",
      function () {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      },
      function (error) {
        var errorMess;
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            errorMess = trans.errorImage;
            break;
          case "storage/canceled":
            errorMess = trans.errorUploadCancel;
            break;
          case "storage/unknown":
            // Unknown error occur, inspect error.serverResponse
            errorMess = trans.errorUnknown;
            break;
        }
        changes--;
        if (changes <= 0) {
          setDisplay(updatingLoaderModal, "none");
        }

        showToast(errorMess);
      },
      function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          //console.log('File available at', downloadURL);
          userRef.child("profile_Image").set(downloadURL, function (error) {
            if (error) {
              showToast(trans.errorMess);
            }
            changes--;
            if (changes <= 0) {
              setDisplay(updatingLoaderModal, "none");
              showToast(trans.changesMade);
            }
          });
        });
      }
    );
  }

  if (changes <= 0) {
    setDisplay(updatingLoaderModal, "none");
    showToast(trans.noChanges);
  }
}
function sendWebCs() {
  if (currentUserId) {
    $.getJSON("https://ipapi.co/json/", function (data) {
      var ip = data.ip;
      const browser = (function () {
        var test = function (regexp) {
          return regexp.test(window.navigator.userAgent);
        };
        switch (true) {
          case test(/edg/i):
            return "Edge";
          case test(/opr/i) && (!!window.opr || !!window.opera):
            return "Opera";
          case test(/chrome/i) && !!window.chrome:
            return "Chrome";
          case test(/trident/i):
            return "IE";
          case test(/firefox/i):
            return "Firefox";
          case test(/safari/i):
            return "Safari";
          default:
            return "Other";
        }
      })();
      if (ip) {
        ip = ip.replace(/\./g, "-");
        webRef = firebase
          .database()
          .ref("webUsers/" + currentUserId + "/" + ip);
        webRef.on("value", function (data) {
          if (data.exists()) {
            const userWeb = data.val();
            //check if blocked
            if (userWeb.blocked) {
              logout();
              return;
            }
            if (!onlineSent) {
              webRef.child("online").set(true, function (error) {
                if (!error) {
                  onlineSent = true;
                }
              });

              if (userWeb.browser && !userWeb.browser.includes(browser)) {
                var browsers = userWeb.browser + ", " + browser;
                webRef.child("browser").set(browsers);
              }
            }
            //check if user requested logout from phone
            if (userWeb.logout) {
              webRef.child("logout").set(false, function () {
                if (!error) {
                  logout();
                }
              });
            }
          } else {
            var webInfo = {
              logout: false,
              city: data.city || null,
              time: new Date().getTime(),
              country: data.country || null,
              blocked: false,
              online: true,
              browser: browser || null,
            };
            webRef.set(webInfo);
          }
        });
      }
    });
  }
}
function createUserProfile() {
  var registerModal = document.getElementById("registerModal");
  var imgUser = document.getElementById("imgUser");
  imgUser.src = phPersonImg;
  var inName = document.getElementById("inName");
  var loader = document.getElementById("loadingInfo");
  $(document).ready(function () {
    inName.focus();
  });

  var btnRegister = document.getElementById("btnRegister");

  inImageUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      uploadFile = this.files[0];
      //console.log("image file: " + inImageUpload.value);

      // $('img')[0]
      imgUser.src = URL.createObjectURL(uploadFile); // set src to blob url
    }
  });

  setDisplay(registerModal, "block");

  btnRegister.addEventListener(
    "click",
    function () {
      if (inName.value) {
        setDisplay(loader, "block");
        disableButton(btnRegister, true);
        var userName = inName.value;
        var time = new Date().getTime();
        var userProfile = {
          email: email,
          name: userName,
          lowCaseName: userName.toLowerCase(),
          profile_Image: null,
          name_change: "no",
          isPlaying: false,
          date_created: time,
        };
        if (uploadFile) {
          var filePath =
            "User Profile Images/" + currentUserId + "/Images/Profile Pic";
          var storageRef = firebase.storage().ref().child(filePath);
          var uploadTask = storageRef.put(uploadFile);
          uploadTask.on(
            "state_changed",
            function () {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              //var progress = (snapshot.bytesTransfer / snapshot.totalBytes) * 100;
              //console.log('Upload is ' + progress + '% done');
              // switch (snapshot.state) {
              //   case firebase.storage.TaskState.PAUSED: // or 'paused'
              //     console.log('Upload is paused');
              //     break;
              //   case firebase.storage.TaskState.RUNNING: // or 'running'
              //     console.log('Upload is running');
              //     break;
              // }
            },
            function (error) {
              var msg;
              switch (error.code) {
                case "storage/unauthorized":
                  msg = trans.errorImage;
                  break;
                case "storage/canceled":
                  msg = trans.errorUploadCancel;
                  break;
                case "storage/unknown":
                  msg = trans.errorUnknown;
                  break;
              }
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
              if (msg) {
                showToast(msg);
              }
            },
            function () {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  //console.log('File available at', downloadURL);
                  userProfile.profile_Image = downloadURL;
                  var userRef = firebase
                    .database()
                    .ref("Users/" + currentUserId + "/info");
                  userRef.set(userProfile, function (error) {
                    if (error) {
                      //message failed
                      showToast("Error registering. Try again later.");
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                    } else {
                      //message sent
                      //console.log("****uploaded user info***");

                      setDisplay(registerModal, "none");
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                      showToast("Thank you for registering!");
                      getProfileInfo();
                    }
                  });
                });
            }
          );
        } else {
          //console.log("id : " + currentChatId);

          var userRef = firebase
            .database()
            .ref("Users/" + currentUserId + "/info");
          userRef.set(userProfile, function (error) {
            if (error) {
              //message failed
              showToast("Error registering. Try again later.");
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
            } else {
              //message sent
              setDisplay(registerModal, "none");
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
              showToast("Thank you for registering!");
              getProfileInfo();
            }
          });
        }
      } else {
        inName.focus();
        showToast("Please provide your name");
      }
    },
    false
  );
}

function getImage(type) {
  switch (type) {
    case "register":
      inImageUpload.click();
      break;
    case "newUser":
      inProfileUpload.click();
      break;
    case "skd":
      inSkdIcon.click();
      break;
  }
}

function openModal(element, display) {
  closeNav();

  if (element) {
    setDisplay(element, display ? display : "block");
  } else {
    openCommonModal();
  }

  //divModal.style.display = "block";
}

function openNewRadio() {
  window.onunload = null;
  window.onbeforeunload = null;
  if (onlineRef) {
    stopOnlineTimer();
  }
  if (onlineSent) {
    webRef.child("online").set(false);
  }
  window.location.assign("../addRadio.html");
}

function toggleSwitch() {
  var switchRequest = document.getElementById("switchRequest");
  var requestsReceived = document.getElementById("requestsReceived");
  var requestsSent = document.getElementById("requestsSent");

  if (switchRequest.checked == true) {
    requestsSent.style.display = "block";
    requestsReceived.style.display = "none";
  } else {
    requestsSent.style.display = "none";
    requestsReceived.style.display = "block";
  }
}

function logout() {
  authListener();
  window.onunload = null;
  window.onbeforeunload = null;
  if (onlineRef) {
    stopOnlineTimer();
  }
  if (onlineSent) {
    webRef.child("online").set(false, function () {
      firebase
        .auth()
        .signOut()
        .then(function () {
          //sign out successfull
          //window.location.href = "../index.html";
          currentUserId = null;
          window.location.replace("../index.html");
        });
    });
  } else {
    firebase
      .auth()
      .signOut()
      .then(function () {
        //sign out successfull
        //window.location.href = "../index.html";
        currentUserId = null;
        window.location.replace("../index.html");
      });
  }
}
function openNav() {
  var sidePanel = document.getElementById("sidePanel");
  if (window.innerWidth <= 840) {
    sidePanel.style.width = "100%";
  } else {
    sidePanel.style.width = "30%";
  }

  sidePanel.style.overflow = "auto";
}

function openChats() {
  //btnNav
  var navHome = document.getElementById("navBox");

  if (navHome.className.includes("fresh")) {
    if (window.innerWidth <= 840) {
      navHome.style.display = "flex";
      mnuChats.classList.add("active");
    } else {
      navHome.style.display = "none";
      mnuChats.classList.remove("active");
    }
    navHome.className = navHome.className.replace(" fresh", "");
  } else if (navHome.style.display == "flex") {
    navHome.style.display = "none";
    mnuChats.classList.remove("active");
  } else {
    navHome.style.display = "flex";
    mnuChats.classList.add("active");
  }
}

function closeNav() {
  var sidePanel = document.getElementById("sidePanel");
  sidePanel.style.width = "0";
  sidePanel.style.overflow = "hidden";
}
function openPodTab(type) {
  var tbContent, tab;
  var podContentDivs = podChat.querySelectorAll(".content");
  var podTabLinks = podChat.querySelectorAll(".tablinks");
  tbContent = podContentDivs[type == "chat" ? 1 : 0];
  tab = podTabLinks[type == "chat" ? 1 : 0];
  podTabLinks.forEach((tb) => {
    tb.classList.remove("active");
  });
  podContentDivs.forEach((cnt) => {
    cnt.style.display = "none";
  });
  tbContent.style.display = "flex";
  tab.classList.add("active");
  setDisplay("inputArea", type == "chat" ? "flex" : "none");
}
function openTab(evt, tabName, pos) {
  var i, tabcontent, tablinks;
  var bkImg, bkColor;
  switch (pos) {
    case 0:
      bkColor = "#09B2FF";
      bkImg = "linear-gradient(to right, #09B2FF,#09B2FF, #5D9CEC)";
      break;
    case 1:
      bkColor = "#5d85ec";
      bkImg = "linear-gradient(to right, #5d85ec,#7a7adc, #b387ec)";
      break;
    case 2:
      bkColor = "#A90011";
      bkImg = "linear-gradient(to right, #A90011,#a92700, #a95300)";
      break;
    case 3:
      bkColor = "#4b9100";
      bkImg = "linear-gradient(to right, #4b9100,#009147, #00918f)";
      break;
    default:
      bkColor = "#09B2FF";
      bkImg = "linear-gradient(to right, #09B2FF,#09B2FF, #5D9CEC)";
      break;
  }
  navBox.style.backgroundColor = bkColor;
  navBox.style.backgroundImage = bkImg;

  tabcontent = document.getElementsByClassName("tabcontent drawer");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks drawer");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
    //tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "flex";
  evt.currentTarget.classList.add("active");
  //evt.currentTarget.className += " active";
}

function openTabRadio(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent Radio");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks Radio");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  document.getElementById(tabName).style.display = "flex";
  if (tabName === "tabChat") {
    imgBannerTop.style.height = "0px";
    document.getElementById("inputArea").style.display = "flex";
  } else {
    imgBannerTop.style.height = "100px";
    document.getElementById("inputArea").style.display = "none";
  }
  if (evt === "chat") {
    document.getElementById("btnTabChat").className += " active";
    scrollBottom("radio");
  } else if (evt === "radio") {
    document.getElementById("btnTabRadio").className += " active";
  } else {
    evt.currentTarget.className += " active";
  }
}

var BOOKMARK_TEMPLATE =
  '<div class="bookmark-container">' +
  '<div class="spacing"><img class="pic" src="' +
  phPersonImg +
  '" alt="profile picture" width="40px" height="40px"></img></div>' +
  '<div class="verticalFlex w100 ovf-hidden">' +
  '<div class="name" translate="no"></div>' +
  '<div class="message oneLine"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>";

var PROFILE_TEMPLATE =
  '<div class="bookmark-container horizFlex">' +
  '<img src="' +
  phPersonImg +
  '" alt="profile image" width="40px" height="40px" class="pic">' +
  '<div class="verticalFlex">' +
  '<div class="name" translate="no"></div>' +
  '<div class="message"></div>' +
  "</div>" +
  '<img class="divAction opas" src="' +
  phTrashIcon +
  '" alt="Remove" width="28px" height="28px" title="Remove friend">' +
  '<img class="divReject opas" src="' +
  phXPerson +
  '" alt="Reject" width="28px" height="28px" title="Decline friend request">' +
  "</div>";

var RADIO_TEMPLATE =
  '<div class="bookmark-container horizFlex">' +
  '<img class="imgRadio" src="' +
  phRadioImg +
  '" alt="radio logo" width="40px" height="40px">' +
  '<div class="name" translate="no"></div>' +
  '<div class="likes">❤️</div>';
("</div>");

var SMALL_TEMPLATE =
  '<div class="verticalFlex social">' +
  '<img class="img-circle" src="' +
  phPersonImg +
  '" alt="profile image" width="40px" height="40px">' +
  '<div class="name" translate="no"></div>' +
  "</div>";

/**
 * Message templates
 */
//************* For sent messages***********

var MESSAGE_SENT =
  '<div class="message-content sent">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  '<div class="message-container right-gus">' +
  //'<div class="name sent boldText"></div>' +
  '<div class="messageReply ri">Reply</div>' +
  // '<div class="messageReply">'+
  //     '<div class="elReply ri">Reply</div>'+
  // '</div>'+
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="message"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>" +
  "</div>" +
  "</div>";

var PICTURE_SENT =
  '<div class="message-content sent">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  '<div class="message-container right-gus pic">' +
  //'<div class="name sent boldText"></div>' +
  '<div class="messageReply ri">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<img class="picture" src="" alt="image sent">' +
  '<div class="horizFlex">' +
  '<div class="message"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>" +
  "</div>" +
  "</div>";

var GIF_SENT =
  '<div class="message-content sent">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  '<div class="message-container right-gus">' +
  //'<div class="name sent boldText"></div>' +
  '<div class="messageReply ri">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="gifHolder">' +
  '<img class="gif" src="" alt="gif sent">' +
  '<div class="notes brand">GIPHY</div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="message"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>" +
  "</div>" +
  "</div>";

var AUDIO_SENT =
  '<div class="message-content sent">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  '<div class="message-container right-gus">' +
  //'<div class="name sent boldText"></div>' +
  '<div class="messageReply ri">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<audio class="mAudio" controls src="">' +
  "Your browser does not support the <code>audio</code> element." +
  "</audio>" +
  '<div class="horizFlex">' +
  '<div class="message"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>" +
  "</div>" +
  "</div>";

var VIDEO_SENT =
  '<div class="message-content sent">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  '<div class="message-container right-gus vid">' +
  //'<div class="name sent boldText"></div>' +
  '<div class="messageReply ri">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<video class="videoContent" controls src="">' +
  "Your browser does not support HTML5 video." +
  "</video>" +
  '<div class="horizFlex">' +
  '<div class="message"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  "</div>" +
  "</div>" +
  "</div>";
//*********** For received messages ******************

var MESSAGE_RECEIVED =
  '<div class="message-content">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="message-container left-gus">' +
  '<div class="messageReply le">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="name received boldText"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  '<div class="message"></div>' +
  "</div>" +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  "</div>" +
  "</div>";

var PICTURE_RECEIVED =
  '<div class="message-content">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="message-container left-gus pic">' +
  '<div class="messageReply le">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="name received boldText"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  '<img class="picture" src="" alt="image sent">' +
  '<div class="message"></div>' +
  "</div>" +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  "</div>" +
  "</div>";

var GIF_RECEIVED =
  '<div class="message-content">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="message-container left-gus">' +
  '<div class="messageReply le">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="name received boldText"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  '<div class="gifHolder">' +
  '<img class="gif" src="" alt="gif sent">' +
  '<div class="notes brand">GIPHY</div>' +
  "</div>" +
  //'<img class="gif" src="" alt="gif sent">' +
  '<div class="message"></div>' +
  "</div>" +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  "</div>" +
  "</div>";

var AUDIO_RECEIVED =
  '<div class="message-content">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="message-container left-gus">' +
  '<div class="messageReply le">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="name received boldText"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  '<audio class="mAudio" controls src="">' +
  "Your browser does not support the <code>audio</code> element." +
  "</audio>" +
  '<div class="message"></div>' +
  "</div>" +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  "</div>" +
  "</div>";

var VIDEO_RECEIVED =
  '<div class="message-content">' +
  '<div class="date"></div>' +
  '<div class="horizFlex mHolder">' +
  '<div class="message-container left-gus vid">' +
  '<div class="messageReply le">Reply</div>' +
  '<div class="reply">' +
  '<div class="rName boldText"></div>' +
  '<div class="rMessage"></div>' +
  "</div>" +
  '<div class="horizFlex">' +
  '<div class="name received boldText"></div>' +
  '<div class="time"></div>' +
  "</div>" +
  '<video class="videoContent" controls src="">' +
  "Your browser does not support HTML5 video." +
  "</video>" +
  '<div class="message"></div>' +
  "</div>" +
  '<div class="verticalFlex phHolder">' +
  '<img class="rep" src="' +
  phReply +
  '" alt="" width="24px" height="24px" title="Reply">' +
  '<img class="dow" src="' +
  phDownloadIcon +
  '" alt="" width="24px" height="24px" title="Download">' +
  '<img class="sha" src="' +
  phShare +
  '" alt="" width="24px" height="24px" title="Share">' +
  '<img class="for" src="' +
  phForward +
  '" alt="" width="24px" height="24px" title="Forward">' +
  "</div>" +
  "</div>" +
  "</div>";

function loadBookmarks() {
  if (chatBmRef == null) {
    chatBmRef = firebase
      .database()
      .ref("Users/" + currentUserId + "/Chat_Bookmarks");

    const noBookmarks = document.getElementById("noChats");

    chatBmRef.orderByChild("date").on("child_added", function (data) {
      noBookmarks.style.display = "none";
      var bookmark = data.val();
      addBookmark(data.key, bookmark, null);
      addChatListener(data.key, bookmark);
      chatsKeyArray.push(data.key);
      chatsArray.push(bookmark);
    });

    chatBmRef.on("child_changed", function (data) {
      var bookmark = data.val();
      deleteElement(data.key);
      addBookmark(data.key, bookmark, null);
      if (currentElement && currentElement == data.key) {
        document.getElementById(currentElement).style.backgroundColor =
          "rgba(64, 195, 255, 0.33)";
      }
    });

    chatBmRef.on("child_removed", function (data) {
      var requestsReceived = document.getElementById("chats");
      if (requestsReceived.children.length == 0) {
        noBookmarks.style.display = "block";
      }
      deleteElement(data.key);
      deleteElement(data.key + "csearch");
      if (chatsKeyArray.includes(data.key)) {
        var index = chatsKeyArray.indexOf(data.key);
        chatsKeyArray.splice(index, 1);
        chatsArray.splice(index, 1);
      }
    });
  }
}

function addChatListener(id, bookmark) {
  //every time a new message arrives on the chat, change the message of that bookmark
  var chatRef;
  const bookmarkRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + id);
  switch (bookmark.type) {
    case "privateChat":
      chatRef = firebase
        .database()
        .ref("PrivateChat/" + currentUserId + "/" + id);
      break;
    case "RadioChat":
      chatRef = firebase.database().ref("Chats/" + id);
      break;
    case "GroupChat":
      chatRef = firebase
        .database()
        .ref("GroupChats/" + id + "/chat" + currentUserId);
      break;
    case "podChat":
      chatRef = firebase.database().ref("podChat/" + id);
      break;
  }

  chatRef.limitToLast(1).on("child_added", function (data) {
    //send chat info to bookmark
    var chatInfo = data.val();
    if (bookmark.date !== chatInfo.messageTime) {
      if (chatInfo.userId && chatInfo.userId !== currentUserId) {
        switch (chatInfo.type) {
          case "Text":
            var message = chatInfo.userName + ": " + chatInfo.textMessage;
            bookmarkRef.child("message").set(message);
            bookmarkRef.child("messageType").set("Text");
            break;
          case "Audio":
            bookmarkRef.child("audioDuration").set(chatInfo.audioLength);
            bookmarkRef.child("message").set(chatInfo.userName);
            bookmarkRef.child("messageType").set("Audio");
            break;
          case "Picture":
            bookmarkRef.child("message").set(chatInfo.userName);
            bookmarkRef.child("messageType").set("Picture");
            break;
          case "TextPicture":
            bookmarkRef.child("senderName").set(chatInfo.userName);
            bookmarkRef.child("message").set(chatInfo.textMessage);
            bookmarkRef.child("messageType").set("TextPicture");
            break;
          case "Video":
            bookmarkRef.child("message").set(chatInfo.userName);
            bookmarkRef.child("messageType").set("Video");
            break;
          case "TextVideo":
            bookmarkRef.child("senderName").set(chatInfo.userName);
            bookmarkRef.child("message").set(chatInfo.textMessage);
            bookmarkRef.child("messageType").set("TextVideo");
            break;
        }
        bookmarkRef.child("date").set(chatInfo.messageTime);
      }
    }
  });
}

function addBookmark(id, bookmark, ext) {
  //create the bookmark container
  const container = document.createElement("div");
  container.innerHTML = BOOKMARK_TEMPLATE;
  const div = container.firstChild;
  var chatBookmarksElementList;
  if (ext) {
    div.setAttribute("id", id + ext);
    chatBookmarksElementList = document.getElementById("divChatSearchResults");
  } else {
    div.setAttribute("id", id);
    chatBookmarksElementList = document.getElementById("recentChats");
  }

  const messageElement = div.querySelector(".message");

  var strMessage;
  if (bookmark.message && bookmark.messageType !== "Empty") {
    strMessage = bookmark.message;
  } else {
    strMessage = "No messages";
  }
  if (bookmark.messageType === "Audio") {
    strMessage = "Audio 🎤" + "(" + getAudioTime(bookmark.audioDuration) + ")";
  }
  //for all spaces = .replace(/\s/g,' ')  for enter spaces = .replace(/\n/g, " ")
  var message = strMessage
    .replace(/\s/g, " ")
    .replace("</p>", "</div>")
    .replace("<p", "<div");
  message = message.replace(/<br \\>/g, "...");
  messageElement.innerHTML = message; //bookmark.message;

  const nameElement = div.querySelector(".name");
  var strName = bookmark.name;
  var name = strName.replace(/\n/g, " ");
  nameElement.textContent = name;
  const timeElement = div.querySelector(".time");
  timeElement.textContent = formatDate(new Date(bookmark.date));
  var bmImg = div.querySelector(".pic");
  //set bookmark icon
  if (bookmark.imageUrl) {
    //console.log('image: ' + bookmark.imageUrl);

    $(bmImg).on("error", function () {
      if (bookmark.type && bookmark.type == "RadioChat") {
        //"url('img_tree.png')";
        bmImg.src = phRadioImg;
        getImageUpdate(bookmark, id, bmImg);
      } else if (bookmark.type && bookmark.type == "podChat") {
        bmImg.src = phPodcast;
      } else {
        bmImg.src = phPersonImg;
      }
    });

    bmImg.src = bookmark.imageUrl; //'url(' + addSizeToGoogleProfilePic(bookmark.imageUrl) + ')';
  } else if (bookmark.type && bookmark.type == "RadioChat") {
    //"url('img_tree.png')";
    div.querySelector(".pic").src = phRadioImg;
  } else if (bookmark.type && bookmark.type == "podChat") {
    div.querySelector(".pic").src = phPodcast;
  } else {
    div.querySelector(".pic").src = phPersonImg;
  }

  const existingBookmarks = chatBookmarksElementList.children;
  if (existingBookmarks.length === 0) {
    chatBookmarksElementList.appendChild(div);
  } else {
    chatBookmarksElementList.insertBefore(
      div,
      chatBookmarksElementList.children[0]
    );
  }

  div.addEventListener(
    "click",
    function () {
      displayChat(id, bookmark, bookmark.type);
    },
    false
  );
}

function getImageUpdate(bookmark, id, bmImg) {
  if (!bookmark.type) {
    return;
  }
  var gRef,
    imgPh = phImage;
  switch (bookmark.type) {
    case "RadioChat":
      gRef = firebase
        .database()
        .ref("Radio Stations/" + id + "/info/radio_image");
      imgPh = phRadioImg;
      break;
    case "privateChat":
      gRef = firebase.database().ref("Users/" + id + "/info/profile_Image");
      imgPh = phXPerson;
      break;
    case "GroupChat": //GroupChat
      gRef = firebase.database().ref("GroupChats/" + id + "/info/icon");
      imgPh = phPersonImg;
      break;
    case "podChat":
      gRef = firebase.database().ref("podcast/" + id + "/icon");
      imgPh = phPodcast;
      break;
  }
  gRef.once("value", function (data) {
    if (data.exists()) {
      bmImg.src = data.val();
      var bmRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + id + "/imageUrl");
      bmRef.set(data.val());
    } else {
      bmImg.src = imgPh;
    }
  });
}

function removeBkm(id, isRadio) {
  if (currentUserId) {
    var existsRef = firebase
      .database()
      .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + id);
    existsRef.remove(function (error) {
      if (!error) {
        //delete success
        showToast(trans.chatRemoved);
      }
    });
  }
  if (currentChatId == id) {
    currentChatId = null;
    document.getElementById("divWelcome").style.display = "flex";
    document.getElementById("normalChat").style.display = "none";
    document.getElementById("radioChat").style.display = "none";
    document.getElementById("inputArea").style.display = "none";
    notFound.querySelector("p").textContent = isRadio
      ? trans.radioNotExist
      : trans.groupNotFound;
    setDisplay(notFound, "flex");
  }
}

function loadRadios() {
  //load user radios

  var userRadiosRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/My_Radios");
  userRadiosRef.on("child_added", function (data) {
    const radioId = data.key;

    var radioRef;
    const verified = data.val().verified != null ? data.val().verified : true;

    if (verified) {
      radioRef = firebase.database().ref("Radio Stations/" + radioId + "/info");
    } else {
      radioRef = firebase.database().ref("verify/radio/" + radioId + "/info");
    }
    radioRef.on("value", function (data) {
      if (data.exists()) {
        var radio = data.val();
        setDisplay(userRadios, "block");
        addRadio(radioId, radio, "divUserRadios", verified);
      }
    });
  });

  userRadiosRef.on("child_removed", function (data) {
    deleteElement(data.key + "user");
  });

  //load favorite radios
  var favRadiosRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Favorite Radios");
  favRadiosRef.on("child_added", function (data) {
    const radioId = data.key;
    var radioRef = firebase
      .database()
      .ref("Radio Stations/" + radioId + "/info");
    radioRef.on("value", function (data) {
      if (data.exists()) {
        var radio = data.val();
        setDisplay(favs, "block");
        addRadio(radioId, radio, "divFavRadios", true);
      }
    });
  });

  favRadiosRef.on("child_removed", function (data) {
    deleteElement(data.key + "fav");
  });
}

function addRadio(id, radio, divId, verified) {
  var oldDiv = document.getElementById(id + "radio");
  const container = document.createElement("div");
  container.innerHTML = RADIO_TEMPLATE;
  const div = container.firstChild;
  var radioId = id + "radio";
  var typeId;
  switch (divId) {
    case "divUserRadios":
      typeId = id + "user";
      //div.setAttribute('id',id + 'user');
      break;
    case "divFavRadios":
      typeId = id + "fav";
      //div.setAttribute('id',id + 'fav');
      break;
    case "divSearchResults":
      typeId = id + "search";
      //div.setAttribute('id',id + 'search');
      break;
    default:
      //'divTopRadios'
      typeId = id + "top";
      //div.setAttribute('id',id+'top');
      break;
  }
  oldDiv = document.getElementById(typeId);
  div.setAttribute("id", typeId);
  //div.setAttribute('time', bookmark.date);
  var radioElementList = document.getElementById(divId);
  if (radio.numLikes) {
    var divLikes = div.querySelector(".likes");
    divLikes.textContent = "❤️ " + radio.numLikes;
    setDisplay(divLikes, "block");
  } else {
    var divLikes = div.querySelector(".likes");
    setDisplay(divLikes, "none");
  }
  const nameElement = div.querySelector(".name");
  var radioName = radio.radio_Name;
  //var name = strName.replace(/\n/g, '<br>');
  nameElement.textContent = radioName;

  //set bookmark icon
  if (radio.radio_image) {
    //console.log('image: ' + bookmark.imageUrl);
    div.querySelector(".imgRadio").src = radio.radio_image;
  } else {
    div.querySelector(".imgRadio").src = phRadioImg;
  }

  //const existingRadios = radioElementList.children;

  if (oldDiv) {
    radioElementList.replaceChild(div, oldDiv);
  } else {
    const existingRadio = radioElementList.children;
    if (existingRadio.length === 0) {
      radioElementList.appendChild(div);
    } else {
      radioElementList.insertBefore(div, radioElementList.children[0]);
    }
  }

  div.addEventListener(
    "click",
    function () {
      if (verified) {
        displayChat(radioId, radio, "RadioChat");
      } else {
        currentChatId = id;
        radioInfo = radio;
        if (currentUserId == radioInfo.admin_ID) {
          isCreator = true;
          initEditModal(false);
          setDisplay(editRadioModal, "flex");
        }
      }
    },
    false
  );
}

// Load friends
function loadFriends() {
  //.child("Users").child(userId).child("Friends");
  var friendsRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Friends");
  friendsRef.on("child_added", function (data) {
    getUser(data.key);
  });

  friendsRef.on("child_removed", function (data) {
    deleteElement(data.key);
    deleteElement(data.key + "friend");
    deleteElement(data.key + "search");
    if (friends.children.length == 0) {
      setDisplay(divNoFriends, "block");
    }
  });
}
function getUser(key, ext) {
  var friends = document.getElementById("friends");
  var userRef = firebase.database().ref(`Users/${key}/info`);
  userRef.on("value", function (data) {
    if (data.exists) {
      if (friends.children.length == 0) {
        setDisplay(divNoFriends, "none");
        setDisplay(divFriends, "block");
      }
      var friend = data.val();

      displayFriend(data.key, friend, ext);
    }
  });
}
function displayFriend(id, friend, ext) {
  const container = document.createElement("div");
  container.innerHTML = PROFILE_TEMPLATE;
  const div = container.firstChild;
  var friendId = id + "friend";
  var friendElementList;
  var divAction = div.querySelector(".divAction");
  var friendInfo;

  if (!chatUserKeyArray.includes(id)) {
    friendInfo = {
      email: friend.email,
      name: friend.name,
      lowCaseName: friend.lowCaseName,
      profile_Image: friend.profile_Image ? friend.profile_Image : null,
      message: null,
      date_created: null,
    };

    chatUserKeyArray.push(id);
    chatUserArray.push(friendInfo);
  } else {
    friendInfo = chatUserArray[chatUserKeyArray.indexOf(id)];
  }

  if (ext) {
    friendElementList = document.getElementById("divFSearchResults");
    div.setAttribute("id", id + ext);
    if (id == currentUserId) {
      setDisplay(divAction, "none");
      var message = div.querySelector(".message");
      message.textContent = trans.you;
      setDisplay(message, "block");
    } else {
      var divReject = div.querySelector(".divReject");
      setDisplay(divReject, "none");
      if (document.getElementById(friendId)) {
        divAction.src = phTrashIcon;
        divAction.title = trans.unfriend;

        $(divAction).click(function (e) {
          e.stopPropagation();
          showConfirmModal(id, friend.name, friendInfo);
        });
      } else if (document.getElementById(id + "reqin")) {
        divAction.src = phAcceptPerson;
        divAction.title = trans.acceptReq;
        divAction.style.backgroundColor = "#2dba10";
        setDisplay(divReject, "block");

        $(divReject).click(function (e) {
          e.stopPropagation();
          rejectFriendRequest(id, friendInfo);
        });

        $(divAction).click(function (e) {
          e.stopPropagation();
          var currentUserInfo = {
            email: userInfo.email,
            name: userInfo.name,
            lowCaseName: userInfo.name.toLowerCase(),
            profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
            message: null,
            date_created: null,
          };
          acceptFriendRequest(id, currentUserInfo, friendInfo);
        });
      } else if (document.getElementById(id + "reqout")) {
        divAction.src = phXPerson;
        divAction.title = trans.cancelReq;

        $(divAction).click(function (e) {
          e.stopPropagation();
          cancelFriendRequest(id, friendInfo);
        });
      } else {
        //add as friend
        divAction.src = phAddPerson;
        divAction.title = trans.sendFriendReq;
        divAction.style.backgroundColor = "#21B1F3";

        $(divAction).click(function (e) {
          e.stopPropagation();
          var currentUserInfo = {
            email: userInfo.email,
            name: userInfo.name,
            lowCaseName: userInfo.name.toLowerCase(),
            profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
            message: null,
            date_created: null,
          };
          if (requestmessage) {
            showMessageDialog(id, currentUserInfo, friendInfo);
            setDisplay(chatUserModal, "none");
          } else {
            sendFriendRequest(id, currentUserInfo, friendInfo);
          }
        });
      }
    }
  } else {
    friendElementList = document.getElementById("friends");
    div.setAttribute("id", friendId);
    $(divAction).click(function (e) {
      e.stopPropagation();
      showConfirmModal(id, friend.name, friendInfo);
    });
  }

  const nameElement = div.querySelector(".name");
  var friendName = friend.name;
  nameElement.textContent = friendName;

  //set bookmark icon
  if (friend.profile_Image) {
    div.querySelector(".pic").src = friend.profile_Image;
  }

  //const existingRadios = friendElementList.children;
  friendElementList.appendChild(div);

  div.addEventListener("click", function () {
    if (id != currentUserId) {
      if (document.getElementById(friendId)) {
        displayChat(friendId, friend, "privateChat");
      } else {
        getChatUserInfo(id);
      }
    }
  });
}

function loadReceivedRequests() {
  var receivedRequestsRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/FriendRequests/Received");
  receivedRequestsRef.on("child_added", function (data) {
    document.getElementById("noneReceived").style.display = "none";
    var request = data.val();
    displayRequest(data.key, request, true);

    if (document.getElementById(data.key + "search")) {
      editDivAction(data.key, data.val(), "reject");
    }
  });

  // friendsRef.on('child_changed', function(data) {
  //     //setCommentValues(postElement, data.key, data.val().text, data.val().author);
  // });

  receivedRequestsRef.on("child_removed", function (data) {
    deleteElement(data.key + "reqin");
    var requestsReceived = document.getElementById("requestsReceived");

    if (requestsReceived.children.length <= 1) {
      document.getElementById("noneReceived").style.display = "block";
    }
    if (document.getElementById(data.key + "search")) {
      if (document.getElementById(data.key + "friend")) {
        editDivAction(data.key, data.val(), "remove");
      } else {
        editDivAction(data.key, data.val(), "add");
      }
    }
    //deleteComment(postElement, data.key);
  });
}

// Load requests sent
function loadSentRequests() {
  var sentRequestsRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/FriendRequests/Sent");
  sentRequestsRef.on("child_added", function (data) {
    document.getElementById("noneSent").style.display = "none";
    var request = data.val();
    displayRequest(data.key, request, false);
    if (document.getElementById(data.key + "search")) {
      editDivAction(data.key, data.val(), "cancel");
    }
  });

  // friendsRef.on('child_changed', function(data) {
  //     //setCommentValues(postElement, data.key, data.val().text, data.val().author);
  // });

  sentRequestsRef.on("child_removed", function (data) {
    deleteElement(data.key + "reqout");
    var requestsReceived = document.getElementById("requestsSent");

    if (requestsReceived.children.length <= 1) {
      document.getElementById("noneSent").style.display = "block";
    }

    if (document.getElementById(data.key + "search")) {
      if (document.getElementById(data.key + "friend")) {
        editDivAction(data.key, data.val(), "remove");
      } else {
        editDivAction(data.key, data.val(), "add");
      }
    }
  });
}

function deleteElement(id) {
  if (document.getElementById(id)) {
    document.getElementById(id).remove();
  }
}

function displayRequest(id, request, received) {
  const container = document.createElement("div");
  container.innerHTML = PROFILE_TEMPLATE;
  const div = container.firstChild;
  const messageElement = div.querySelector(".message");
  const nameElement = div.querySelector(".name");
  if (request.message) {
    messageElement.textContent = request.message;
    setDisplay(nameElement, "block");
    //container.innerHTML = PROFILE_MESSAGE_TEMPLATE;
  } else {
    setDisplay(messageElement, "none");
  }

  var ext = received ? "reqin" : "reqout";
  div.setAttribute("id", id + ext);
  //div.setAttribute('time', bookmark.date);
  var requestElementList;
  var divAction = div.querySelector(".divAction");
  if (received) {
    requestElementList = document.getElementById("requestsReceived");
    divAction.src = phAcceptPerson;
    divAction.title = trans.acceptReq;
    divAction.style.backgroundColor = "#2dba10";
    var divReject = div.querySelector(".divReject");
    setDisplay(divReject, "block");

    $(divReject).click(function (e) {
      e.stopPropagation();
      rejectFriendRequest(id, friendInfo);
    });
    $(divAction).click(function (e) {
      e.stopPropagation();
      var currentUserInfo = {
        email: userInfo.email,
        name: userInfo.name,
        lowCaseName: userInfo.name.toLowerCase(),
        profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
        message: null,
        date_created: null,
      };
      acceptFriendRequest(id, currentUserInfo, request);
    });
  } else {
    requestElementList = document.getElementById("requestsSent");
    divAction.src = phReqCancel;
    divAction.title = trans.cancelReq;
    divAction.style.backgroundColor = "#444";
    $(divAction).click(function (e) {
      e.stopPropagation();
      cancelFriendRequest(id, request);
    });
    // divAction.addEventListener('click', function (e) {
    //     e.stopPropagation();
    //     cancelFriendRequest(id, request);
    // });
  }

  var friendName = request.name;
  nameElement.textContent = friendName;

  //set bookmark icon
  if (request.profile_Image) {
    //console.log('image: ' + bookmark.imageUrl);
    div.querySelector(".pic").src = request.profile_Image;
  }

  if (!chatUserKeyArray.includes(id)) {
    chatUserKeyArray.push(id);
    chatUserArray.push(request);
  }

  div.addEventListener("click", function () {
    getChatUserInfo(id);
  });

  requestElementList.appendChild(div);
}

function displayChat(id, chat, type, isSearch) {
  var elId = id.replace("radio", "");
  if (currentChatId != null && id.includes(currentChatId)) {
    if (window.innerWidth <= 840 && !isSearch) {
      openChats();
    }

    if (document.getElementById(elId)) {
      document.getElementById(elId).style.backgroundColor =
        "rgba(64, 195, 255, 0.33)";
    }
    if (!isNewUserContent) {
      return;
    } else {
      isNewUserContent = false;
    }
  }

  if (chat) {
    stopRecTimer();
    setDisplay(replyContent, "none");
    disableButton(btnSend, false);
    setDisplay(notFound, "none");
    setDisplay(btnNewRequest, "flex");
    setDisplay(petitionBox, "none");
    setDisplay(bSettings, "none");
    setDisplay(radioTabs, "flex");
    stopRefs();
    stopRadioSkdRef();
    stopRadioRefs();
    clearYtLists();
    radioStarted = false;
    currentChat = chat;
    currentChatType = type;
    curDay = getDayAbbr(new Date().getDay());

    if (currentElement) {
      var currentItem = document.getElementById(currentElement);
      if (currentItem) {
        document.getElementById(currentElement).style.backgroundColor = "";
      }
    }
    if (document.getElementById(elId)) {
      document.getElementById(elId).style.backgroundColor =
        "rgba(64, 195, 255, 0.33)";
    }
    setDisplay(imgSettings, "none");
    setDisplay(divEditInfo, "none");
    currentElement = id.replace("radio", "");
    document.getElementById("divWelcome").style.display = "none";
    document.getElementById("inputArea").style.display = "flex";
    initNotificationLs(id, type);
    switch (type) {
      case "RadioChat":
        allowLink = false;
        document.getElementById("normalChat").style.display = "none";
        document.getElementById("radioChat").style.display = "flex";
        document.getElementById("podChat").style.display = "none";
        isCreator = false;
        resetAddSkd(false);
        if (!agoraStarted && currentUserId != null) {
          initAgora();
        }
        if (currentUserId != null && option != null) {
          option.channel = id.replace("radio", "");
        }

        if (isMainHost || isCohost) {
          if (liveVideoRef) {
            if (currentChannel == null) {
              liveVideoRef.off();
            } else if (!id.includes(currentChannel)) {
              liveVideoRef.off();
              if (isVideoLive) {
                isVideoLive = false;
                leaveChannel();
              }
            }
          }
        }

        var isDjing = radioHost && radioHost.hostId == currentUserId;
        if ((isDjing || isMainHost) && reqVideoRef != null) {
          reqVideoRef.remove();
          setDisplay(requestDiv, "none");
          let requestItems = document.getElementById("requestItems");
          requestItems.textContent = "";
          reqVideoRef.off();
          reqVideoRef = null;
        }

        if (userReqVideoRef) {
          userReqVideoRef.remove(function (error) {
            if (error) {
              showToast(trans.errorMess);
            }
            userReqVideoRef.off();
          });
        }
        reqInfo = null;
        initRadioChat(id, chat);
        break;
      case "privateChat":
        allowLink = true;
        document.getElementById("normalChat").style.display = "flex";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("podChat").style.display = "none";
        initPrivateChat(id, chat);
        break;
      case "GroupChat":
        allowLink = true;
        document.getElementById("normalChat").style.display = "flex";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("podChat").style.display = "none";
        initGroupChat(id, chat);
        break;
      case "podChat":
        allowLink = true;
        document.getElementById("normalChat").style.display = "none";
        document.getElementById("radioChat").style.display = "none";
        document.getElementById("podChat").style.display = "flex";

        // if (
        //   audioPlayId != null &&
        //   !id.includes(audioPlayId) &&
        //   !podPlayer.paused
        // ) {
        //   podPlayer.pause();
        // }
        initPodChat(id, chat, isSearch);
        break;
    }

    if (window.innerWidth <= 840 && !isSearch) {
      openChats();
    }
    textContainer.focus();
  }
}
function initNotificationLs(groupId, type) {
  if (dbUserSub) {
    dbUserSub.off();
    dbUserSub = null;
  }
  cTopic = groupId + currentUserId;
  dbUserSub = firebase.database().ref(`userSub/${currentUserId}/${cTopic}`);
  dbUserSub.on("value", function (data) {
    subOn = data.exists();

    if (subOn) {
      notificationKey = data.val();
      btnToggleNotification.classList.add("enabled");
    } else {
      notificationKey = null;
      btnToggleNotification.classList.remove("enabled");
    }
  });
}

function initPodChat(id, chat, isSearch) {
  setDisplay("inputArea", id.includes("pod=") ? "none" : "flex");
  currentChatId = id.replace("pod=", "");
  audioPlayId = currentChatId;
  groupRef = firebase.database().ref(`podcast/${currentChatId}`);
  groupRef.on("value", function (data) {
    if (data.exists()) {
      groupInfo = data.val();
      initPodToolbar(groupInfo);
      if (!fragsInitiated) {
        fragsInitiated = true;
        initPodFrags(id, groupInfo, chat, isSearch);
      }

      updateFrags(id, groupInfo, chat);
    }
  });
}
function initPodFrags(id, chat, bm, isSearch) {
  setDisplay("inputArea", id.includes("pod=") ? "none" : "flex");
  openPodTab(id.includes("pod=") || isSearch ? "home" : "chat");
  var podName = chat.title.replace(/--/g, "_");
  podName = podName.replace(/\s+/g, "-");
  podName = podName.replace(/_/g, "--");
  var urlName = "chat/p=" + podName; //chat/p=
  window.history.replaceState({}, "", urlName);
  document.title = chat.title + " | ChatMurcianys";

  //Get Chat ref
  currentChatRef = firebase.database().ref(`podChat/${currentChatId}`);
  currentChatRef.on("child_added", function (data) {
    document.getElementById("podNoMsgs").style.display = "none";
    var message = data.val();
    displayMessage(data.key, message, "podcast");
  });
  currentChatRef.on("child_changed", function (data) {
    document.getElementById("normMessagesNone").style.display = "none";
    var message = data.val();
    displayMessage(data.key, message, "podcast");
  });
  currentChatRef.on("child_removed", function (data) {
    deleteElement(data.key);
    var messagesListElement = document.getElementById("podMsgList");

    if (messagesListElement.children.length == 0) {
      document.getElementById("podNoMsgs").style.display = "block";
    }
  });

  getPodLike(id.replace("pod=", ""));
}
function getPodLike(id) {
  var liked;
  const podLikeRef = firebase
    .database()
    .ref(`like/podcast/${id}/${currentUserId}`);
  userLikeRef = firebase
    .database()
    .ref(`Users/${currentUserId}/like/podcast/${id}`);
  userLikeRef.on("value", function (data) {
    liked = data.exists();
    if (liked) {
      btnAddPodFavs.style.display = "none";
    } else {
      btnAddPodFavs.style.width = "block";
    }
  });
  $(btnAddPodFavs).off("click");
  $(btnAddPodFavs).click(function (e) {
    e.stopPropagation();
    if (currentUserId != null) {
      likePod(podLikeRef, id);
    } else {
      initUserLogin(6029);
    }
  });
}

function likePod(podLikeRef, id) {
  const dt = new Date().getTime();
  userLikeRef.set(dt, function (error) {
    if (error) {
      showToast(trans.errorMess);
    } else {
      podLikeRef.set(dt);
    }
  });
}

function dislikePod(podLikeRef, id) {
  userLikeRef.remove(function (error) {
    if (error) {
      showToast(trans.errorMess);
    } else {
      podLikeRef.remove();
    }
  });
}

function updateFrags(id, chat, bm) {
  currentChat = chat;
  var divLocation = podChat.querySelector(".content .altLocation span");
  var divLikes = podChat.querySelector(".content .altLikes span");
  var divDesc = podChat.querySelector(".content .altDesc");
  var imgLogo = podChat.querySelector(".content .topInfo img");

  imgLogo.src = chat.icon ? chat.icon : phPodcast;
  divLocation.textContent = getCountryName(
    trans.language,
    getCountryIndex(chat.country.toUpperCase())
  );
  divLikes.textContent = chat.likes;
  divDesc.textContent = chat.desc;
  if (
    episodeList.length == 0 ||
    (bm.radioStream != null && bm.radioStream != chat.feed)
  ) {
    var epLoading = divPodEpisode.querySelector("img.altLoading");
    epLoading.style.display = "block";
    initPodAudio(chat.feed, epLoading);
  }
}
async function initPodAudio(feed, epLoading) {
  podPlayer.innerHTML = "";
  if (feed) {
    const pod = await podcastFeedParser.getPodcastFromURL(feed);
    const episodes = pod.episodes;
    var episodeLink;
    if (episodes != null && episodes.length > 0) {
      episodes.forEach((ep) => {
        addPodEpisode(ep);
      });

      episodeLink = episodes[0].enclosure.url;
    }
    epLoading.style.display = "none";
    if (episodeLink == null) {
      return;
    }
    var source = document.createElement("source");
    source.src = episodeLink;
    podPlayer.appendChild(source);
    podPlayer.load();
    podChat.querySelector(".currEp").textContent = episodes[0].title;
  }
  // countryList.forEach((c) => {
  //   var option = document.createElement("option");
  //   option.textContent = c;
  //   selPodCountry.appendChild(option);
  // });
}
var EPISODE_TEMPLATE =
  '<div class="horizFlex white-shadow-text-round divEp mb8">' +
  '<img src="./images/podcast.svg" alt="podcast" class="epIcon alt-podIcon mr8" width="90px" height="fit-content">' +
  '<div class="verticalFlex mainTop ovf-hidden">' +
  '<div class="epName mb8 boldText">Name</div>' +
  '<div class="epDesc">Description</div>' +
  '<div class="epMore mb8 readMore opas point"></div>' +
  '<div class="horizFlex space-btw">' +
  '<button class="epPlay btn-und-blue-shadow-round mw64">Play</button>' +
  '<div class="epDur self-end time">00:00</div>' +
  "</div>" +
  "</div>" +
  "</div>";
function addPodEpisode(ep) {
  const container = document.createElement("div");
  container.innerHTML = EPISODE_TEMPLATE;
  const div = container.firstChild;
  var divEpisodeList = document.getElementById("podEpisodeList");
  var key = ep.enclosure.url ? ep.enclosure.url : divEpisodeList.length;
  var oldDiv = document.getElementById(key);
  div.setAttribute("id", key);

  episodeList.push(ep);
  const indexEpisode = episodeList.length - 1;
  var imgIcon = div.querySelector(".epIcon");
  var btnPlay = div.querySelector(".epPlay");
  $(imgIcon).on("error", function () {
    imgIcon.src = phPodcast;
  });
  imgIcon.src = ep.imageURL ? ep.imageURL : phPodcast;

  $(btnPlay).click(function (e) {
    e.stopPropagation();
    podPlayer.innerHTML = "";
    var source = document.createElement("source");
    source.src = ep.enclosure.url;
    podPlayer.appendChild(source);
    podPlayer.load();
    podPlayer.play();
    currentEpisode = indexEpisode;
    podChat.querySelector(".currEp").textContent = ep.title;
  });
  var divReadMore = div.querySelector(".epMore");
  divReadMore.textContent = trans.readMore;

  var divReadFull = document.getElementById("epReadFull");
  $(divReadMore).click(function (e) {
    e.stopPropagation();
    divReadFull.querySelector(".epTitle").textContent = ep.title;
    divReadFull.querySelector(".epDescFull").innerHTML = ep.description;
    setDisplay(divReadFull, "flex");
  });

  div.querySelector(".epName").textContent = ep.title;
  div.querySelector(".epDesc").innerHTML = ep.description
    ? linkify(removeTags(ep.description))
    : "";
  div.querySelector(".epDur").innerHTML = ep.enclosure.length
    ? formatDurationHMS(ep.enclosure.length)
    : "";

  if (oldDiv) {
    $(oldDiv).off("click");
    divEpisodeList.replaceChild(div, oldDiv);
  } else {
    divEpisodeList.appendChild(div);
  }
}
function initPodToolbar(podcast) {
  if (podcast) {
    var divTitle = podChat.querySelector(".divTitle");
    divTitle.textContent = podcast.title;

    var imgIcon = podChat.querySelector(".toolbar img");
    imgIcon.src = podcast.icon ? podcast.icon : phPodcast;
  }
}

function initRadioChat(id, radioChat) {
  var radioStream;
  var radioName;
  var imgLargeRadio = document.getElementById("imgLargeRadio");
  var imgLogo = document.getElementById("radioLogo");
  imgLogo.src = phRadioImg;
  var logo, banner;
  if (id.endsWith("radio")) {
    radioStream = radioChat.radio_Stream;
    radioName = radioChat.radio_Name;

    //display radio image
    if (radioChat.radio_image) {
      imgLogo.src = radioChat.radio_image;
      imgLargeRadio.src = radioChat.radio_image;
    } else {
      imgLargeRadio.src = phRadioImg;
    }

    currentChatId = id.replace("radio", "");
    openTabRadio("radio", "tabRadio");
  } else {
    radioStream = radioChat.radioStream;
    radioName = radioChat.name;
    if (radioChat.imageUrl) {
      imgLogo.src = radioChat.imageUrl;
      imgLargeRadio.src = radioChat.imageUrl;
    } else {
      imgLargeRadio.src = phRadioImg;
    }

    currentChatId = id;

    openTabRadio("chat", "tabChat");
  }
  var radioBanner = document.getElementById("divBlurBanner");
  //.querySelector(".sloganBkg");
  if (radioChat.banner) {
    banner = radioChat.banner;
    radioBanner.style.backgroundImage =
      "url(" + addSizeToGoogleProfilePic(radioChat.banner) + ")";
    setDisplay(imgBannerTop, "block");
  } else {
    banner = phBannerImg;
    radioBanner.style.backgroundImage = "url('" + phBannerImg + "')";
    setDisplay(imgBannerTop, "none");
  }
  imgBannerTop.src = banner;
  logo = imgLogo.src;

  var elmtRadioName = document.getElementById("radioName");
  elmtRadioName.innerHTML = radioName;
  currentRadioName = radioName;
  var audio = document.getElementById("radioAudio"); //radioAudio openstream: os_player_media
  audio.innerHTML = "";

  var source = document.createElement("source"); //document.getElementById('radioStream');
  source.src = radioStream;
  audio.appendChild(source);
  var backupSource = document.createElement("source");
  var backUpUrl;
  if (radioStream.endsWith("/")) {
    //backupSource.src = radioStream + ";";
    backUpUrl = radioStream + ";";
  } else if (radioStream.endsWith("/;")) {
    //backupSource.src = radioStream;
    backUpUrl = radioStream;
  } else {
    //backupSource.src = radioStream + "/;";
    backUpUrl = radioStream + "/;";
  }

  backupSource.src = backUpUrl;
  audio.appendChild(backupSource);

  audio.load();
  // const statsListener = new IcecastMetadataStats(radioStream, {
  //   sources: ["icy"],
  //   onStats: (stats) => {
  //     console.log(stats.icy);
  //   },
  // });
  // statsListener.start();

  //http://stream-dc1.radioparadise.com:80/ogg-96m

  radioLikesRef = firebase
    .database()
    .ref("Radio Stations/" + currentChatId + "/info");
  radioLikesRef.on("value", function (data) {
    if (data.exists()) {
      radioInfo = data.val();
      if (radioInfo.numLikes) {
        divLikes.textContent = "❤️ " + radioInfo.numLikes;
      } else {
        divLikes.textContent = "❤️ " + 0;
      }
      if (radioInfo.radio_Slogan) {
        divSlogan.textContent = radioInfo.radio_Slogan;
        setDisplay(divSlogan, "block");
      } else {
        setDisplay(divSlogan, "none");
      }
      divInfo.textContent = radioInfo.radio_Description;

      if (radioInfo.webStream) {
        //get webStream if any
        var webSource = document.createElement("source");
        var webUrl = radioInfo.webStream;
        webSource.src = webUrl;
        audio.appendChild(webSource);
        audio.load();
      }

      if (radioStream != radioInfo.radio_Stream) {
        radioStream = radioInfo.radio_Stream;
        audio.innerHTML = "";
        source.src = radioStream;
        audio.appendChild(source);
        if (radioStream.endsWith("/")) {
          backUpUrl = radioStream + ";";
        } else if (radioStream.endsWith("/;")) {
          backUpUrl = radioStream;
        } else {
          backUpUrl = radioStream + "/;";
        }
        backupSource.src = backUpUrl;
        audio.appendChild(backupSource);
        if (!audio.paused) {
          audio.load();
          audio.play();
        } else {
          audio.load();
        }
      }

      if (radioInfo.radio_image && logo != radioInfo.radio_image) {
        logo = radioInfo.radio_image;
        imgLogo.src = logo;
      }
      if (radioInfo.banner && banner != radioInfo.banner) {
        banner = radioInfo.banner;
        radioBanner.style.backgroundImage =
          "url(" + addSizeToGoogleProfilePic(banner) + ")";
        setDisplay(imgBannerTop, "block");
      }
      imgBannerTop.src = banner;
    } else {
      divLikes.textContent = "❤️ " + 0;
      divInfo.textContent = "";
    }
  });
  //Prepare radio fragment

  const btnSendRequest = document.getElementById("btnSendRequest");
  btnSendRequest.addEventListener("click", function () {
    if (currentUserId != null) {
      sendPetition(currentChatId);
    } else {
      initUserLogin(6344);
    }
  });
  roleRef = firebase.database().ref(`role/${currentUserId}/${currentChatId}`); //"role/" + currentChatId + "/Administrators/" + currentUserId
  var gotPermission = false;
  roleRef.on("value", function (snapshot) {
    if (snapshot.exists()) {
      gRole = snapshot.val();
      hasPermission = gRole.admin || gRole.owner || gRole.dj;
      isCreator = gRole.owner;
      setDisplay(btnRemoveLive, gRole.admin || gRole.owner ? "block" : "flex");
    } else {
      hasPermission = false;
      gRole = null;
    }
    setDisplay(btnManageSkd, hasPermission ? "block" : "none");
    initPermissionViews(id);
    setDisplay(imgSettings, isCreator ? "block" : "none");
    setDisplay(divEditInfo, isCreator ? "block" : "none");
    let dGetRadioWidget = document.getElementById("dGetRadioWidget");
    setDisplay(dGetRadioWidget, hasPermission ? "block" : "none");

    if (!gotPermission) {
      gotPermission = true;
      allowLink = allowNum == 2 || (allowNum != 0 && hasPermission);
      if (allowLinkRef == null) {
        allowNum = 1;
        allowLinkRef = firebase.database().ref(`allowLink/${currentChatId}`);
        allowLinkRef.on("value", function (data) {
          if (data.exists()) {
            allowNum = data.val();
            allowLink = allowNum == 2 || (allowNum != 0 && hasPermission);
          } else {
            allowLink = false;
          }
          setLinkRadios();
        });
      }
    }
  });

  //start host/dj listeners
  loadHosts();

  document.getElementById("messageNone").style.display = "block";
  messageNone.textContent = trans.noMessages;
  currentChatRef = firebase.database().ref("Chats/" + currentChatId);
  currentChatRef.limitToLast(30).on("child_added", function (data) {
    document.getElementById("messageNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "radio");
  });

  currentChatRef.limitToLast(30).on("child_changed", function (data) {
    document.getElementById("messageNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "radio");
  });
  currentChatRef.on("child_removed", function (data) {
    deleteElement(data.key);
    var messagesListElement = document.getElementById("radioMessages");

    if (messagesListElement.children.length == 0) {
      document.getElementById("messageNone").style.display = "block";
    }
  });
  if (radioName.includes("-")) {
    radioName = radioName.replace(/-/g, "--");
  }

  var urlName = "chat/" + radioName.replace(/\s+/g, "-");
  window.history.replaceState({}, "", urlName);
  document.title = radioName + " | ChatMurcianys";
  if (currentUserId && userInfo.name) {
    var existsRef = firebase
      .database()
      .ref("Radio Stations/" + currentChatId + "/info/radio_Name");
    existsRef.once("value", function (snapshot) {
      if (snapshot.exists()) {
        disableButton(btnSend, false);
        onlineRef = firebase
          .database()
          .ref(`on/${currentChatId}/${currentUserId}`);
        initOnline();
        startOnlineTimer();
        checkRadioLikes();
      } else {
        removeBkm(currentChatId, true);
      }
    });
  } else {
    pendingRadioUser = true;
  }

  initWatchListener();
  initRadioSkd(new Date().getDay());
}
function setLinkRadios() {
  var linkPList = chatRulesModal.querySelectorAll('input[name="linkP"]');
  linkPList[allowNum < linkPList.length ? allowNum : 1].checked = true;
}
function initPermissionViews(id) {
  if (hasPermission) {
    setDisplay(btnLiveVideo, "block");
    cohostVideoRef = firebase.database().ref("cohost/" + currentChatId);
    setDisplay(btnWatchTogether, "block");
    setDisplay(btnViewUserSkd, "block");
    setDisplay(divDjOptions, "flex");
    //todo: display manage schedule
  } else {
    setDisplay(btnLiveVideo, "none");
    cohostVideoRef = null;
    setDisplay(btnWatchTogether, "none");
    setDisplay(btnViewUserSkd, "none");
    setDisplay(divDjOptions, "none");
  }

  if (!radioStarted) {
    if (hasPermission) {
      radioStarted = true;
      setDisplay(btnTabPet, "block");
      petitionsRef = firebase.database().ref("Petitions/" + currentChatId);

      petitionsRef.on("child_added", function (data) {
        document.getElementById("noRequests").style.display = "none";
        var petition = data.val();
        displayPetition(data.key, petition, hasPermission);
      });

      petitionsRef.on("child_removed", function (data) {
        deleteElement(data.key);
        var petitionsElement = document.getElementById("petitionList");

        if (petitionsElement.children.length < 1) {
          document.getElementById("noRequests").style.display = "block";
        }
      });

      petitionsRef.on("child_changed", function (data) {
        var petition = data.val();
        updatePetition(data.key, petition, hasPermission);
      });
    } else {
      setDisplay(btnTabPet, "none");
      document.getElementById("noRequests").style.display = "block";
      document.getElementById("petitionList").innerHTML = "";
      if (petitionsRef != null) {
        petitionsRef.off();
        petitionsRef = null;
      }
    }

    onlineBroadcastRef = firebase
      .database()
      .ref("Radio Stations/" + currentChatId + "/live");
    onlineBroadcastRef.on("value", function (snapshot) {
      if (snapshot.exists()) {
        radioHost = snapshot.val();
        hostName = radioHost.hostName;

        liveDJ.textContent = trans.live + hostName;
        setDisplay(liveDJ, "block");
        if (hasPermission && currentUserId == radioHost.hostId) {
          btnGoLive.textContent = trans.announceEnd;
          setDisplay(btnGoLive, "block");
          isDjLive = false;
          if (reqVideoRef == null) {
            initLiveVideoReqs();
          }
        } else {
          setDisplay(btnGoLive, "none");
          btnGoLive.textContent = trans.announceLive;
          isDjLive = true;
        }
        if (djConfigRef) {
          djConfigRef.off();
        }
        checkDjConfig(radioHost.hostId);
      } else {
        isDjLive = false;
        if (requestConfig.ads) {
          requestConfig.ads = true;
        }

        setDisplay(liveDJ, "none");
        hostName = "";
        var isDjing = radioHost && radioHost.hostId == currentUserId;
        if (!isDjing && !isMainHost && reqVideoRef != null) {
          reqVideoRef.remove();
          setDisplay(requestDiv, "none");
          requestItems.textContent = "";
          reqVideoRef.off();
          reqVideoRef = null;
        }
        // if (reqVideoRef && radioHost && !isMainHost) {
        //     reqVideoRef.off();
        // }
        radioHost = null;
        if (hasPermission) {
          //was isDJ 12/3/2020
          setDisplay(btnGoLive, "block");
          btnGoLive.textContent = trans.announceLive;
        } else {
          setDisplay(btnGoLive, "none");
        }
        checkRequestsLeft(currentChatId);
        if (requestConfig.max > 1) {
          divReqLeft.textContent = trans.requestsLeftPl.replace(
            "num",
            requestConfig.max
          );
        } else {
          divReqLeft.textContent = trans.requestsLeft.replace(
            "num",
            requestConfig.max
          );
        }
        setDisplay(petitionBox, "none");
        setDisplay(btnNewRequest, "flex");
        setDisplay(divWaitTime, "none");
      }
    });

    //Listen to live video stream
    let divHostName = liveVideoContainerHeader.querySelector(".mainTop");
    liveVideoRef = firebase
      .database()
      .ref("Radio Stations/" + currentChatId + "/liveVideo");
    liveVideoRef.on("value", function (snapshot) {
      if (snapshot.exists()) {
        streamInfo = snapshot.val();
        divHostName.textContent = streamInfo.name;
        isMainHost = currentUserId == streamInfo.hostId;

        if (!isMainHost) {
          //check if cohost is allowed
          if (hasPermission && !isCohost) {
            //&& streamInfo.cohost
            setDisplay(btnLiveVideo, "block");
          } else {
            setDisplay(btnLiveVideo, "none");
          }
          setDisplay(btnStopStream, "none");
        } else if (reqVideoRef == null) {
          //liveRefStarted = true;
          initLiveVideoReqs();
        }

        if (isMainHost && streamInfo.phone) {
          setDisplay(btnLiveVideo, "none");
        }
        if (!isVideoLive) {
          isVideoLive = true;
          joinChannel(false, true);
        }
      } else {
        //streamInfo = null; //set to null to allow leave channel
        var isDjing = radioHost && radioHost.hostId == currentUserId;
        if (!isDjing && !isMainHost && reqVideoRef != null) {
          reqVideoRef.remove();
          setDisplay(requestDiv, "none");
          requestItems.textContent = "";
          reqVideoRef.off();
          reqVideoRef = null;
        }
        isMainHost = false;
        isCohost = false;
        if (isVideoLive) {
          leaveChannel();
          isVideoLive = false;
          setDisplay(liveVideoContainer, "none");
        }
        setDisplay(btnStopStream, "none");
      }
    });

    userReqVideoRef = firebase
      .database()
      .ref(`Radio Stations/${currentChatId}/reqVideo/${currentUserId}`);

    userReqVideoRef.on("value", function (snapshot) {
      if (snapshot.exists()) {
        reqInfo = snapshot.val();
        if (reqInfo.allow) {
          setDisplay(btnCancelReq, "none");
          let topMsg = liveVideoModal.querySelector(".topMessage");
          var xName = hostName ? hostName : streamInfo ? streamInfo.name : "";
          topMsg.textContent = trans.streamAllowed.replace("$name", xName);
          setDisplay(topMsg, "block");
          //btnLiveVideo.click();
          setDisplay(liveVideoModal, "flex");
        } else {
          //stop live streaming if live
          if (isVideoLive && isCohost) {
            btnStopStream.click();
          }
          let topMsg = liveVideoModal.querySelector(".topMessage");
          setDisplay(topMsg, "none");
        }
      } else {
        if (reqInfo && hasPermission) {
          reqInfo = null;
          setDisplay(btnLiveVideo, "block");
          //stop live streaming if live
          if (isVideoLive && isCohost) {
            btnStopStream.click();
          }
          let topMsg = liveVideoModal.querySelector(".topMessage");
          setDisplay(topMsg, "none");
        }
        setDisplay(btnCancelReq, "none");
      }
    });

    //load admins
    loadAdmins();
    //load online users
    loadOnlineUsers();
    var bod = isCreator ? trans.emailBodHelp : trans.emailBody;
    radioInfoModal.querySelector(".redBtn").href =
      "mailto:info@chatmurcianys.com?Subject=RID:%20" +
      id +
      "&body=" +
      bod.replace("userid", currentUserId);
    radioInfoModal.querySelector(".redBtn").textContent = isCreator
      ? trans.radioProblem
      : trans.reportRadio;

    if (hasPermission) {
      btnGoLive.addEventListener("click", function () {
        endMessage.textContent =
          '"' + userInfo.name + " " + trans.isLive + currentRadioName + '"';

        if (hostName != "") {
          //delete live ref
          onlineBroadcastRef.remove(function (error) {
            if (error) {
              //request failed
              showToast(trans.errorMess);
            } else {
              //request sent
              showToast(trans.liveEnded);
            }
          });
        } else {
          //show broadcast dialog
          setDisplay(goLiveModal, "flex");
        }
      });

      btnSendLive.addEventListener("click", function () {
        var host = {
          hostName: userInfo.name,
          hostId: currentUserId,
          date: new Date().getTime(),
          hostImg: userInfo.profileImage ? userInfo.profileImage : null,
        };
        // if (inHostName.value.trim() != "") {
        //     host.hostName = inHostName.value.trim();
        // }

        onlineBroadcastRef.set(host, function (error) {
          if (error) {
            showToast(trans.errorMess);
          } else {
            showToast(trans.liveStarted);
          }
          setDisplay(goLiveModal, "none");
        });
      });
      $(btnEditManageChatRules).off("click");
      $(btnEditManageChatRules).click(function (e) {
        e.stopPropagation();
        setDisplay(chatRulesModal, "flex");
      });
      $(btnInfoManageChatRules).off("click");
      $(btnInfoManageChatRules).click(function (e) {
        e.stopPropagation();
        setDisplay(chatRulesModal, "flex");
      });
    }
  }
}

/**
 * Load skd from a specific day
 * @param {*} day:day of the week
 */
function initRadioSkd(day) {
  var lstDays = divDayCont.querySelectorAll(".seg");
  var nDay = getDayAbbr(day);
  const mDay = day == 0 ? 6 : day - 1;
  var segDay = lstDays[mDay];
  dNone.style.display = segDay.children.length == 0 ? "flex" : "none";
  curDaySeg = mDay;
  showDaySkd(mDay);
  if (daySkdKeyArray.indexOf(nDay) <= 0) {
    daySkdKeyArray.push(nDay);
    var daySkdRef = firebase
      .database()
      .ref(`radioSkd/${currentChatId}/${nDay}`);
    daySkdArray.push(daySkdRef);
    daySkdRef.orderByValue().on("child_added", function (data) {
      if (curDaySeg == mDay && segDay.children.length == 0) {
        setDisplay(dNone, "none");
      }

      getSkd(data.key, segDay, nDay, nDay, false);
    });
    daySkdRef.on("child_removed", function (data) {
      deleteElement(data.key + "radio");
      deleteElement(data.key + "pv");
      deleteElement(data.key + nDay);
      if (curDaySeg == mDay && segDay.children.length == 0) {
        setDisplay(dNone, nDay);
      }
    });
  }
}

/**
 * Determine if schedule is coming up and display in tabRadio
 * @param {*} key skd's key
 * @param {*} data skd's information
 */
function addTodaySkd(key, data) {
  if (skdTodayArray.length == 2) {
    return;
  }
  var mEndNow = formatMilTime(new Date(), true);
  var mStartNow = formatMilTime(new Date(), false);

  var endTime = data.enDate
    ? formatMilTime(new Date(data.enDate), true)
    : data.mEnd
    ? data.mEnd
    : data.mend;
  var startTime = data.stDate
    ? formatMilTime(new Date(data.stDate), false)
    : data.mStart
    ? data.mStart
    : data.mstart;

  if (mEndNow < endTime) {
    //data.mEnd
    //If show has not ended
    if (skdTodayKeyList.indexOf(key) == -1) {
      skdTodayArray.push(data);
      skdTodayKeyList.push(key);
      //var onAir = mStartNow >= data.mStart && mEndNow < data.mEnd;
      var onAir = mStartNow >= startTime && mEndNow < endTime;
      addSkdPv(key + "pv", data, lstSkdNow, onAir);
    }
  }
}

var PV_SKD_TEMP =
  '<div class="light-blue-shadow-btm-round horizFlex centerItems h-item">' +
  '<img class="skd-icon" src="' +
  phImage +
  '" alt="Broadcast icon" width="40px" height="40px">' +
  '<div class="verticalFlex mainTop">' +
  '<p class="mar-unset horizFlex"><span class="on-air"></span> <span class="hours"></span></p>' +
  '<p class="boldText mar-unset name" translate="no"></p>' +
  "</div>" +
  "</div>";

/**
 * Add skd preview to lstSkdNow
 * @param {*} key skd's id
 * @param {*} data skd's information
 */
function addSkdPv(key, data, parent, onAir) {
  const container = document.createElement("div");
  container.innerHTML = PV_SKD_TEMP;
  const div = container.firstChild;
  var oldDiv = document.getElementById(key);
  div.setAttribute("id", key);

  var imgIcon = div.querySelector("img");
  $(imgIcon).on("error", function () {
    imgIcon.src = phImage;
  });

  imgIcon.src = data.icon ? data.icon : phImage;

  // $(div).click(function(e){
  //     e.stopPropagation();
  //     //check if from user (show options)
  // });

  div.querySelector(".name").textContent = data.name;
  var start = data.stDate ? formatTime(new Date(data.stDate)) : data.start;
  var end = data.enDate ? formatTime(new Date(data.enDate)) : data.end;
  div.querySelector(".hours").textContent = start + " - " + end; //data.start + " - " + data.end;
  if (onAir) {
    var elOnAir = div.querySelector(".on-air");
    elOnAir.style.display = "block";
    elOnAir.textContent = trans.onAir;
  }
  if (oldDiv) {
    $(oldDiv).off("click");
    parent.replaceChild(div, oldDiv);
  } else {
    parent.appendChild(div);
  }
}

/**
 * Show specific day segment in divDayContent and
 * mark corresponding day navigation
 * @param {*} day : day of the week
 */
function showDaySkd(day) {
  var navDays = ulDays.querySelectorAll("li");
  navDays.forEach((nav) => {
    nav.className = "";
  });

  navDays[day].className = "sel";

  var daySegs = divDayCont.querySelectorAll(".seg");
  daySegs.forEach((elSeg) => {
    elSeg.style.display = "none";
  });
  daySegs[day].style.display = "block";
}
function stopRadioRefs() {
  if (currentChatRef) {
    currentChatRef.off();
    messageCount = 0;
    document.getElementById("radioMessages").innerHTML = "";
    document.getElementById("normalMessages").innerHTML = "";
  }
  if (participantsRef) {
    participantsRef.off();
    if (participantList.length != 0) {
      participantList = [];
    }
  }
  if (radioLikesRef) {
    radioLikesRef.off();
    radioLikesRef = null;
  }
  if (petitionsRef) {
    document.getElementById("noRequests").style.display = "block";
    document.getElementById("petitionList").innerHTML = "";
    petitionsRef.off();
    petitionsRef = null;
  }
  if (roleRef) {
    roleRef.off();
    roleRef = null;
  }
  if (onlineBroadcastRef) {
    onlineBroadcastRef.off();
    onlineBroadcastRef = null;
  }
  if (djConfigRef) {
    djConfigRef.off();
  }
  if (timeRef) {
    timeRef.off();
  }
  if (vCoinRef) {
    vCoinRef.off();
  }
  if (radioAdminsRef) {
    radioAdminsRef.off();
    divAdminList.textContent = trans.noAdmins;
  }
  if (radioDjsRef) {
    radioDjsRef.off();
    djList.textContent = "";
    divHostList.textContent = trans.noDj;
  }
  if (onlineUsersRef) {
    onlineUsersRef.off();
    divOnlineUsers.textContent = trans.noUsers;
  }
  if (!isMainHost && !isCohost) {
    if (liveVideoRef) {
      liveVideoRef.off();
    }

    if (isVideoLive) {
      isVideoLive = false;
      leaveChannel();
    }
    if (reqVideoRef) {
      reqVideoRef.remove();
      setDisplay(requestDiv, "none");
      requestItems.textContent = "";
      reqVideoRef.off();
      reqVideoRef = null;
    }
  }

  if (watchRef) {
    watchRef.off();
    watchRef = null;
  }

  if (onlineRef) {
    stopOnlineTimer();
  }
}

function stopRefs() {
  hasPermission = false;
  if (allowLinkRef) {
    allowLinkRef.off();
    allowLinkRef = null;
  }
  if (groupRef) {
    groupRef.off();
    groupRef = null;
  }
  groupInfo = null;
  fragsInitiated = false;
  episodeList = [];
  podEpisodeList.innerHTML = "";
  if (userLikeRef) {
    userLikeRef.off();
    userLikeRef = null;
  }
}

function stopRadioSkdRef() {
  if (userSkdRef) {
    userSkdRef.off();
    userSkdRef = null;
    skdList.innerHTML = "";
    setDisplay(skdEmpty, "flex");
  }
  if (groupSkdRef) {
    groupSkdRef.off();
    groupSkdRef = null;
    divAdminSkd.querySelector(".dList").innerHTML = "";
    var dEmpty = divAdminSkd.querySelector(".dEmpty");
    setDisplay(dEmpty, "flex");
  }
  if (daySkdArray.length > 0) {
    daySkdArray.forEach((dataRef) => {
      if (dataRef) {
        dataRef.off();
      }
    });
    daySkdArray = [];
    daySkdKeyArray = [];
  }

  var skdDaysList = divDayCont.querySelectorAll(".seg");
  skdDaysList.forEach((elDay) => {
    elDay.innerHTML = "";
    elDay.style.display = "none";
  });

  skdTodayArray = [];
  skdTodayKeyList = [];
  lstSkdNow.innerHTML = [];
}
function initWatchListener() {
  $(btnCloseYtPlayer).click(function (e) {
    e.stopPropagation();
    if (player != null) {
      player.pauseVideo();
    }
    setDisplay(ytContent, "none");
    setDisplay(imgWatchVideos, "block");
  });
  $(btnRemoveMyVideos).click(function (e) {
    e.stopPropagation();
    if (hasYtVideo) {
      removeUserYtVideos();
    }
  });
  $(btnWatchTogether).click(function (e) {
    e.stopPropagation();
    var checks = divYtSearch.querySelector(".checks");
    setDisplay(
      checks,
      isDjLive && radioHost && radioHost.hostId != currentUserId
        ? "gone"
        : "flex"
    );
    setDisplay(divYtSearch, "flex");
  });
  $(btnWatchAnn).click(function (e) {
    e.stopPropagation();
    // isYtwatching = true;
    // setDisplay(divAnnounce,"none");
    // setDisplay(ytContent,"flex");
    // loadYoutubeVideo(ytVideoIdList[ytVideoList.length - 1]);
    acceptYtInvite(ytVideoList.length - 1);
  });
  $(btnCloseAnn).click(function (e) {
    e.stopPropagation();
    isYtwatching = false;
    setDisplay(divAnnounce, "none");
    setDisplay(imgWatchVideos, "block");
  });

  $(imgWatchVideos).click(function (e) {
    e.stopPropagation();
    if (ytVideoList.length == 0) {
      setDisplay(imgWatchVideos, "none");
      return;
    }
    setDisplay(imgWatchVideos, "none");
    setDisplay(divAnnounce, "flex");
  });
  watchRef = firebase.database().ref(`watch/${currentChatId}`);
  watchRef.on("child_added", function (data) {
    var ytVideo = data.val();
    if (ytVideo != null) {
      var key = data.key;
      ytVideoIdList.push(key);
      ytVideoList.push(ytVideo);

      if (currentUserId == ytVideo.uid) {
        //Show youtube container if not showing
        isYtwatching = true;
        setDisplay(divAnnounce, "none");
        setDisplay(ytContent, "flex");
        videoPlaying = ytVideoList.length - 1;
        loadYoutubeVideo(key);
        hasYtVideo = true;
        if (btnRemoveMyVideos.style.display == "none") {
          setDisplay(btnRemoveMyVideos, "block");
        }
      } else {
        var maxTime = 180000;
        //Check if watching
        if (isYtwatching) {
          if (player != null && player.getPlayerState() != 1) {
            videoPlaying = ytVideoList.length - 1;
            loadYoutubeVideo(key);
          } else if (ytVideo.date && ytVideo.date != 0) {
            var isNew = new Date().getTime() - ytVideo.date <= maxTime;
            if (isNew) {
              acceptYtInvite(ytVideoList.length - 1);
            }
          }
        } else {
          if (ytVideo.date && ytVideo.date != 0) {
            var isNew = new Date().getTime() - ytVideo.date <= maxTime;
            if (isNew) {
              acceptYtInvite(ytVideoList.length - 1);
            } else {
              divAnnInfo.textContent = trans.yt_announce.replace(
                "$name",
                ytVideo.name
              );
              setDisplay(divAnnounce, "flex");
            }
          } else if (imgWatchVideos.style.display == "none") {
            divAnnInfo.textContent = trans.yt_announce.replace(
              "$name",
              ytVideo.name
            );
            setDisplay(divAnnounce, "flex");
          }
        }
      }

      if (ytVideoList.length > 1 && ytVideos.style.display == "none") {
        setDisplay(ytVideos, "flex");
      }

      //add video to ytVideos
      addYtVideo(key, ytVideo, false, "ytVideos");
    }
  });

  watchRef.on("child_changed", function (data) {
    var ytVideo = data.val();
    if (ytVideo != null) {
      var key = data.key;
      var index = ytVideoIdList.indexOf(key);
      if (index >= 0) {
        ytVideoList[index] = ytVideo;
        addYtVideo(key, ytVideo, false, "ytVideos");
        var maxTime = 180000;
        if (videoPlaying != index && ytVideo.date && ytVideo.date != 0) {
          var isNew = new Date().getTime() - ytVideo.date <= maxTime;
          if (isNew) {
            acceptYtInvite(index);
          }
        }
      }
    }
  });

  watchRef.on("child_removed", function (data) {
    if (data.val() != null) {
      var key = data.key;
      var index = ytVideoIdList.indexOf(key);
      if (index >= 0) {
        ytVideoIdList.splice(index, 1);
        ytVideoList.splice(index, 1);
        if (ytVideoList.length <= 0) {
          setDisplay(ytVideos, "none");
        }
        deleteElement(key);
      }

      if (ytVideoList.length == 0) {
        // destroyPlayer();
        clearYtLists();
        hasYtVideo = false;
        setDisplay(imgWatchVideos, "none");
        setDisplay(divAnnounce, "none");
      } else if (videoPlaying == index) {
        playNextVideo();
      }
    }
  });
}

function acceptYtInvite(index) {
  isYtwatching = true;
  setDisplay(divAnnounce, "none");
  setDisplay(ytContent, "flex");
  videoPlaying = index;
  loadYoutubeVideo(ytVideoIdList[index]);
}
function removeUserYtVideos(videoId) {
  if (ytVideoList.length > 0) {
    var userYtKeys = [];
    for (var i = 0; i < ytVideoList.length; i++) {
      var ytVid = ytVideoList[i];
      var key = ytVideoIdList[i];
      if (currentUserId == ytVid.uid) {
        userYtKeys.push(key);
      }
    }
    if (userYtKeys.length > 0) {
      if (videoId == null) {
        for (var j = 0; j < userYtKeys.length; j++) {
          watchRef.child(userYtKeys[j]).remove();
        }
        var message =
          userYtKeys.length > 1
            ? trans.yt_videos_removed.replace("$d", userYtKeys.length)
            : trans.yt_video_removed;
        showToast(message);
      } else {
        watchRef.child(videoId).remove(function (error) {
          if (!error) {
            showToast(trans.yt_video_removed);
          }
        });
        if (userYtKeys.length == 1) {
          hasYtVideo = false;
          setDisplay(btnRemoveMyVideos, "none");
        }
      }
    }
  } else {
    setDisplay(btnRemoveMyVideos, "none");
  }
}

var YT_LIST_TEMPLATE =
  '<div class="horizFlex roundWhiteTrans rel ytVideo point">' +
  '<div class="verticalFlex rel" translate="no">' +
  '<img class="point opas imgThumb" src="' +
  phYTPlayIcon +
  '" alt="video thumbnail" width="60px" height="60px">' +
  '<img class="ytPlay darkTransCircle opas point" src="' +
  phLoading +
  '" width="30px" height="30px">' +
  "</div>" +
  '<div class="verticalFlex videoInfo" translate="no" style="display: none;">' +
  '<div class="title" translate="no"></div>' +
  '<div class="chan" translate="no"></div>' +
  '<div class="desc" translate="no"></div>' +
  "</div>" +
  "</div>";

function addYtVideo(key, data, isSearch, elId) {
  const container = document.createElement("div");
  container.innerHTML = YT_LIST_TEMPLATE;
  const div = container.firstChild;
  var videoList = document.getElementById(elId);
  var oldDiv;
  if (isSearch) {
    oldDiv = document.getElementById(key + "Search");
    div.setAttribute("id", key + "Search");
  } else {
    oldDiv = document.getElementById(key);
    div.setAttribute("id", key);
  }

  var imgVideo = div.querySelector("img");
  var imgPlay = div.querySelector(".ytPlay");
  $(imgVideo)
    .on("error", function () {
      imgVideo.src = phImage;
    })
    .on("load", function () {
      imgPlay.src = phYTPlayIcon;
    });
  var thumbLink = "https://img.youtube.com/vi/videoId/default.jpg";
  imgVideo.src = data.thumb
    ? data.thumb
    : data.videoId
    ? thumbLink.replace("videoId", data.videoId)
    : phImage;

  $(div).click(function (e) {
    e.stopPropagation();
    if (isSearch) {
      sendWatchVideo(key, data);
    } else {
      if (currentUserId == data.uid) {
        hideDropdowns();
        showYtMenuOptions(key, ytVideoContent.querySelector(".options"));
      } else {
        videoPlaying = ytVideoList.indexOf(key);
        loadYoutubeVideo(key);
      }
    }
  });

  if (isSearch && data.title) {
    var divVideoInfo = div.querySelector(".videoInfo");
    setDisplay(divVideoInfo, "flex");

    imgVideo.style.width = "100px";
    imgVideo.style.height = "100px";
    div.querySelector(".title").textContent = data.title;
    div.querySelector(".chan").textContent = data.channel ? data.channel : "";
    div.querySelector(".desc").textContent = data.desc ? data.desc : "";
  }
  if (oldDiv) {
    $(oldDiv).off("click");
    videoList.replaceChild(div, oldDiv);
  } else {
    videoList.appendChild(div);
  }
}

function showYtMenuOptions(key, menu) {
  menu.classList.remove("show");
  setDisplay(menu, "none");

  var options = menu.querySelectorAll(".ytOp");
  $(options[0]).unbind();
  $(options[1]).unbind();
  $(options[2]).unbind();
  $(options[0]).click(function (e) {
    e.stopPropagation();
    loadYoutubeVideo(key);
    menu.classList.remove("show");
    setDisplay(menu, "none");
    $(options[0]).unbind();
  });
  $(options[1]).click(function (e) {
    e.stopPropagation();
    var newDate = new Date().getTime();
    watchRef
      .child(key)
      .child("date")
      .set(newDate, function (error) {
        if (error) {
          showToast(trans.errorMess);
        } else {
          showToast(trans.video_will_play_everyone);
        }
      });
    menu.classList.remove("show");
    setDisplay(menu, "none");
    $(options[1]).unbind();
  });
  $(options[2]).click(function (e) {
    e.stopPropagation();
    removeUserYtVideos(key);

    // if (ytVideoList.length >= 1) {
    //     hasYtVideo = false;
    // }
    menu.classList.remove("show");
    setDisplay(menu, "none");
    $(options[2]).unbind();
  });
  options[0].textContent = trans.play_video;
  options[1].textContent = trans.play_everyone;
  options[2].textContent = trans.remove_video;
  //setDisplay(menu,"flex");
  menu.classList.add("show");
}
function loadYoutubeVideo(videoId) {
  if (player == null) {
    initVideoId = videoId;
    var tag = document.createElement("script");

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // window.onYouTubePlayerAPIReady = function() {

    // };
  } else {
    player.loadVideoById(videoId);
  }
}
window.onYouTubePlayerAPIReady = function () {
  player = new YT.Player("ytPlayer", {
    height: "200",
    width: "300",
    origin: "https://chatmurcianys.com",
    videoId: initVideoId,
    playerVars: { autoplay: 1 },
    events: {
      onReady: onPlayerReady,
      onError: onPlayerError,
      //'onStateChange': onPlayerStateChange
    },
  });
};

function onPlayerReady(event) {
  event.target.playVideo();
}

function onPlayerError(event) {}
function playNextVideo() {
  if (player == null) {
    return;
  }
  var size = ytVideoList.length;
  if (size > 1) {
    if (videoPlaying < size - 1) {
      videoPlaying++;
    } else {
      videoPlaying = 0;
    }
    player.loadVideoById(ytVideoList[videoPlaying].videoId);
    //player.cueVideoById();
  } else if (size == 1) {
    videoPlaying = 0;
    player.loadVideoById(ytVideoList[videoPlaying].videoId);
  }
}

function destroyPlayer() {
  if (player != null) {
    player.removeEventListener("onReady", onPlayerReady);
    player.removeEventListener("onError", onPlayerError);
    player.destroy();
    player = null;
  }
}

function clearYtLists() {
  isYtwatching = false;
  hasYtVideo = false;
  ytVideoList = [];
  ytVideoIdList = [];
  videoPlaying = -1;
  setDisplay(imgWatchVideos, "none");
  setDisplay(divAnnounce, "none");
  //ytPlayer.innerHTML = "";
  ytVideos.innerHTML = "";
  setDisplay(ytContent, "none");
  if (player != null) {
    player.pauseVideo();
  }
}

function initLiveVideoReqs() {
  reqVideoRef = firebase
    .database()
    .ref(`Radio Stations/${currentChatId}/reqVideo`);
  reqVideoRef.on("child_added", function (data) {
    if (requestItems.children.length == 0) {
      setDisplay(requestDiv, "block");
    }
    //add to #requestItems
    addRequestItem(data.key, data.val());
    var attSound = new Audio(sndAttention);
    attSound.loop = false;
    attSound.play();
  });
  reqVideoRef.on("child_changed", function (data) {
    //add to #requestItems
    addRequestItem(data.key, data.val());
  });
  reqVideoRef.on("child_removed", function (data) {
    deleteElement(data.key + "vidReq");
    if (requestItems.children.length == 0) {
      setDisplay(requestDiv, "none");
    }
  });
}
var REQUEST_TEMPLATE =
  '<div class="horizFlex">' +
  '<img src="images/person_placeholder.svg" alt="profile image" width="40px" height="40px">' +
  '<span class="name boldText whiteText mainTop">Name</span>' +
  '<div class="verticalFlex">' +
  '<button class="allow" title="Allow"></button>' +
  '<button class="decline" title="Decline"></button>' +
  "</div>" +
  "</div>";
function addRequestItem(id, data) {
  if (!data.name || !id) {
    return;
  }
  const container = document.createElement("div");
  container.innerHTML = REQUEST_TEMPLATE;
  const div = container.firstChild;
  var requestList = document.getElementById("requestItems");
  var oldDiv = document.getElementById(id + "vidReq");

  div.setAttribute("id", id + "vidReq");
  //init content from data
  let imgUser = div.querySelector("img");
  let uName = div.querySelector("span");
  let btnAllow = div.querySelector(".allow");
  let btnDecline = div.querySelector(".decline");
  btnAllow.textContent = trans.allow;
  btnDecline.textContent = trans.decline;
  $(imgUser).on("error", function () {
    imgUser.src = phPersonImg;
  });
  imgUser.src = data.profile_Image ? data.profile_Image : phPersonImg;
  uName.textContent = data.name;
  setDisplay(btnAllow, data.allow ? "none" : "block");
  $(btnAllow).off("click");
  $(btnDecline).off("click");
  btnAllow.addEventListener("click", function () {
    var reqRef;
    if (!reqVideoRef) {
      reqRef = firebase
        .database()
        .ref(`Radio Stations/${currentChatId}/reqVideo/${id}/allow`);
    } else {
      reqRef = reqVideoRef.child(id + "/allow");
    }
    reqRef.set(true, function (error) {
      if (error) {
        showToast(trans.errorMess);
      } else {
        showToast(trans.permissionGranted);
        setDisplay(btnAllow, "none");
        $(btnAllow).off("click");
        btnDecline.textContent = trans.stop;
      }
    });
  });

  btnDecline.addEventListener("click", function () {
    var reqRef;
    if (reqVideoRef == null) {
      reqRef = firebase
        .database()
        .ref(`Radio Stations/${currentChatId}/reqVideo/${id}`); ///allow`);
    } else {
      reqRef = reqVideoRef.child(id); //.child("allow");
    }
    reqRef.remove();
  });

  if (oldDiv) {
    requestList.replaceChild(div, oldDiv);
  } else {
    requestList.appendChild(div);
  }
}

function loadAdmins() {
  divAdminList.textContent = trans.noAdmins;
  radioAdminsRef = firebase.database().ref(`admin/${currentChatId}`);
  //.ref("Radio Stations/" + currentChatId + "/Administrators");
  radioAdminsRef.on("child_added", function (data) {
    if (divAdminList.children.length == 0) {
      divAdminList.textContent = "";
    }
    displayAdmin(data.key, data.val());
  });
  radioAdminsRef.on("child_changed", function (data) {
    displayAdmin(data.key, data.val());
  });
  radioAdminsRef.on("child_removed", function (data) {
    deleteElement(data.key + "admin");
    if (divAdminList.children.length == 0) {
      divAdminList.textContent = trans.noAdmins;
    }
  });
}
function displayAdmin(key, admin) {
  if (!admin.name) {
    return;
  }
  const container = document.createElement("div");
  container.innerHTML = SMALL_TEMPLATE;
  const div = container.firstChild;
  var adminList = document.getElementById("divAdminList");
  var oldDiv = document.getElementById(key + "admin");
  div.setAttribute("id", key + "admin");

  var imgDj = div.querySelector(".img-circle");
  $(imgDj).on("error", function () {
    imgDj.src = phPersonImg;
  });
  imgDj.src = admin.img ? admin.img : phPersonImg;
  div.querySelector(".name").textContent = admin.name;

  $(div).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    imgHolder.src = imgDj.src;
    setDisplay(largeImageView, "flex");
    magnify("imgHolder", 3);
  });

  if (oldDiv) {
    $(oldDiv).off("click");
    adminList.replaceChild(div, oldDiv);
  } else {
    adminList.appendChild(div);
  }
}

function loadOnlineUsers() {
  console.log("loading online users");
  var divOnlineUsers = document.getElementById("divOnlineUsers");
  divOnlineUsers.textContent = trans.noUsers;
  onlineUsersRef = firebase.database().ref(`on/${currentChatId}`);
  onlineUsersRef.on("child_added", function (data) {
    getUserInfo(data.key, data.val());
  });

  onlineUsersRef.on("child_removed", function (data) {
    deleteElement(data.key + "online");
    if (divOnlineUsers.children.length == 0) {
      divOnlineUsers.textContent = trans.noUsers;
    }
  });
}

function getUserInfo(key, date) {
  const divOnlineUsers = document.getElementById("divOnlineUsers");
  var userRef = firebase.database().ref(`Users/${key}/info`);
  userRef.once("value", function (data) {
    if (data.exists) {
      if (divOnlineUsers.children.length == 0) {
        divOnlineUsers.textContent = "";
      }
      addOnlineUser(key, date, data.val());
    }
  });
}
function addOnlineUser(key, date, user) {
  console.log("userid: " + key + " current: " + currentUserId);
  if (!user.name) {
    return;
  }
  const container = document.createElement("div");
  container.innerHTML = PROFILE_TEMPLATE;
  const div = container.firstChild;
  var onlineList = document.getElementById("divOnlineUsers");
  var oldDiv = document.getElementById(key + "online");
  div.setAttribute("id", key + "online");

  var imgUser = div.querySelector(".pic");
  $(imgUser).on("error", function () {
    imgUser.src = phPersonImg;
  });
  imgUser.src = user.profile_Image ? user.profile_Image : phPersonImg;
  var divName = div.querySelector(".name");
  divName.textContent = user.name;

  $(div).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    imgHolder.src = imgUser.src;
    setDisplay(largeImageView, "flex");
    magnify("imgHolder", 3);
  });

  if (oldDiv) {
    $(oldDiv).off("click");
    onlineList.replaceChild(div, oldDiv);
  } else if (currentUserId == key) {
    console.log("same as online user");
    divName.textContent = user.name + " (" + trans.you + ")";
    onlineList.insertBefore(div, onlineList.children[0]);
  } else {
    console.log("not same as online user");
    onlineList.appendChild(div);
  }
}
function loadHosts() {
  divHostList.textContent = trans.noDj;
  radioDjsRef = firebase.database().ref(`dj/${currentChatId}`);
  //.ref("Radio Stations/" + currentChatId + "/DJs");
  radioDjsRef.on("child_added", function (data) {
    displayHost(data.key, data.val(), false);
    setDisplay(djs, "block");
    if (divHostList.children.length == 0) {
      divHostList.textContent = "";
    }
    displayHost(data.key, data.val(), true);
    //hostArray.push(data.val());
    hostKeyArray.push(data.key);
  });
  radioDjsRef.on("child_changed", function (data) {
    displayHost(data.key, data.val(), false);
    displayHost(data.key, data.val(), true);
  });
  radioDjsRef.on("child_removed", function (data) {
    deleteElement(data.key + "host");
    if (djList.children.length == 0) {
      setDisplay(djs, "none");
    }
    deleteElement(data.key + "hostMod");
    if (hostKeyArray.includes(data.key)) {
      var index = hostKeyArray.indexOf(data.key);
      hostKeyArray.splice(index, 1);
      //hostArray.splice(index,1);
    }
    if (divHostList.children.length == 0) {
      divHostList.textContent = trans.noDj;
    }
  });
}

function displayHost(key, host, forModal) {
  if (!host.name) {
    return;
  }
  const container = document.createElement("div");
  container.innerHTML = SMALL_TEMPLATE;
  const div = container.firstChild;
  var hostList;
  var oldDiv;
  if (forModal) {
    hostList = document.getElementById("divHostList");
    oldDiv = document.getElementById(key + "hostMod");
    div.setAttribute("id", key + "hostMod");
  } else {
    hostList = document.getElementById("djList");
    oldDiv = document.getElementById(key + "host");
    div.setAttribute("id", key + "host");
  }

  var imgDj = div.querySelector(".img-circle");
  $(imgDj).on("error", function () {
    imgDj.src = phPersonImg;
  });
  imgDj.src = host.img ? host.img : phPersonImg;
  div.querySelector(".name").textContent = host.name;

  $(div).click(function (e) {
    e.stopPropagation();
    //show bigger picture;
    imgHolder.src = imgDj.src;
    setDisplay(largeImageView, "flex");
    magnify("imgHolder", 3);
  });

  if (oldDiv) {
    $(oldDiv).off("click");
    hostList.replaceChild(div, oldDiv);
  } else {
    hostList.appendChild(div);
  }
}

function checkDjConfig(hostId) {
  timeRef = firebase
    .database()
    .ref(
      "v-coins/" + currentChatId + "/" + hostId + "/" + currentUserId + "/time"
    );
  djConfigRef = firebase
    .database()
    .ref("config_pet/" + currentChatId + "/" + hostId);
  djConfigRef.on("value", function (data) {
    if (data.exists()) {
      requestConfig = data.val();
    } else {
      requestConfig = reqDefaultConfig;
    }

    if (requestConfig.allow) {
      checkRequestsLeft(hostId);
    } else {
      divReqLeft.textContent = "";
      setDisplay(divWaitTime, "none");
    }
  });
}

function checkRequestsLeft(hostId) {
  if (!timeRef) {
    timeRef = firebase
      .database()
      .ref(
        "v-coins/" +
          currentChatId +
          "/" +
          hostId +
          "/" +
          currentUserId +
          "/time"
      );
  }
  vCoinRef = firebase
    .database()
    .ref(
      "v-coins/" + currentChatId + "/" + hostId + "/" + currentUserId + "/count"
    );
  vCoinRef.once("value", function (data) {
    if (data.exists()) {
      vCoins = data.val();
    } else {
      vCoins = reqDefaultConfig.max;
    }

    if (vCoins > 1) {
      divReqLeft.textContent = trans.requestsLeftPl.replace("num", vCoins);
    } else {
      divReqLeft.textContent = trans.requestsLeft.replace("num", vCoins);
    }
    if (vCoins <= 0) {
      if (requestConfig.ads) {
        setDisplay(divWaitTime, "none");
        setDisplay(btnWatchAd, "flex");
        setDisplay(divAdNote, "block");
        setDisplay(divAdParent, "block");
      } else {
        checkTimeLeft();
      }
    } else if (vCoins < requestConfig.max) {
      if (requestConfig.ads) {
        setDisplay(divWaitTime, "none");
        setDisplay(btnWatchAd, "flex");
        setDisplay(divAdNote, "block");
        setDisplay(divAdParent, "block");
      }
    } else {
      setDisplay(divWaitTime, "none");
      setDisplay(btnWatchAd, "none");
      setDisplay(divAdNote, "none");
      setDisplay(divAdParent, "none");
    }
  });
}
function checkTimeLeft() {
  timeRef.once("value", function (data) {
    var now = new Date().getTime();
    if (data.exists()) {
      unlockTime = data.val();
      if (unlockTime > now + requestConfig.time * 60000) {
        unlockTime = now + requestConfig.time * 60000;
        timeRef.set(unlockTime);
      }
    } else {
      unlockTime = now + requestConfig.time * 60000;
      timeRef.set(unlockTime);
    }
    if (now >= unlockTime) {
      setDisplay(divWaitTime, "none");
      vCoins = requestConfig.max;
      if (vCoins > 1) {
        divReqLeft.textContent = trans.requestsLeftPl.replace("num", vCoins);
      } else {
        divReqLeft.textContent = trans.requestsLeft.replace("num", vCoins);
      }
    } else {
      setDisplay(divWaitTime, "block");
      divWaitTime.textContent = trans.waitTime.replace(
        "$time",
        formatMessageDate(new Date(unlockTime))
      );
    }
  });
}
function checkRadioLikes() {
  var divLike = divFavorite.querySelector("div");
  var imgLike = divFavorite.querySelector("img");
  var userFavRef = firebase
    .database()
    .ref("Users/" + currentUserId + "/Favorite Radios/" + currentChatId);
  var radioUserLikesRef = firebase
    .database()
    .ref(
      "Radio Stations/" + currentChatId + "/Likes/" + currentUserId + "/user_ID"
    );
  userFavRef.once("value", function (snapshot) {
    setDisplay(divFavorite, "flex");
    isFavorite = snapshot.exists();
    if (isFavorite) {
      divLike.textContent = trans.unfavorite;
      imgFavorite.title = trans.unfavorite;
      imgLike.src = HeartIcon;
      imgFavorite.src = HeartIcon;
      divFavorite.className = divFavorite.className.replace(
        "btn-blue",
        "btn-gray"
      );
      setDisplay(divFavorite, "none");
    } else {
      divLike.textContent = trans.favorite;
      imgFavorite.title = trans.favorite;
      imgLike.src = grayHeartIcon;
      imgFavorite.src = grayHeartIcon;
      divFavorite.className = divFavorite.className.replace(
        "btn-gray",
        "btn-blue"
      );
      setDisplay(divFavorite, "flex");
    }
  });

  divFavorite.addEventListener("click", function () {
    toggleFavorite(divLike, imgLike, radioUserLikesRef, userFavRef);
  });
  imgFavorite.addEventListener("click", function () {
    toggleFavorite(divLike, imgLike, radioUserLikesRef, userFavRef);
  });
}

function toggleFavorite(divLike, imgLike, radioUserLikesRef, userFavRef) {
  if (isFavorite) {
    //remove from favorites
    radioUserLikesRef.remove();
    userFavRef.remove();
    divLike.textContent = trans.favorite;
    imgFavorite.title = trans.favorite;
    imgLike.src = grayHeartIcon;
    imgFavorite.src = grayHeartIcon;
    divFavorite.className = divFavorite.className.replace(
      "btn-gray",
      "btn-blue"
    );
    isFavorite = false;
    setDisplay(divFavorite, "none");
  } else {
    //add to favorites
    radioUserLikesRef.set(currentUserId);
    userFavRef.child("radio_ID").set(currentChatId);
    divLike.textContent = trans.unfavorite;
    imgFavorite.title = trans.unfavorite;
    imgLike.src = HeartIcon;
    imgFavorite.src = HeartIcon;
    divFavorite.className = divFavorite.className.replace(
      "btn-blue",
      "btn-gray"
    );
    isFavorite = true;
    setDisplay(divFavorite, "flex");
  }
}
function displayMessage(key, chatMessage, chatType) {
  if (chatMessage.type !== "Text" && !chatMessage.isUploaded) {
    if (chatMessage.type !== "SongRequest") {
      return;
    }
  }

  const container = document.createElement("div");
  var messagesElementList;
  var div;
  var mainElement;
  switch (chatType) {
    case "radio":
      messagesElementList = document.getElementById("radioMessages");
      break;
    case "private":
    case "group":
      messagesElementList = document.getElementById("normalMessages");
      break;
    case "podcast":
      messagesElementList = document.getElementById("podMsgList");
      break;
  }

  var isCurrentUser = currentUserId === chatMessage.userId;
  var message = "";

  switch (chatMessage.type) {
    case "Text":
      if (isCurrentUser) {
        container.innerHTML = MESSAGE_SENT;
      } else {
        container.innerHTML = MESSAGE_RECEIVED;
      }

      div = container.firstChild;
      break;
    case "SongRequest":
      if (isCurrentUser) {
        container.innerHTML = MESSAGE_SENT;
      } else {
        container.innerHTML = MESSAGE_RECEIVED;
      }

      div = container.firstChild;
      if (chatMessage.requesterName) {
        if (
          chatMessage.textMessage &&
          !chatMessage.textMessage.includes(chatMessage.requesterName)
        ) {
          message = chatMessage.requesterName + "<br>";
        }
      }
      mainElement = div.querySelector(".message-container");
      mainElement.className += " request";

      div.className += " request";
      break;
    case "Audio":
      if (isCurrentUser) {
        container.innerHTML = AUDIO_SENT;
      } else {
        container.innerHTML = AUDIO_RECEIVED;
      }
      div = container.firstChild;
      div.querySelector(".mAudio").src = chatMessage.audioFile;
      message =
        trans.voiceMessage + " (" + getAudioTime(chatMessage.audioLength) + ")";

      var imgDownload = div.querySelector(".dow");
      imgDownload.title = trans.download;
      imgDownload.addEventListener(
        "click",
        function () {
          window.onunload = null;
          window.onbeforeunload = null;
          saveFile("AUD" + key + ".m4a", chatMessage.audioFile);
          window.onunload = noTimeout;
          window.onbeforeunload = warning;
        },
        false
      );
      break;
    case "Picture":
    case "TextPicture":
      if (isCurrentUser) {
        container.innerHTML = PICTURE_SENT;
      } else {
        container.innerHTML = PICTURE_RECEIVED;
      }
      div = container.firstChild;
      // if(chatMessage.phoneFilePath && chatMessage.phoneFilePath.includes(".gif")){
      // }
      var imageElement = div.querySelector(".picture");
      imageElement.addEventListener("load", function () {
        scrollBottom(chatType);
      });
      imageElement.src = chatMessage.filePath;
      imageElement.addEventListener("click", function () {
        imgHolder.src = chatMessage.filePath;
        setDisplay(largeImageView, "flex");
        magnify("imgHolder", 3);
      });

      message = trans.picture;

      var imgDownload = div.querySelector(".dow");
      imgDownload.title = trans.download;
      imgDownload.addEventListener(
        "click",
        function () {
          window.onunload = null;
          window.onbeforeunload = null;
          var fileName;
          if (chatMessage.phoneFilePath) {
            fileName = chatMessage.phoneFilePath.includes(".gif")
              ? "GIF" + key + ".gif"
              : "IMG" + key + ".png";
          } else {
            fileName = "IMG" + key + ".png";
          }

          saveFile(fileName, chatMessage.filePath);
          window.onunload = noTimeout;
          window.onbeforeunload = warning;
        },
        false
      );
      break;
    case "Video":
    case "TextVideo":
      if (isCurrentUser) {
        container.innerHTML = VIDEO_SENT;
      } else {
        container.innerHTML = VIDEO_RECEIVED;
      }
      div = container.firstChild;
      var videoElement = div.querySelector(".videoContent");
      videoElement.src = chatMessage.filePath;
      videoElement.addEventListener("load", function () {
        scrollBottom(chatType);
      });
      message = trans.video + " (" + chatMessage.videoLength + ")";

      var imgDownload = div.querySelector(".dow");
      imgDownload.title = trans.download;
      imgDownload.addEventListener(
        "click",
        function () {
          window.onunload = null;
          window.onbeforeunload = null;
          saveFile("VID" + key + ".mp4", chatMessage.filePath);
          window.onunload = noTimeout;
          window.onbeforeunload = warning;
        },
        false
      );
      break;
    case "Gif":
    case "TextGif":
      if (isCurrentUser) {
        container.innerHTML = GIF_SENT;
      } else {
        container.innerHTML = GIF_RECEIVED;
      }
      div = container.firstChild;
      var gifElement = div.querySelector(".gif");
      $(gifElement).on("load", function () {
        scrollBottom(chatType);
      });
      gifElement.src = chatMessage.filePath;
      gifElement.addEventListener("click", function () {
        imgHolder.src = chatMessage.filePath;
        setDisplay(largeImageView, "flex");
        magnify("imgHolder", 3);
      });
      // new Freezeframe(gifElement,{
      //     overlay: true,
      //     responsive: false
      // });
      //message = trans.gif;
      if (chatMessage.filePath.includes("giphy")) {
        var brand = div.querySelector(".brand");
        setDisplay(brand, "block");
      }

      var imgDownload = div.querySelector(".dow");
      imgDownload.title = trans.download;
      imgDownload.addEventListener(
        "click",
        function () {
          window.onunload = null;
          window.onbeforeunload = null;

          saveFile("GIF" + key + ".gif", chatMessage.filePath);
          window.onunload = noTimeout;
          window.onbeforeunload = warning;
        },
        false
      );
      break;
  }
  var oldDiv = document.getElementById(key);
  div.setAttribute("id", key);

  if (chatMessage.textMessage) {
    message += chatMessage.textMessage
      .replace("</p>", "</div>")
      .replace("<p", "<div")
      .replace("font-family:'.Helvetica Neue Interface';font-size:16px;", "")
      .replace('style="color:#000000;"', "")
      .replace('style="margin-bottom:16px;"', "");
    var textElement = div.querySelector(".message");

    if (chatMessage.note) {
      if (message.includes("@")) {
        message = message
          .replace("@25", trans.voiceCall)
          .replace("@26", trans.videoCall)
          .replace("@30", trans.missedCall);
      } else {
        message = message
          .replace("25", trans.voiceCall)
          .replace("26", trans.videoCall)
          .replace("30", trans.missedCall);
      }
    }
    if (message.length < 8) {
      textElement.style.fontSize = "20px";
    }
    //font-family:\'.Helvetica Neue Interface\';font-size:16px; //font-size:16px;
    textElement.innerHTML = linkify(message); //message;
    //textElement.innerHTML = linkify(chating);
    // var linkify = require('linkifyjs');
  }

  var rNameElement = div.querySelector(".rName");
  var rMessageElement = div.querySelector(".rMessage");
  if (chatMessage.isReply) {
    var replyElement = div.querySelector(".reply");
    if (chatMessage.reSenderId != currentUserId) {
      rNameElement.textContent = chatMessage.reSenderName;
    } else {
      rNameElement.textContent = trans.you;
    }

    switch (chatMessage.reType) {
      case "Text":
      case "SongRequest":
        rMessageElement.innerHTML = chatMessage.reText.replace(/\s/g, " ");
        break;
      case "Audio":
        rMessageElement.innerHTML =
          trans.voiceMessage + " (" + chatMessage.reMediaLength + ")";
        break;
      case "Picture":
        rMessageElement.innerHTML = trans.picture;
        break;
      case "TextPicture":
        rMessageElement.innerHTML = trans.picture + ": " + chatMessage.reText;
        break;
      case "Video":
        rMessageElement.innerHTML = trans.video;
        break;
      case "TextVideo":
        rMessageElement.innerHTML = trans.video + ": " + chatMessage.reText;
        break;
      case "Gif":
        rMessageElement.innerHTML = trans.gif;
        break;
      case "TextGif":
        rMessageElement.innerHTML = trans.gif + ": " + chatMessage.reText;
        break;
    }

    replyElement.addEventListener(
      "click",
      function () {
        var replyId = chatMessage.reMessageKey;
        document.getElementById(replyId).scrollIntoView();
      },
      false
    );
  }

  var dateElement = div.querySelector(".date");
  var timeElement = div.querySelector(".time");
  var messageTime = new Date(chatMessage.messageTime);

  if (!isCurrentUser) {
    var nameElement = div.querySelector(".name");
    nameElement.textContent = chatMessage.userName;
    if (!userArray.includes(chatMessage.userId)) {
      if (!mainElement) {
        mainElement = div.querySelector(".message-container");
      }
      var userColor = randomColor({
        luminosity: "dark",
      });
      mainElement.style.boxShadow = "3px 3px 5px " + userColor;
      nameElement.style.color = userColor;
      userArray.push(chatMessage.userId);
      colorArray.push(userColor);
    } else {
      if (!mainElement) {
        mainElement = div.querySelector(".message-container");
      }
      var userColor = colorArray[userArray.indexOf(chatMessage.userId)];
      //mainElement.style.borderColor = userColor;
      mainElement.style.boxShadow = "3px 3px 5px " + userColor;
      nameElement.style.color = userColor;
    }
    nameElement.addEventListener("click", function () {
      setDisplay(loaderModal, "flex");
      getChatUserInfo(chatMessage.userId);
    });
  }

  if (lastDate) {
    if (sameDay(messageTime, lastDate)) {
      dateElement.style.display = "none";
    } else {
      var data = formatMessageDate(
        new Date(chatMessage.messageTime),
        trans.language
      );
      dateElement.textContent =
        data == "Today"
          ? trans.today
          : data == "Yesterday"
          ? trans.yesterday
          : data;
    }
  } else {
    dateElement.textContent = formatMessageDate(
      new Date(chatMessage.messageTime)
    );
  }

  lastDate = messageTime;
  timeElement.textContent = formatTime(messageTime);
  var mReply = div.querySelector(".messageReply");
  mReply.textContent = trans.reply;
  mReply.addEventListener(
    "click",
    function () {
      rKey = key;
      rMessage = chatMessage;
      if (!isCurrentUser) {
        replyContent.querySelector(".rName").textContent = chatMessage.userName;
      } else {
        replyContent.querySelector(".rName").textContent = trans.you;
      }
      if (chatMessage.type.includes("Text")) {
        message = message.replace(/60px/g, "20px");
        message = message.replace(/16px/g, "0");
        message = message.replace(/<br \\>/g, "...");
        chatMessage.textMessage = message;
      }

      replyContent.querySelector(".rMessage").innerHTML = message;
      setDisplay(replyContent, "flex");
      setTimeout(function () {
        $(textContainer).focus();
      }, 100);
    },
    false
  );
  var imgReply = div.querySelector(".rep");
  imgReply.title = trans.reply;
  imgReply.addEventListener(
    "click",
    function () {
      rKey = key;
      rMessage = chatMessage;
      if (!isCurrentUser) {
        replyContent.querySelector(".rName").textContent = chatMessage.userName;
      } else {
        replyContent.querySelector(".rName").textContent = trans.you;
      }
      if (chatMessage.type.includes("Text")) {
        message = message.replace(/60px/g, "20px");
        message = message.replace(/16px/g, "0");
        message = message.replace(/<br \\>/g, "...");
        chatMessage.textMessage = message;
      }

      replyContent.querySelector(".rMessage").innerHTML = message;
      setDisplay(replyContent, "flex");
      setTimeout(function () {
        $(textContainer).focus();
      }, 100);
    },
    false
  );
  var imgForward = div.querySelector(".for");
  imgForward.title = trans.forward;
  var imgShare = div.querySelector(".sha");
  imgShare.title = trans.share;

  if (oldDiv) {
    messagesElementList.replaceChild(div, oldDiv);
  } else {
    messagesElementList.appendChild(div);
  }

  //setTimeout(function() {div.classList.add('visible')}, 1);
  scrollBottom(chatType);
}

function getChatUserInfo(friendId) {
  //else, get user profile info
  var currentUserInfo = {
    email: userInfo.email,
    name: userInfo.name,
    lowCaseName: userInfo.name.toLowerCase(),
    profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
    message: null,
    date_created: null,
  };
  var friendType;
  if (document.getElementById(friendId + "friend")) {
    friendType = "friend";
  } else if (document.getElementById(friendId + "reqin")) {
    friendType = "in";
  } else if (document.getElementById(friendId + "reqout")) {
    friendType = "out";
  } else {
    friendType = "new";
  }
  if (chatUserKeyArray.includes(friendId)) {
    var friendInfo = chatUserArray[chatUserKeyArray.indexOf(friendId)];
    initChatUserModal(friendId, currentUserInfo, friendInfo, friendType);
  } else {
    var userRef = firebase.database().ref("Users/" + friendId + "/info");
    userRef.once("value", function (data) {
      if (data.exists()) {
        var user = data.val();
        var friendInfo = {
          email: user.email,
          name: user.name,
          lowCaseName: user.lowCaseName,
          profile_Image: user.profile_Image ? user.profile_Image : null,
          message: null,
          date_created: null,
        };

        chatUserKeyArray.push(friendId);
        chatUserArray.push(friendInfo);
        initChatUserModal(friendId, currentUserInfo, friendInfo, friendType);
      }
    });
  }
}
function initChatUserModal(friendId, currentUserInfo, friendInfo, friendType) {
  var imgFriend = chatUserModal.querySelector("img");
  var divName = chatUserModal.querySelector(".name");
  var options = chatUserModal.querySelectorAll(".options");
  var btnAddFriend = options[0];
  var btnReject = options[1];
  setDisplay(btnReject, "none");
  if (friendInfo.profile_Image) {
    imgFriend.src = friendInfo.profile_Image;
  } else {
    imgFriend.src = phPersonImg;
  }
  divName.textContent = friendInfo.name;
  switch (friendType) {
    case "in":
      btnAddFriend.textContent = trans.acceptReq;
      setDisplay(btnReject, "block");
      btnReject.addEventListener("click", function () {
        rejectFriendRequest(friendId, friendInfo);
      });
      break;
    case "out":
      btnAddFriend.textContent = trans.cancelReq;
      break;
    case "friend":
      btnAddFriend.textContent = trans.unfriend;
      break;
    default:
      //new: send friend request
      btnAddFriend.textContent = trans.sendFriendReq;
      break;
  }
  btnAddFriend.addEventListener("click", function () {
    setDisplay(chatUserModal, "none");
    switch (friendType) {
      case "in":
        //add to friends
        acceptFriendRequest(friendId, currentUserInfo, friendInfo);
        break;
      case "out":
        //remove from requests sent
        cancelFriendRequest(friendId, friendInfo);
        break;
      case "friend":
        //remove from friends
        showConfirmModal(friendId, friendInfo.name, friendInfo);
        //removeFriend(friendId, friendInfo.name);
        break;
      default:
        //new: send friend request
        //send friend request
        if (requestmessage) {
          showMessageDialog(friendId, currentUserInfo, friendInfo);
        } else {
          sendFriendRequest(friendId, currentUserInfo, friendInfo);
        }
        break;
    }
  });
  setDisplay(loaderModal, "none");
  setDisplay(chatUserModal, "flex");
}

function removeFriend(friendId, name, friendInfo) {
  showToast(trans.removingFriend.replace("$name", name));
  var friendFriendRef = firebase
    .database()
    .ref("Users/" + friendId + "/Friends/" + currentUserId);
  friendFriendRef.remove(function (error) {
    if (!error) {
      var userFriendRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/Friends/" + friendId);
      userFriendRef.remove(function (error) {
        if (!error) {
          var userBmkRef = firebase
            .database()
            .ref("Users/" + currentUserId + "/Chat_Bookmarks/" + friendId);
          userBmkRef.remove(function () {
            var friendBmkRef = firebase
              .database()
              .ref("Users/" + friendId + "/Chat_Bookmarks/" + currentUserId);
            friendBmkRef.remove(function () {
              var userChatRef = firebase
                .database()
                .ref("PrivateChat/" + currentUserId + "/" + friendId);
              userChatRef.remove(function () {
                var relationRef = firebase.database().ref("relation");
                relationRef
                  .child(currentUserId + "/" + friendId)
                  .set("UNKNOWN", function () {
                    relationRef
                      .child(friendId + "/" + currentUserId)
                      .set("UNKNOWN", function () {
                        showToast(trans.friendRemoved.replace("$name", name));
                        if (document.getElementById(friendId + "search")) {
                          editDivAction(friendId, friendInfo, "add");
                        }
                      });
                  });
              });
            });
          });
        }
      });
    }
  });
}
function acceptFriendRequest(friendId, currentUserInfo, friendInfo) {
  var friendFriendRef = firebase
    .database()
    .ref("Users/" + friendId + "/Friends/" + currentUserId);
  showToast(trans.addingFriend.replace("$name", friendInfo.name));
  var time = new Date().getTime();
  friendInfo.date_created = time;
  currentUserInfo.date_created = time;
  friendFriendRef.set(time, function (error) {
    //currentUserInfo
    if (!error) {
      var userFriendRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/Friends/" + friendId);
      userFriendRef.set(time, function (error) {
        //friendInfo
        if (!error) {
          var friendRef = firebase
            .database()
            .ref("Users/" + friendId + "/FriendRequests/Sent/" + currentUserId);
          friendRef.remove(function (error) {
            if (!error) {
              var userRef = firebase
                .database()
                .ref(
                  "Users/" +
                    currentUserId +
                    "/FriendRequests/Received/" +
                    friendId
                );
              userRef.remove(function (error) {
                if (!error) {
                  var relationRef = firebase.database().ref("relation");
                  relationRef
                    .child(currentUserId + "/" + friendId)
                    .set("FRIEND", function (error) {
                      if (!error) {
                        relationRef
                          .child(friendId + "/" + currentUserId)
                          .set("FRIEND", function () {
                            if (!error) {
                              showToast(
                                trans.newFriend.replace(
                                  "$name",
                                  friendInfo.name
                                )
                              );
                              if (
                                document.getElementById(friendId + "search")
                              ) {
                                editDivAction(friendId, friendInfo, "remove");
                              }
                            }
                          });
                      }
                    });
                }
              });
            }
          });
        }
      });
    }
  });
}
function cancelFriendRequest(friendId, friendInfo) {
  var friendRef = firebase
    .database()
    .ref("Users/" + friendId + "/FriendRequests/Received/" + currentUserId);
  friendRef.remove(function (error) {
    if (error) {
      showToast(trans.errorMess);
    } else {
      var userRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/FriendRequests/Sent/" + friendId);
      userRef.remove(function (error) {
        if (!error) {
          relationRef = firebase.database().ref("relation");
          relationRef
            .child(currentUserId + "/" + friendId)
            .set("UNKNOWN", function () {
              relationRef
                .child(friendId + "/" + currentUserId)
                .set("UNKNOWN", function () {
                  showToast(trans.requestCancelled);
                  if (document.getElementById(friendId + "search")) {
                    editDivAction(friendId, friendInfo, "add");
                  }
                });
            });
        }
      });
    }
  });
}

function editDivAction(friendId, friendInfo, type) {
  var div = document.getElementById(friendId + "search");
  var divAction = div.querySelector(".divAction");
  var divReject = div.querySelector(".divReject");
  setDisplay(divReject, "none");
  switch (type) {
    case "add":
      divAction.src = phAddPerson;
      divAction.title = trans.sendFriendReq;
      divAction.style.backgroundColor = "#21B1F3";
      $(divAction).off("click");
      $(divReject).off("click");
      // divAction.addEventListener('click', function (e) {
      //     e.stopPropagation();
      //     var currentUserInfo = {
      //         email: userInfo.email,
      //         name:userInfo.name,
      //         lowCaseName:userInfo.name.toLowerCase(),
      //         profile_Image:userInfo.profileImage ? userInfo.profileImage : null,
      //         message: null,
      //         date_created:null
      //     }
      //     if (requestmessage) {
      //         showMessageDialog(friendId, currentUserInfo, friendInfo);
      //         setDisplay(chatUserModal, 'none');
      //     }
      //     else{
      //         sendFriendRequest(friendId, currentUserInfo,friendInfo);
      //     }

      // });
      $(divAction).click(function (e) {
        e.stopPropagation();
        var currentUserInfo = {
          email: userInfo.email,
          name: userInfo.name,
          lowCaseName: userInfo.name.toLowerCase(),
          profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
          message: null,
          date_created: null,
        };
        if (requestmessage) {
          showMessageDialog(friendId, currentUserInfo, friendInfo);
          setDisplay(chatUserModal, "none");
        } else {
          sendFriendRequest(friendId, currentUserInfo, friendInfo);
        }
      });
      break;
    case "cancel":
      divAction.src = phXPerson;
      divAction.title = trans.cancelReq;
      divAction.style.backgroundColor = "#444";
      $(divAction).off("click");
      $(divReject).off("click");
      // divAction.addEventListener('click', function (e) {
      //     e.stopPropagation();
      //     cancelFriendRequest(friendId, friendInfo);
      // });
      $(divAction).click(function (e) {
        e.stopPropagation();
        cancelFriendRequest(friendId, friendInfo);
      });
      break;
    case "reject":
      divAction.src = phAcceptPerson;
      divAction.title = trans.acceptReq;
      divAction.style.backgroundColor = "#2dba10";
      setDisplay(divReject, "block");
      $(divAction).off("click");
      $(divReject).off("click");
      $(divReject).click(function (e) {
        e.stopPropagation();
        rejectFriendRequest(friendId, friendInfo);
      });
      // divReject.addEventListener('click', function(e) {
      //     e.stopPropagation();
      //     rejectFriendRequest(friendId, friendInfo);
      // });
      $(divAction).click(function (e) {
        e.stopPropagation();
        var currentUserInfo = {
          email: userInfo.email,
          name: userInfo.name,
          lowCaseName: userInfo.name.toLowerCase(),
          profile_Image: userInfo.profileImage ? userInfo.profileImage : null,
          message: null,
          date_created: null,
        };
        acceptFriendRequest(friendId, currentUserInfo, friendInfo);
      });
      // divAction.addEventListener('click', function (e) {
      //     e.stopPropagation();
      //     var currentUserInfo = {
      //         email: userInfo.email,
      //         name:userInfo.name,
      //         lowCaseName:userInfo.name.toLowerCase(),
      //         profile_Image:userInfo.profileImage ? userInfo.profileImage : null,
      //         message: null,
      //         date_created:null
      //     }
      //     acceptFriendRequest(friendId,currentUserInfo,friendInfo);
      // });
      break;
    default:
      //remove
      divAction.src = phTrashIcon;
      divAction.title = trans.unfriend;
      divAction.style.backgroundColor = "#444";
      $(divAction).off("click");
      $(divReject).off("click");
      $(divAction).click(function (e) {
        e.stopPropagation();
        showConfirmModal(friendId, friendInfo.name, friendInfo);
      });
      // divAction.addEventListener('click', function (e) {
      //     e.stopPropagation();
      //     showConfirmModal(friendId,friendInfo.name, friendInfo);
      // });
      break;
  }
}
function rejectFriendRequest(friendId, friendInfo) {
  var friendRef = firebase
    .database()
    .ref("Users/" + friendId + "/FriendRequests/Sent/" + currentUserId);
  friendRef.remove(function (error) {
    if (error) {
      //request failed
      showToast(trans.errorMess);
    } else {
      var userRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/FriendRequests/Received/" + friendId);
      userRef.remove(function (error) {
        if (!error) {
          relationRef = firebase.database().ref("relation");
          relationRef
            .child(currentUserId + "/" + friendId)
            .set("UNKNOWN", function () {
              relationRef
                .child(friendId + "/" + currentUserId)
                .set("UNKNOWN", function () {
                  showToast(trans.requestCancelled);
                  if (document.getElementById(friendId + "search")) {
                    editDivAction(friendId, friendInfo, "add");
                  }
                });
            });
        }
      });
    }
  });
}
function showMessageDialog(friendId, currentUserInfo, friendInfo) {
  setDisplay(addMessageModal, "flex");
  var invite = requestmessage;
  var radios = addMessageModal.querySelectorAll('input[type="radio"]');
  var inMessage = addMessageModal.querySelector('input[type="text"]');
  invite = radios[0].checked;
  inMessage.style.display = invite ? "block" : "none";
  for (var i = 0, max = radios.length; i < max; i++) {
    radios[i].onclick = function () {
      if (this.value == "dna") {
        inMessage.style.display = "none";
        inMessage.value = "";
        if (requestmessage) {
          requestmessage = false;
          setCookie("requestMessage", "no", 365);
        }
        invite = false;
      } else if (this.value == "no") {
        inMessage.style.display = "none";
        inMessage.value = "";
        if (!requestmessage) {
          deleteCookie("requestMessage");
          requestmessage = true;
        }
        invite = false;
      } else {
        inMessage.style.display = "block";
        if (!requestmessage) {
          deleteCookie("requestMessage");
          requestmessage = true;
        }
        invite = true;
      }
    };
  }
  var btnCancel = addMessageModal.querySelector(".redBtn");
  var btnSendRequest = addMessageModal.querySelector(".btnBlue");

  btnCancel.addEventListener("click", function () {
    setDisplay(addMessageModal, "none");
  });

  btnSendRequest.addEventListener("click", function () {
    if (invite) {
      if (inMessage.value.trim() == "") {
        $(inMessage).shake();
        inMessage.focus();
      } else {
        friendInfo.message = inMessage.value.trim();
        currentUserInfo.message = inMessage.value.trim();
        sendFriendRequest(friendId, currentUserInfo, friendInfo);
      }
    } else {
      sendFriendRequest(friendId, currentUserInfo, friendInfo, null);
    }
  });

  btnSendRequest.addEventListener("keyup", function (event) {
    if (event.keyCode === 13) {
      //"Enter" key on keyboard
      //cancel the deafult button if needed
      event.preventDefault();
      btnSendRequest.click();
    }
  });
}

function sendFriendRequest(friendId, currentUserInfo, friendInfo) {
  setDisplay(addMessageModal, "none");
  showToast(trans.sendingReq);
  var time = new Date().getTime();
  friendInfo.date_created = time;
  currentUserInfo.date_created = time;
  var friendRef = firebase
    .database()
    .ref("Users/" + friendId + "/FriendRequests/Received/" + currentUserId);
  friendRef.set(currentUserInfo, function (error) {
    if (!error) {
      var userRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/FriendRequests/Sent/" + friendId);
      userRef.set(friendInfo, function (error) {
        if (!error) {
          relationRef = firebase.database().ref("relation");
          relationRef
            .child(currentUserId + "/" + friendId)
            .set("PENDING", function () {
              relationRef
                .child(friendId + "/" + currentUserId)
                .set("RESOLVE", function () {
                  showToast(trans.requestCancelled);
                  if (document.getElementById(friendId + "search")) {
                    editDivAction(friendId, friendInfo, "add");
                  }
                });
            });
          showToast(trans.reqSent);
          if (document.getElementById(friendId + "search")) {
            editDivAction(friendId, friendInfo, "cancel");
          }
        }
      });
    }
  });
}

function updatePetition(id, petition, hasPermission) {
  var oldDiv = document.getElementById(id);

  const container = document.createElement("div");
  container.innerHTML = PETITION_TEMPLATE;

  const div = container.firstChild;
  div.setAttribute("id", id);
  var petitionElementList = document.getElementById("petitionList");

  const nameElement = div.querySelector(".requester");
  nameElement.textContent = petition.name;
  const timeElement = div.querySelector(".requestTime");
  timeElement.textContent = formatDate(new Date(petition.time));

  const playingElement = div.querySelector(".isPlaying");
  const songElement = div.querySelector(".requestSong");
  const artistElement = div.querySelector(".requestArtist");
  const commentElement = div.querySelector(".requestComment");
  const audioElement = div.querySelector(".pAudio");

  if (petition.isPlaying) {
    var spPlaying = playingElement.querySelector("span");
    spPlaying.classList = "sp-unfulfilled";
    spPlaying.textContent = trans.markUnfulfilled;
    playingElement.classList.replace(
      "btn-blue-shadow-round",
      "btn-white-shadow-round"
    );
    setDisplay(playingElement, "none");
  } else {
    var spPlaying = playingElement.querySelector("span");
    spPlaying.classList = "sp-fulfilled";
    spPlaying.textContent = trans.markFulfilled;
    playingElement.classList.replace(
      "btn-white-shadow-round",
      "btn-blue-shadow-round"
    );
    setDisplay(playingElement, "block");
  }

  if (petition.song) {
    div.querySelector(".song").textContent = petition.song;
  } else {
    songElement.style.display = "none";
  }

  if (petition.artist) {
    div.querySelector(".artist").textContent = petition.artist;
  } else {
    artistElement.style.display = "none";
  }

  if (petition.comments) {
    div.querySelector(".comments").textContent = petition.comments;
  } else {
    commentElement.style.display = "none";
  }

  if (petition.auFile) {
    var btnSaveAudio = div.querySelector(".btnSaveAudio");
    audioElement.src = petition.auUrl;
    btnSaveAudio.href = petition.auUrl;
    btnSaveAudio.addEventListener("click", function (event) {
      event.preventDefault();
      window.onunload = null;
      window.onbeforeunload = null;
      saveFile(id + ".m4a", petition.auUrl);
      window.onunload = noTimeout;
      window.onbeforeunload = warning;
    });
  } else {
    div.querySelector(".requestAudio").style.display = "none";
  }

  petitionElementList.replaceChild(div, oldDiv);

  if (hasPermission) {
    playingElement.addEventListener("click", function () {
      if (!petition.isPlaying) {
        var spPlaying = playingElement.querySelector("span");
        spPlaying.classList = "sp-fulfilled";
        spPlaying.textContent = trans.markFulfilled;
        playingElement.classList.replace(
          "btn-white-shadow-round",
          "btn-blue-shadow-round"
        );
      } else {
        var spPlaying = playingElement.querySelector("span");
        spPlaying.classList = "sp-fulfilled";
        spPlaying.textContent = trans.markFulfilled;
        playingElement.classList.replace(
          "btn-white-shadow-round",
          "btn-blue-shadow-round"
        );
      }
      toggleSongPlaying(id, petition);
    });

    const deleteElement = div.querySelector(".ivDelete");
    const spDelete = div.querySelector(".sp-delete");
    spDelete.textContent = trans.delete;
    setDisplay(deleteElement, "block");
    deleteElement.addEventListener("click", function () {
      deletePetition(id, petition);
    });

    if (petition.song || petition.artist) {
      const ytSearch = div.querySelector(".ytSearch");
      const spYtSearch = div.querySelector(".sp-searchYt");
      spYtSearch.textContent = trans.searchYt;

      setDisplay(ytSearch, "block");
      ytSearch.addEventListener("click", function () {
        var searchQuery = "https://www.youtube.com/results?search_query=";
        searchQuery += petition.artist
          ? petition.artist.replace(/\s+/g, "+") + " "
          : "";
        searchQuery += petition.song ? petition.song.replace(/\s+/g, "+") : "";
        //+ petition.artist.replace(/\s+/g, "+") + '-' + petition.song.replace(/\s+/g, "+");
        window.open(searchQuery, "_blank");
      });
    } else {
      const ytSearch = div.querySelector(".ytSearch");
      setDisplay(ytSearch, "none");
    }
  }
}

function sendPetition(radioId) {
  const inSong = document.getElementById("inSong");
  const inArtist = document.getElementById("inArtist");
  const inComment = document.getElementById("inComment");

  var song = inSong.value;
  var artist = inArtist.value;
  var comment = inComment.value;

  //Crear input fields
  inSong.value = "";
  inArtist.value = "";
  inComment.value = "";

  if (song || artist || comment) {
    var time = new Date().getTime();
    const petition = {
      song: null,
      artist: null,
      comments: null,
      radioId: radioId,
      time: time,
      isPlaying: false,
      name: userName,
    };

    if (song) {
      petition.song = song;
    }
    if (artist) {
      petition.artist = artist;
    }
    if (comment) {
      petition.comments = comment;
    }

    petitionsRef.push().set(petition, function (error) {
      if (error) {
        //request failed
        showToast("Error sending petition. Try again later.");
      } else {
        //request sent
        showToast("Petition sent successfully");
        setDisplay(btnNewRequest, "flex");
        setDisplay(petitionBox, "none");
        checkVCoins();
      }
    });
  } else {
    showToast("Please provide the artist name, song name, or a comment");
  }
}

function checkVCoins() {
  vCoins--;
  if (vCoins > 1) {
    divReqLeft.textContent = trans.requestsLeftPl.replace("num", vCoins);
  } else {
    divReqLeft.textContent = trans.requestsLeft.replace("num", vCoins);
  }
  if (vCoinRef) {
    vCoinRef.set(vCoins);
  }
  if (vCoins <= 0) {
    if (requestConfig.ads) {
      setDisplay(divWaitTime, "none");
      setDisplay(btnWatchAd, "flex");
      setDisplay(divAdNote, "block");
      setDisplay(divAdParent, "block");
    } else {
      var unlockT = new Date().getTime() + requestConfig.time * 60000;
      timeRef.set(unlockT);
      unlockTime = unlockT;
      setDisplay(divWaitTime, "block");
      divWaitTime.textContent = trans.waitTime("$time", unlockT);
      setDisplay(btnWatchAd, "none");
      setDisplay(divAdNote, "none");
      setDisplay(divAdParent, "none");
    }
  } else if (vCoins < requestConfig.max) {
    if (requestConfig.ads) {
      setDisplay(divWaitTime, "none");
      setDisplay(btnWatchAd, "flex");
      setDisplay(divAdNote, "block");
      setDisplay(divAdParent, "block");
    }
  } else {
    setDisplay(divWaitTime, "none");
    setDisplay(btnWatchAd, "none");
    setDisplay(divAdNote, "none");
    setDisplay(divAdParent, "none");
  }
}
var PETITION_TEMPLATE =
  '<div class="petition-container horizFlex">' +
  '<div class="petMainInfo mainTop">' +
  '<div class="requester blueText boldText" translate="no"></div>' +
  '<div class="requestSong linedText" translate="no">' +
  "<strong>Song:&nbsp;</strong>" +
  '<div class="song" translate="no"></div>' +
  "</div>" +
  '<div class="requestArtist linedText" translate="no">' +
  "<strong>Artist:&nbsp;</strong>" +
  '<div class="artist" translate="no"></div>' +
  "</div>" +
  '<div class="requestComment" translate="yes">' +
  "<strong>Comments:&nbsp;</strong>" +
  '<div class="comments" translate="yes"></div>' +
  "</div>" +
  '<div class="requestAudio linedText" translate="no">' +
  '<audio class="pAudio" controls src="">' +
  "Your browser does not support the <code>audio</code> element." +
  "</audio>" +
  '<a href="" download class="btnSaveAudio">' +
  '<img src="' +
  phDownloadIcon +
  '" class="btnBlueSmall" alt="download" width="104" height="142">' +
  "<p>Download audio</p>" +
  "</a>" +
  "</div>" +
  "</div>" +
  '<div class="requestInfo verticalFlex">' +
  '<button class="ytSearch btn-dark-purple-shadow-round opas"><i class="fa-brands fa-youtube"></i><span class="sp-searchYt">Search on YouTube</span></button>' +
  '<button class="isPlaying btn-blue-shadow-round opas"><i class="fa-solid fa-music"></i><span class="sp-fulfilled">Mark as fulfilled</span></button>' +
  '<button class="ivDelete btn-red-shadow-round opas"><i class="fa-solid fa-trash-can"></i><span class="sp-delete">Delete</span></button>' +
  // '<img class="ivDelete" src="' +
  // phTrashIcon +
  // '" alt="delete request">' +
  // '<img class="isPlaying" src="' +
  // phPlayingIcon +
  // '" alt="unplayed song">' +
  // '<img class="ytSearch" src="' +
  // phYTPlayIcon +
  // '" alt="search on youtube">' +
  '<div class="requestTime boldText"></div>' +
  "</div>" +
  "</div>";

function displayPetition(id, petition, hasPermission) {
  const container = document.createElement("div");
  container.innerHTML = PETITION_TEMPLATE;

  const div = container.firstChild;
  div.setAttribute("id", id);
  //div.setAttribute('time', bookmark.date);
  var petitionElementList = document.getElementById("petitionList");

  const nameElement = div.querySelector(".requester");
  nameElement.textContent = petition.name;
  const timeElement = div.querySelector(".requestTime");
  timeElement.textContent = formatDate(new Date(petition.time));

  const playingElement = div.querySelector(".isPlaying");
  const songElement = div.querySelector(".requestSong");
  const artistElement = div.querySelector(".requestArtist");
  const commentElement = div.querySelector(".requestComment");
  const audioElement = div.querySelector(".pAudio");

  if (petition.isPlaying) {
    var spPlaying = playingElement.querySelector("span");
    spPlaying.classList = "sp-unfulfilled";
    spPlaying.textContent = trans.markUnfulfilled;
    playingElement.classList.replace(
      "btn-blue-shadow-round",
      "btn-white-shadow-round"
    );
    setDisplay(playingElement, "none");
  } else {
    var spPlaying = playingElement.querySelector("span");
    spPlaying.classList = "sp-fulfilled";
    spPlaying.textContent = trans.markFulfilled;
    playingElement.classList.replace(
      "btn-white-shadow-round",
      "btn-blue-shadow-round"
    );
    setDisplay(playingElement, "block");
  }

  if (petition.song) {
    div.querySelector(".song").textContent = petition.song;
  } else {
    songElement.style.display = "none";
  }

  if (petition.artist) {
    div.querySelector(".artist").textContent = petition.artist;
  } else {
    artistElement.style.display = "none";
  }

  if (petition.comments) {
    div.querySelector(".comments").textContent = petition.comments;
  } else {
    commentElement.style.display = "none";
  }

  if (petition.auFile) {
    var btnSaveAudio = div.querySelector(".btnSaveAudio");
    audioElement.src = petition.auUrl;
    btnSaveAudio.href = petition.auUrl;
    btnSaveAudio.addEventListener("click", function (event) {
      event.preventDefault();
      window.onunload = null;
      window.onbeforeunload = null;
      saveFile(id + ".m4a", petition.auUrl);
      window.onunload = noTimeout;
      window.onbeforeunload = warning;
    });
  } else {
    div.querySelector(".requestAudio").style.display = "none";
  }

  //const existingRadios = friendElementList.children;
  petitionElementList.appendChild(div);

  if (hasPermission) {
    playingElement.addEventListener("click", function () {
      if (!petition.isPlaying) {
        var spPlaying = playingElement.querySelector("span");
        spPlaying.classList = "sp-fulfilled";
        spPlaying.textContent = trans.markFulfilled;
        playingElement.classList.replace(
          "btn-white-shadow-round",
          "btn-blue-shadow-round"
        );
        setDisplay(playingElement, "block");
      } else {
        var spPlaying = playingElement.querySelector("span");
        spPlaying.classList = "sp-unfulfilled";
        spPlaying.textContent = trans.markUnfulfilled;
        playingElement.classList.replace(
          "btn-blue-shadow-round",
          "btn-white-shadow-round"
        );
        setDisplay(playingElement, "none");
      }
      toggleSongPlaying(id, petition);
    });

    const deleteElement = div.querySelector(".ivDelete");
    const spDelete = div.querySelector(".sp-delete");
    spDelete.textContent = trans.delete;
    setDisplay(deleteElement, "block");
    deleteElement.addEventListener("click", function () {
      deletePetition(id, petition);
    });
    if (petition.song || petition.artist) {
      const ytSearch = div.querySelector(".ytSearch");
      const spYtSearch = div.querySelector(".sp-searchYt");
      spYtSearch.textContent = trans.searchYt;
      setDisplay(ytSearch, "block");
      ytSearch.addEventListener("click", function () {
        var searchQuery = "https://www.youtube.com/results?search_query=";
        searchQuery += petition.artist
          ? petition.artist.replace(/\s+/g, "+") + " "
          : "";
        searchQuery += petition.song ? petition.song.replace(/\s+/g, "+") : "";
        //+ petition.artist.replace(/\s+/g, "+") + '-' + petition.song.replace(/\s+/g, "+");
        window.open(searchQuery, "_blank");
      });
    } else {
      const ytSearch = div.querySelector(".ytSearch");
      setDisplay(ytSearch, "none");
    }
  }
}

function deletePetition(id, petition) {
  petitionsRef.child(id).remove(function (error) {
    if (error) {
      //request failed
      showToast(trans.errorMess);
    } else {
      //request sent
      if (petition.auFile) {
        var audioRef = firebase.storage().refFromURL(`${petition.auUrl}`);
        audioRef
          .delete()
          .then(() => {
            showToast(trans.petitionDeleted);
          })
          .catch((error) => {
            // Uh-oh, an error occurred!

            showToast(trans.errorMess);
          });
      } else {
        showToast(trans.petitionDeleted);
      }
    }
  });
}

function toggleSongPlaying(petitionKey, petition) {
  if (petition.isPlaying) {
    petitionsRef.child(petitionKey + "/isPlaying").set(false, function (error) {
      if (error) {
        //request failed
        showToast(trans.errorSendPetition);
      } else {
        //request sent
        showToast(trans.successPetitionPlay);
      }
    });
  } else {
    petitionsRef.child(petitionKey + "/isPlaying").set(true, function (error) {
      if (error) {
        //request failed
        showToast(trans.errorSendPetition);
      } else {
        //request sent
        showToast(trans.songPlayed);

        //send message to chat
        var time = new Date().getTime();
        const txtMessage = {
          song: null,
          textMessage: null,
          requesterName: petition.name,
          userName: userName,
          userId: currentUserId,
          type: "SongRequest",
          messageTime: time,
        };

        var song;
        var message;
        if (petition.song) {
          song = petition.song;
          txtMessage.song = petition.song;
          message = trans.yourSong + '"' + song + trans.isPlaying + userName;
        } else {
          song = trans.requestReviewed;
          message = song + trans.yoursTruly + userName;
        }

        txtMessage.textMessage = message;
        var radioChatRef = firebase.database().ref("Chats/" + currentChatId);
        radioChatRef.push().set(txtMessage, function (error) {
          if (error) {
            //request failed
            showToast(trans.errorSendingMessage);
          } else {
            //request sent
            showToast(trans.playingSent);
          }
        });
      }
    });
  }
}

function formatDate(date) {
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? " PM" : " AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  return month + "/" + day + " " + hours + ":" + minutes + ampm;
}

function initPrivateChat(id, privateChat) {
  if (id.endsWith("friend")) {
    currentChatId = id.replace("friend", "");
  } else {
    currentChatId = id;
  }
  var elmtFriendName = document.getElementById("normalChatName");
  elmtFriendName.innerHTML = privateChat.name;
  document.getElementById("normMessagesNone").style.display = "block";
  //load Chat
  currentChatRef = firebase
    .database()
    .ref("PrivateChat/" + currentUserId + "/" + currentChatId);
  currentChatRef.on("child_added", function (data) {
    document.getElementById("normMessagesNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "private");
  });
  currentChatRef.on("child_changed", function (data) {
    document.getElementById("normMessagesNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "private");
  });
  currentChatRef.on("child_removed", function (data) {
    deleteElement(data.key);
    var messagesListElement = document.getElementById("normalMessages");

    if (messagesListElement.children.length == 0) {
      document.getElementById("normMessagesNone").style.display = "block";
    }
  });

  window.history.replaceState({}, "", "/chat");
  document.title = "ChatMurcianys";
}

function initGroupChat(id, groupChat) {
  var elmtGroupName = document.getElementById("normalChatName");
  elmtGroupName.innerHTML = groupChat.name;
  currentChatId = id;
  document.getElementById("normMessagesNone").style.display = "block";
  //load Chat
  currentChatRef = firebase
    .database()
    .ref("GroupChats/" + id + "/chat/" + currentUserId);
  currentChatRef.on("child_added", function (data) {
    document.getElementById("normMessagesNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "private");
  });
  currentChatRef.on("child_changed", function (data) {
    document.getElementById("normMessagesNone").style.display = "none";
    messageCount++;
    var message = data.val();
    displayMessage(data.key, message, "private");
  });
  currentChatRef.on("child_removed", function (data) {
    deleteElement(data.key);
    var messagesListElement =
      participantListdocument.getElementById("normalMessages");

    if (messagesListElement.children.length == 0) {
      document.getElementById("normMessagesNone").style.display = "block";
    }
  });

  participantsRef = firebase.database().ref("GroupChats/" + id + "/members");
  participantsRef.on("child_added", function (data) {
    if (currentUserId != data.key) {
      participantList.push(data.key);
    }
  });

  participantsRef.on("child_removed", function (data) {
    var index = participantList.indexOf(data.key);
    if (index != -1) {
      participantList.splice(index, 1);
    }
  });

  window.history.replaceState({}, "", "/chat");
  document.title = "ChatMurcianys";
}
// function loadMessages(){

// }

// function displayTextMessage(id, time, userName, text)
// {

// }
function magnify(imgID, zoom) {
  var img, glass, w, h, bw;
  img = document.getElementById(imgID);
  if (largeImageView.querySelector(".img-magnifier-glass")) {
    largeImageView.querySelector(".img-magnifier-glass").remove();
  }
  /*create magnifier glass:*/
  glass = document.createElement("DIV");
  glass.setAttribute("class", "img-magnifier-glass");
  /*insert magnifier glass:*/
  img.parentElement.insertBefore(glass, img);
  /*set background properties for the magnifier glass:*/
  glass.style.backgroundImage = "url('" + img.src + "')";
  glass.style.backgroundRepeat = "no-repeat";
  glass.style.backgroundSize =
    img.width * zoom + "px " + img.height * zoom + "px";
  bw = 3;
  w = glass.offsetWidth / 2;
  h = glass.offsetHeight / 2;
  /*execute a function when someone moves the magnifier glass over the image:*/
  glass.addEventListener("mousemove", moveMagnifier);
  img.addEventListener("mousemove", moveMagnifier);
  /*and also for touch screens:*/
  glass.addEventListener("touchmove", moveMagnifier);
  img.addEventListener("touchmove", moveMagnifier);
  function moveMagnifier(e) {
    var pos, x, y;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = getCursorPos(e);
    x = pos.x;
    y = pos.y;
    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x > img.width - w / zoom) {
      x = img.width - w / zoom;
    }
    if (x < w / zoom) {
      x = w / zoom;
    }
    if (y > img.height - h / zoom) {
      y = img.height - h / zoom;
    }
    if (y < h / zoom) {
      y = h / zoom;
    }
    /*set the position of the magnifier glass:*/
    glass.style.left = x - w + "px";
    glass.style.top = y - h + "px";
    /*display what the magnifier glass "sees":*/
    glass.style.backgroundPosition =
      "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
  }
  function getCursorPos(e) {
    var a,
      x = 0,
      y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/
    a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }
}
function scrollBottom(type) {
  var objDiv;
  if (type === "private" || type === "group") {
    objDiv = document.getElementById("normalMessages");
  } else {
    objDiv = document.getElementById("radioMessages");
  }
  objDiv.scrollTop = objDiv.scrollHeight;
}

function showDropdown() {
  document.getElementById("langDropdown").classList.toggle("show");
}

jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 4;
  intDistance = intDistance || 2;
  intDuration = intDuration || 500;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};

//Agora initializations
/**
 * @name initAgora
 * @description Initialize live video variables/listeners
 */
async function initAgora() {
  rtc = {
    client: null,
    joined: false,
    published: false,
    localStream: null,
    localAudio: null,
    screenVideoTrack: null,
    screenAudioTrack: null,
    remoteStreams: [],
    remoteAudio: null,
    params: {},
  };

  option = {
    appID: appId,
    channel: "Private Channel", //radioId
    uid: currentUserId ? currentUserId : null, //djId
    token: null,
    role: "",
  };

  rtc.client = AgoraRTC.createClient({ mode: "live", codec: "h264" });

  //For host user: started stream
  rtc.client.on("stream-published", function (evt) {
    var remoteStream = evt.stream;
    var id = remoteStream.getId();
    btnStopStream.style.display = "block";
    setDisplay(btnLiveVideo, "none");
    setDisplay(liveVideoContainer, "flex");
    var videoElement = document.getElementById("video" + id);
    if (videoElement) {
      videoElement.controls = true;
    }
    currentChannel = currentChatId;
    var stream = {
      hostId: currentUserId,
      cohost: false,
      name: userInfo.name,
      videoId: id,
      date: new Date().getTime(),
    };
    if (!isVideoLive) {
      isVideoLive = true;
      liveVideoRef.set(stream);
    } else {
      isCohost = true;
      cohostVideoRef.child(id).set(stream);
    }
    showToast(trans.liveVideoStarted);
    startLiveVideoTimer();
  });

  //For host user: stopped stream
  rtc.client.on("stream-unpublished", function (evt) {
    btnStopStream.style.display = "none";
    var remoteStream = evt.stream;
    var id = remoteStream.getId();
    evt.stream.stop("me");
    evt.stream.close();
    hostContainer.textContent = "";
    currentChannel = null;
    if (hasPermission) {
      setDisplay(btnLiveVideo, "block");
    }
    showToast(trans.liveVideoEnded);
    if (isVideoLive) {
      //Check if user requested video permission remove permission
      //but don't leave channel
      if (reqInfo && userReqVideoRef) {
        userReqVideoRef.remove(function (error) {
          if (error) {
            showToast(trans.errorMess);
          }
          //userReqVideoRef.off();
        });
        reqInfo = null;
      } else {
        //did not request permission (is mainHost) so leaveChannel
        setDisplay(liveVideoContainer, "none");
        isVideoLive = false;
        leaveChannel();
      }
    }

    if (isMainHost) {
      isMainHost = false;
      liveVideoRef.remove();
      cohostVideoRef.remove();
      stopLiveVideoTimer();
    } else {
      isCohost = false;
      cohostVideoRef.child(id).remove();
    }
    var isDjing = reqVideoRef && radioHost && radioHost.hostId == currentUserId;
    if (!isDjing && !isMainHost && reqVideoRef) {
      reqVideoRef.remove();
      setDisplay(requestDiv, "none");
      requestItems.textContent = "";
      reqVideoRef.off();
      reqVideoRef = null;
    }
  });

  //For remote user: stream started
  rtc.client.on("stream-added", function (evt) {
    var remoteStream = evt.stream;
    var id = remoteStream.getId();
    if (id !== rtc.params.uid) {
      rtc.client.subscribe(remoteStream, function (err) {
        console.log("stream subscribe failed", err);
      });
    }
  });
  rtc.client.on("user-published", async (remoteUser, mediaType) => {
    if (remoteUser.uid != rtc.params.uid) {
      await rtc.client.subscribe(remoteUser, mediaType);
      if (mediaType === "video") {
        var remoteStream = remoteUser.videoTrack;
        var id = remoteUser.uid.toString();
        // Add a view for the remote stream.
        addVideoStream("remote_video_" + id);
        // Play the remote stream.
        remoteStream.play("remote_video_" + id); //"remote_video_" + id
        setDisplay(liveVideoContainer, "flex");
        var vidId = remoteStream.getTrackId();
        var remoteVideoElement = document.getElementById("video_" + vidId);
        if (remoteVideoElement) {
          remoteVideoElement.controls = true;
        }
        cohostVideoRef.child(id).once("value", function (snapshot) {
          if (snapshot.exists()) {
            var host = snapshot.val();
            var container = document.getElementById("remote_video_" + id);
            if (container) {
              var div = document.createElement("div");
              //var div = '<div class="hName">'+host.name+'</div>'
              div.className = "hName";
              div.innerHTML = host.name;
              container.appendChild(div);
            }
          }
        });
        //remoteUser.videoTrack.play("DOM_ELEMENT_ID");
      }
      if (mediaType === "audio") {
        remoteUser.audioTrack.play();
      }
    }
  });
  rtc.client.on("user-unpublished", async (user, mediaType) => {
    // Get the dynamically created DIV container.
    if (user.uid != rtc.params.uid) {
      await rtc.client.unsubscribe(user, mediaType);
      if (mediaType === "video") {
        var id = user.uid.toString();
        const remotePlayerContainer = document.getElementById(
          "remote_video_" + id
        );
        // Destroy the container.
        remotePlayerContainer.remove();

        //check if main host left
        if (
          streamInfo != null &&
          streamInfo.videoId &&
          streamInfo.videoId == id &&
          isVideoLive
        ) {
          isVideoLive = false;
          leaveChannel();
          setDisplay(liveVideoContainer, "none");
        }

        showToast(trans.liveVideoEnded);
      }
    }
  });
  //for remote user: connected to stream
  rtc.client.on("stream-subscribed", function (evt) {
    var remoteStream = evt.stream;
    var id = remoteStream.getId();
    // Add a view for the remote stream.
    addVideoStream("remote_video_" + id);
    // Play the remote stream.
    remoteStream.play("remote_video_" + id); //"remote_video_" + id
    setDisplay(liveVideoContainer, "flex");
    var remoteVideoElement = document.getElementById("video" + id);
    if (remoteVideoElement) {
      remoteVideoElement.controls = true;
    }
    cohostVideoRef.child(id).once("value", function (snapshot) {
      if (snapshot.exists()) {
        var host = snapshot.val();
        var container = document.getElementById("remote_video_" + id);
        if (container) {
          var div = document.createElement("div");
          //var div = '<div class="hName">'+host.name+'</div>'
          div.className = "hName";
          div.innerHTML = host.name;
          container.appendChild(div);
        }
      }
    });
  });

  //For remote user: stream stopped
  rtc.client.on("stream-removed", function (evt) {
    var remoteStream = evt.stream;
    var id = remoteStream.getId();
    // Stop playing the remote stream.
    remoteStream.stop("remote_video_" + id); //"remote_video_" + id
    // Remove the view of the remote stream.
    removeVideoStream("remote_video_" + id);
    if (
      streamInfo != null &&
      streamInfo.videoId &&
      streamInfo.videoId == id &&
      isVideoLive
    ) {
      isVideoLive = false;
      leaveChannel();
      setDisplay(liveVideoContainer, "none");
    }

    showToast(trans.liveVideoEnded);
  });

  rtc.client.on("peer-leave", function (evt) {
    if (evt.reason && evt.reason.includes("Quit")) {
      var remoteStream = evt.stream;
      var id = remoteStream.getId();
      // Stop playing the remote stream.
      remoteStream.stop("remote_video_" + id); //"remote_video_" + id
      // Remove the view of the remote stream.
      removeVideoStream("remote_video_" + id);
      showToast(trans.liveVideoEnded);
      if (
        streamInfo != null &&
        streamInfo.videoId &&
        streamInfo.videoId == id &&
        isVideoLive
      ) {
        isVideoLive = false;
        leaveChannel();
        setDisplay(liveVideoContainer, "none");
        btnStopStream.style.display = "none";
      }
    }
  });
  //Initialize the client
  // rtc.client.init(
  //   option.appID,
  //   function () {
  //     agoraStarted = true;
  //   },
  //   (err) => {
  //     console.error(err);
  //     agoraStarted = false;
  //   }
  // );
  agoraStarted = true;
}

function startLiveVideoTimer() {
  const maxTime = 10800000; //3 hours
  callDurationInterval = setInterval(endStream, maxTime);
}

function stopLiveVideoTimer() {
  if (callDurationInterval != null) {
    clearTimeout(callDurationInterval);
    callDurationInterval = null;
  }
}

/**
 * @name joinChannel
 * @param {*} goLive should the user go live or not
 * @description Join a streaming channel based on the 'option' configuration
 */
async function joinChannel(goLive, useCamera) {
  try {
    if (!joined) {
      rtc.params.uid = await rtc.client.join(
        option.appID,
        option.channel,
        option.token,
        null //option.uid
      );
      joined = true;
    }

    if (goLive) {
      if (useCamera) {
        rtc.localStream = await AgoraRTC.createCameraVideoTrack();
        rtc.localAudio = await AgoraRTC.createMicrophoneAudioTrack();
        rtc.localStream.play("hostContainer");
        await rtc.client.setClientRole("host");
        await rtc.client.publish([rtc.localAudio, rtc.localStream]);
        displayLocalLiveVideo();
      } else {
        let screenTrack;
        rtc.localAudio = await AgoraRTC.createMicrophoneAudioTrack();
        screenTrack = await AgoraRTC.createScreenVideoTrack(
          {
            encoderConfig: {
              framerate: 15,
              height: 720,
              width: 1280,
            },
          },
          "auto"
        );
        if (screenTrack instanceof Array) {
          rtc.localStream = screenTrack[0];
          rtc.screenAudioTrack = screenTrack[1];
        } else {
          rtc.localStream = screenTrack;
        }
        rtc.localStream.play("hostContainer");
        await rtc.client.setClientRole("host");
        rtc.localStream.on("track-ended", () => {
          showToast(trans.liveVideoEnded);
          rtc.localStream && rtc.localStream.close();
        });
        if (rtc.screenAudioTrack == null) {
          await rtc.client.publish([rtc.localStream, rtc.localAudio]);
        } else {
          await rtc.client.publish([
            rtc.localStream,
            rtc.localAudio,
            rtc.screenAudioTrack,
          ]);
        }
        displayLocalLiveVideo();
      }
    }

    // rtc.client.join(
    //   option.appID,
    //   option.channel,
    //   option.token ? option.token : null,
    //   option.uid ? option.uid : null,
    //   function (uid) {
    //     rtc.params.uid = uid;
    //     // Create a local stream
    //     joined = true;
    //     rtc.localStream = AgoraRTC.createStream({
    //       streamID: rtc.params.uid,
    //       audio: true,
    //       video: useCamera,
    //       screen: !useCamera,
    //     });

    //     if (goLive) {
    //       startStream();
    //     }
    //   },
    //   function (err) {
    //     setDisplay(btnLiveVideo, "none");
    //   }
    // );
  } catch (error) {
    setDisplay(btnLiveVideo, "none");
  }
}
function displayLocalLiveVideo() {
  var id = rtc.localStream.getTrackId();
  btnStopStream.style.display = "block";
  setDisplay(btnLiveVideo, "none");
  setDisplay(liveVideoContainer, "flex");
  var videoElement = document.getElementById("video_" + id);
  if (videoElement) {
    videoElement.controls = true;
  }
  currentChannel = currentChatId;
  var stream = {
    hostId: currentUserId,
    cohost: false,
    name: userInfo.name,
    videoId: id,
    date: new Date().getTime(),
  };
  if (!isVideoLive) {
    isVideoLive = true;
    liveVideoRef.set(stream);
  } else {
    isCohost = true;
    cohostVideoRef.child(id).set(stream);
  }
  showToast(trans.liveVideoStarted);
  startLiveVideoTimer();
}
/**
 * @name leaveChannel
 * @description Leave a streaming channel (do this before joining a new channel)
 */
async function leaveChannel() {
  try {
    rtc.client.remoteUsers.forEach((user) => {
      // Destroy the dynamically created DIV containers.
      const playerContainer = document.getElementById(
        "remote_video_" + user.uid
      );
      playerContainer && playerContainer.remove();
    });

    // Leave the channel.
    await rtc.client.leave();
    isVideoLive = false;
    joined = false;

    if (hasPermission) {
      setDisplay(btnLiveVideo, "block");
    } else {
      setDisplay(btnLiveVideo, "none");
    }
  } catch (error) {
    showToast(trans.errorMess);
  }

  // rtc.client.leave(
  //   function () {
  //     isVideoLive = false;
  //     joined = false;
  //     // Stop playing the local stream
  //     rtc.localStream.stop();
  //     // Close the local stream
  //     rtc.localStream.close();
  //     //rtc.client.setClientRole("audience");
  //     // Stop playing the remote streams and remove the views
  //     while (rtc.remoteStreams.length > 0) {
  //       var stream = rtc.remoteStreams.shift();
  //       var id = stream.getId();
  //       stream.stop();
  //       removeVideoStream("remote_video_" + id);
  //       //removeView(id);
  //     }
  //     if (hasPermission) {
  //       setDisplay(btnLiveVideo, "block");
  //     } else {
  //       setDisplay(btnLiveVideo, "none");
  //     }
  //   },
  //   function (err) {
  //     showToast(trans.errorMess);
  //   }
  // );
}

/**
 * @name startStream
 * @description Start live video stream
 */
async function startStream() {
  rtc.client.setClientRole("host");
  rtc.localStream.init(
    function () {
      // Initialize the local stream
      rtc.localStream.play("hostContainer");
      // Publish the local stream
      rtc.client.publish(rtc.localStream, function (err) {
        console.error(err);
        showToast(trans.errLiveVideo);
      });
    },
    function (err) {
      console.error("init local stream failed ", err);
      showToast(trans.errLiveVideo);
    }
  );
}

/**
 * @name endStream
 * @description End live video stream
 */
async function endStream() {
  //callDurationInterval = null;
  try {
    var id = rtc.localStream.getTrackId();
    if (rtc.screenAudioTrack != null) {
      await rtc.client.unpublish([
        rtc.localAudio,
        rtc.localStream,
        rtc.screenAudioTrack,
      ]);
    } else {
      await rtc.client.unpublish([rtc.localAudio, rtc.localStream]);
    }

    await rtc.client.setClientRole("audience");
    btnStopStream.style.display = "none";

    // evt.stream.stop("me");
    // evt.stream.close();
    hostContainer.textContent = "";
    currentChannel = null;
    if (hasPermission) {
      setDisplay(btnLiveVideo, "block");
    }
    showToast(trans.liveVideoEnded);
    if (isVideoLive) {
      //Check if user requested video permission remove permission
      //but don't leave channel
      if (reqInfo && userReqVideoRef) {
        userReqVideoRef.remove(function (error) {
          if (error) {
            showToast(trans.errorMess);
          }
          //userReqVideoRef.off();
        });
        reqInfo = null;
      } else if (isMainHost) {
        //did not request permission (is mainHost) so leaveChannel
        setDisplay(liveVideoContainer, "none");
        isVideoLive = false;
        leaveChannel();
      }
    }

    if (isMainHost) {
      isMainHost = false;
      liveVideoRef.remove();
      cohostVideoRef.remove();
      stopLiveVideoTimer();
    } else {
      isCohost = false;
      cohostVideoRef.child(id).remove();
    }
    var isDjing = reqVideoRef && radioHost && radioHost.hostId == currentUserId;
    if (!isDjing && !isMainHost && reqVideoRef) {
      reqVideoRef.remove();
      setDisplay(requestDiv, "none");
      requestItems.textContent = "";
      reqVideoRef.off();
      reqVideoRef = null;
    }
  } catch (error) {
    showToast(trans.errEndLiveVideo);
  }

  // rtc.client.unpublish(rtc.localStream, function (err) {
  //   showToast(trans.errEndLiveVideo);
  // });
}

/**
 * @name addVideoStream
 * @description Add a remote video stream into 'remoteContainer'
 */
function addVideoStream(streamId) {
  let streamDiv = document.createElement("div"); //create new div for every stream
  streamDiv.id = streamId;
  var mainHostVideo = "remote_video_" + streamInfo.videoId;

  if (mainHostVideo != streamId) {
    remoteContainer.appendChild(streamDiv); // Add new div to container
  } else {
    remoteMainHost.appendChild(streamDiv);
    setDisplay(liveVideoContainer, "flex");
  }
}

/**
 * @name removeVideoStream
 * @param {*} id the id of remote video container
 * @description Remove a remote video stream from 'remoteContainer'
 */
function removeVideoStream(id) {
  let remDiv = document.getElementById(id); //stream.getId()
  if (remDiv) {
    remDiv.parentNode.removeChild(remDiv);
  }
}

var language = {
  eng: {
    language: "en",
    welcome: "Welcome",
    greeting: "Welcome to ChatMurcianys!",
    greet: `Welcome back @name`,
    Chats: "Chats",
    Radios: "Radios",
    Friends: "Friends",
    Requests: "Requests",
    chat: "Chat",
    listen: "Listen",
    booth: "Booth",
    search: "Find friends",
    addPerson: "Friends requests",
    manageRadios: "My radios",
    addRadio: "Add Radio",
    more: "More",
    profile: "Profile",
    settings: "Settings",
    signOut: "Sign out",
    about: "About app",
    profOptions: "View profile options",
    modLogout: "Are you sure you want to logout?",
    yes: "Yes",
    no: "No",
    accConf: "Creating account. Please wait...",
    nameUse: "What name would you like to use?",
    uploadImg: "Upload image",
    register: "Register",
    name: "Name",
    regWith: "Register with:",
    phone: "Phone",
    email: "Email",
    or: "-Or-",
    secPhone: "*For your security, your phone number will be kept private",
    secEmail: "*For your security, your email will be kept private",
    password: "Password",
    anyPass: "Any password",
    noChats: "You don't have any conversations",
    received: "Received",
    sent: "Sent",
    noInRequests: "You have not received any friend request",
    noOutRequests: "You have not sent any friend requests",
    requestInfo: "↓ Solicit Your Song Here ↓",
    song: "Song:",
    artist: "Artist:",
    comment: "Dedication/Comment (optional)...",
    send: "Send",
    newUserInfo: "to request songs, access the chat, and much more!",
    login: "Login",
    noSongRequests: "There are no song Requests",
    noMessages: "There are no messages in this chat",
    typeHere: "Type here...",
    updateInfo:
      "*We may release various updates throughout the day to provide you with the best quality and service*",
    modNewRadio: "Do you own a radio station?",
    downloadMess:
      "ChatMurcianys is available for your device on the Google PlayStore",
    download: "Download",
    voiceMessage: "Voice message",
    picture: "Picture",
    video: "Video",
    gif: "Gif",
    you: "You",
    errorSendPetition: "Error sending petition. Try again later.",
    successPetitionPlay: "Song marked as unplayed",
    songPlayed: "Song marked as played",
    yourSong: "Your song ",
    isPlaying: '" is playing. Thank you!\n',
    requestReviewed: "I reviewed your request. ",
    yoursTruly: "Thank you!\n",
    errorSendingMessage: "Error sending message. Try again later.",
    playingSent: "Playing message sent successfully",
    petitionDeleted: "Petition deleted successfully",
    errorMess: "An error ocur. Try again later.",
    errorEmail: "Please provide a valid email address",
    welcomeBack: "Welcome back! Enter the password for this account",
    createPass: "Create a password to secure your account",
    errorPass: "Please provide a password for your account.",
    registerMes: "Log in to take full advantage of our chat",
    continue: "Continue with...",
    next: "Next",
    rememberMe: "Remember me",
    infoLog:
      "We will use the information above to log you in or to create a new account if you do not have one.",
    disclaimer:
      'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
    live: "Live: ",
    announceLive: "I'm live!",
    announceEnd: "I'm off air!",
    liveStarted: "Notification sent",
    liveEnded: "Broadcast ended",
    sendNotification: "Send notification",
    liveMessage: "This will be sent to your listeners:",
    isLive: "is live on ",
    today: "Today",
    yesterday: "Yesterday",
    chatNav: "Chat navigation",
    menu: "Menu",
    translate: "Translate",
    idiom: "En",
    petNewUser: "Login to view the song requests",
    chatNewUser: "Login to view the chat",
    mesInstruc:
      "Use the menu on the left to start a conversation or discover groups.",
    listenHere: "Listen to the radio here",
    searchGiphy: "Search GIFs...",
    providedBy: "Powe by GIPHY",
    chatRemoved: "was removed from your chat history",
    radioNotExist: "Sorry. The radio you were looking for does not exist",
    favorite: "Add to favorites",
    unfavorite: "Remove from favorites",
    newRequest: "Request song/send comment",
    requestsLeft: "num request left",
    requestsLeftPl: "num requests left",
    myRadios: "My Radios",
    myFavorites: "My Favorites",
    topTen: "Top 10 radios",
    searchRadios: "Search radios...",
    radioNotFound: "$name was not found",
    waitTime: "Please wait until $time before requesting another song",
    requestsDenied: "Requests are not allowed at this time",
    adReward: "Congrats! You've earned a song request",
    adModalMessage: "Would you like to watch an ad to request a song?",
    watchAd: "Watch Ad",
    watchAdNote: "Watch an ad for more requests",
    sendFriendReq: "Send friend request",
    unfriend: "Unfriend",
    cancelReq: "Cancel friend request",
    acceptReq: "Accept friend request",
    declineReq: "Decline friend request",
    reqSent: "Friend request sent successfully",
    sendingReq: "Sending friend request...",
    requestCancelled: "Friend request cancelled successfully",
    newFriend: "$name is now your friend",
    addingFriend: "Adding $name to your friends list...",
    friendRemoved: "$name was removed from your friends",
    removingFriend: "Removing $name from your friends...",
    addMessage: "Would you like to add a message to your request?",
    noDNA: "No, don't ask again",
    cancel: "Cancel",
    searchFriends: "Find friends...",
    searchHint: "Search",
    confirmRemove: "Are you sure you want to remove $name from your friends?",
    searchBkm: "Search recent chats...",
    djHost: "Radio hosts/DJs",
    goMain: "Go to main page",
    viewRadioInfo: "View radio information",
    moreOptions: "More options",
    editRadioInfo: "Edit radio information",
    locationSpan: '<span class="blueText boldText">Location: </span>',
    admins: "Administrators",
    pOnline: "Participants online",
    radioProblem: "Do you have problems with your radio?",
    changeBanner: "Change banner",
    changeLogo: "Change logo",
    adminName: "Administrator name",
    editRadioName: "Radio name",
    slogan: "Slogan",
    radioURL: "Radio stream URL",
    noteStream: '*Example: "https://xxxx:1232"',
    noteSlogan:
      '*Example: "The Best Variety of Yesterday and Today - Sunny 99.1"',
    description:
      "Describe your radio...What kind of music does your radio play, broadcast hours, etc.",
    country: "Select country",
    phoneNo: "Phone number",
    website: "Website",
    welcomeMessage: "Welcome message",
    updateRadio: "Update radio information",
    lblRadioHost: "Radio hosts/DJs",
    add: "Add",
    noAdmins: "No admin information available",
    noDj: "No information available",
    noUsers: "Nobody is online",
    emailBody:
      "Uid:%20userid%0d%0aReporting%20radio%0d%0aWrite%20below%20the%20line%0d%0a--------------------------------------",
    emailBodHelp:
      "Uid:%20userid%0d%0aRequesting%20help%0d%0aWrite%20below%20the%20line%0d%0a--------------------------------------",
    reportRadio: "Report radio problems",
    audioError:
      '*Some browsers may not reproduce the audio because it does not start with "https" <a id="aRadioLink" href="" target="_blank">click here to test audio</a>',
    radioCheck: "Can you hear the radio? If not, edit the stream above",
    noChanges: "No changes were made",
    infoUpdating:
      "The information is updating. You will be notified when it is done",
    changesMade: "Information updated successfully",
    reply: "Reply",
    forward: "Forward",
    share: "Share",
    errorUnknown: "Unknown error occur. Try again later",
    errorImage: "You don't have permission to upload this image",
    errorUploadCancel: "You canceled the upload",
    subChanges: "Submit changes",
    upInfo: "Update info",
    currPass: "Current password",
    changeEmail: "Change email",
    changePass: "Change password",
    nameNote:
      "If you change your name, you won't be able to change it again within a year",
    undoChange: "Undo change",
    changeImage: "Change Image",
    editProfile: "Edit profile",
    noNameChange: "Wait $days day$s to change your name",
    newPass: "New password",
    errorFpass: "The password is not valid",
    errorFemail: "The email is not valid",
    errorFemailUsed: "The email is already in use",
    noteAuthenticate:
      "We need to authenticate you. Provide the password for your account.",
    emailChanged: "Email changed successfully",
    passChanged: "Password changed successfully",
    weakPass: "The password is too weak. Provide a different one.",
    chats: "Chats",
    metaD: "Send and receive messages from you computer",
    lVideoMessage: "Do you want to start a live video?",
    start: "Start",
    watchLVideo: "Watch live video",
    addLVideo: "Start live video",
    liveVideoEnded: "Live video ended",
    liveVideoStarted: "Live video started",
    endLiveVideo: "End live video",
    errLiveVideo: "Could not start live video",
    errEndLiveVideo: "Could not end live video",
    streamSettings: "Stream settings",
    streamPermission:
      "$name is live.\nWould you like to request permission to start a live video?",
    allowStream: "Allow live video?",
    allow: "Allow",
    decline: "Decline",
    streamAllowed: "$name invites you to start a live video.",
    permissionGranted: "Permission granted",
    stop: "Stop",
    endVideo: "End live video?",
    exitVideo: "Exit live video?",
    cancelPReq: "Cancel permission request",
    pReqSent: "Permission request sent. You will be notified when accepted.",
    missedCall: "Missed call",
    voiceCall: "Voice call",
    videoCall: "Video call",
    viewConversations: "View recent conversations",
    openMenu: "open menu",
    viewProfileOptions: "view profile options",
    screenCapture: "Screen capture",
    camera: "Camara",
    recordingDevice: "Recording device:",
    watch_together: "Watch videos together",
    yt_options: "Youtube video options",
    enter_yt_link: "Enter Youtube video link:",
    load_video: "Load video",
    yt_announce: "$name invites you to watch a video together",
    watch_invite_sent: "Watch invitation sent",
    stop_yt_video: "Close Youtube player",
    remove_yt_videos: "Remove all my videos",
    remove_video: "Remove video",
    yt_videos_removed: "$d videos removed",
    yt_video_removed: "1 video removed",
    yt_watch_your_video: "Watch youtube video?",
    ins_watch_together: "Enter the link to the video you would like to share:",
    yt_search:
      "Search for a Youtube video or enter the link to the video you would like share",
    error_yt_link: "The link is not valid",
    error_yt_id: "Could not get Youtube video",
    searching: "Searching",
    play_video: "Play video",
    error_not_found: '"$input" not found',
    search_yt: "Search Youtube",
    play_everyone: "Play for everyone",
    video_will_play_everyone: "Video will play for everyone",
    schedule: "Schedule",
    mon: "Lun",
    tue: "Mar",
    wed: "Mie",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    myBroadSched: "My broadcast schedule",
    naSkd: "Nothing scheduled",
    addSkd: "Add schedule",
    back: "Back",
    viewUserSkd: "View my broadcast settings",
    addNewSkd: "Add new schedule",
    selStartTime: "Select start time",
    selEndTime: "Select exit time",
    selBcastDays: "Select broadcast days",
    bcastName: "Broadcast name:",
    selBcastIcon: "Select broadcast icon",
    verifyInfo: "Verify information",
    verify: "Verify",
    happyBcast: "Happy broadcast!",
    cont: "Continue",
    hour: "Hour",
    minute: "Minute",
    am: "AM",
    pm: "PM",
    submit: "Submit",
    imgIcon: "Image icon",
    bCastIcon: "Broadcast icon",
    errorHr: "Please select a valid hour",
    errorMin: "Please select a valid minute",
    errorDays: "Please select at least one day",
    errorName: "Please provide a valid name",
    errorBcastIcon: "Please select an image",
    clockFormat: "The time provided uses the 12-hour clock",
    successSkdAdded: "Congratulations! New schedule added!",
    upIcon: "Uploading icon...",
    upSkdInfo: "Uploading new schedule...",
    delSkd: "Delete this schedule?",
    removing: "Removing...",
    skdRemoved: "Schedule removed",
    delete: "Delete",
    fullSkd: "View full schedule",
    onAir: "On-Air",
    reqTitle: "Request songs or send a message to play on the radio",
    djOptionTitle:
      "Announce you're live, start a live video, or watch a video with your audience in the chat",
    magnify: "Magnify",
    discover: "Discover",
    profileImg: "Profile image",
    home: "Home",
    joinChat: "Join chat room",
    podLogo: "Podcast logo",
    location: "Location",
    likes: "Likes",
    play: "Play",
    emptyPlaylist: "The playlist is empty",
    empty: "Empty",
    loading: "Loading",
    pause: "Pause",
    readMore: "Read more",
    close: "Close",
    groupNotFound: "Sorry. The group you were looking for does not exist.",
    previous: "Previous",
    skdUpdated: "Schedule updated",
    editSkd: "Edit schedule",
    updatingSkg: "Updating schedule",
    sendMsg: "Send message",
    sendAudioMsg: "Send voice message",
    recordAudioMsg: "Record audio message",
    emojis: "Emojis",
    micPermission:
      "To record your audio, we need permission to use your microphone.",
    picPermission: "To take a picture, we need permission to use your camera.",
    vidPermission:
      "To record, we need permission to use your camera and microphone.",
    checkSettings: "Check you settings to give us permission",
    permissionDenied: "Permission denied",
    permissionGranted: "Permission granted. You may need to refresh the page.",
    warnLink: "Links are not allowed in this chat",
    manageChatRules: "Manage chat rules",
    linkPosting: "Link posting",
    blockedForEveryone: "Blocked for everyone",
    allowAdminDJ: "Blocked for everyone except administrators and radio hosts",
    allowedForEveryone: "Allowed for everyone",
    moreFuture:
      "More options will be available in the future to improve everyone's safety",
    updated_successfully: "Updated successfully",
    voiceMsgDeleted: "Voice message deleted",
    searchEmojis: "Search emojis...",
    searchYt: "Search on YouTube",
    markFulfilled: "Mark as fulfilled",
    markUnfulfilled: "Mark as unfulfilled",
    manageSkd: "Manage schedules",
    scrollRight: "Scroll right",
    scrollLeft: "Scroll left",
    createGroup: "Create group",
    searchRadio: "Search radios",
    searchPods: "Search podcasts",
    viewMyGroups: "View my groups",
    welLogin: "Login to access chat rooms and other features",
    welNewUser: "Use the menu on the left to discover groups",
    enterPhone: "Enter your phone number",
    resetPass: "Reset password",
    getRadioWidget: "Get radio widget",
    copied: "Copied",
    addWidget: "Add this widget to your website",
    copyWidget: "Copy widget",
    pasteWidgetWeb: "Paste the copied widget anywhere on your website",
    removeLive: "Remove live",
    errorSubToken: "Could not activate notifications",
    notificationOff: "Notifications turned off for this chat",
    notificationOffError: "Could not turn notication off",
    notificationOn: "Notifications turned on for this chat",
    notificationOnError: "Could not turn on notifications",
  },
  es: {
    language: "es",
    welcome: "Bienvenid@",
    greeting: "!Bienvenid@ a ChatMurcianys!",
    greet: `Bienvenid@ de nuevo @name`,
    Chats: "Chats",
    Radios: "Radios",
    Friends: "Amigos",
    Requests: "Solicitudes",
    chat: "Chat",
    listen: "Escucha",
    booth: "Cabina",
    search: "Buscar amigos",
    addPerson: "Solicitudes de amistad",
    manageRadios: "Mis radios",
    addRadio: "Añadir radio",
    more: "Más",
    profile: "Perfil",
    settings: "Ajustes",
    signOut: "cerrar sesión",
    about: "Sobre app",
    profOptions: "Ver opciones de perfil",
    chatNav: "Navegación de chat",
    modLogout: "¿Estás segur@ de que quieres cerrar sesión?",
    yes: "Si",
    no: "No",
    accConf: "Creado cuenta...",
    nameUse: "¿Qué nombre te gustaría usar?",
    uploadImg: "Subir Imagen",
    register: "Registrarme",
    name: "Nombre",
    regWith: "Registrarme con:",
    phone: "Teléfono",
    email: "Correo electrónico",
    or: "-O-",
    secPhone: "* Por tu seguridad, tu número de teléfono se mantendrá privado.",
    secEmail: "* Por tu seguridad, tu correo electrónico se mantendrá privado",
    password: "Contraseña",
    anyPass: "Cualquier contraseña",
    noChats: "No has iniciado una conversacion",
    received: "Recibidas",
    sent: "Enviadas",
    noInRequests: "No has recibido ninguna solicitud de amistad.",
    noOutRequests: "No has enviado ninguna solicitud de amistad.",
    requestInfo: "↓ Solicita tu canción aquí ↓",
    song: "Canción:",
    artist: "Artista:",
    comment: "Dedicación / Comentario (opcional)...",
    send: "Enviar",
    newUserInfo: "para solicitar canciones, acceder al chat y mucho más!",
    login: "Iniciar sesión",
    noSongRequests: "No hay solicitudes de canciones",
    noMessages: "No hay mensajes en este chat",
    typeHere: "Escribir aquí...",
    updateInfo:
      "*Pueda que lancemos varias actualizaciones a lo largo del día para brindarle una mejor calidad y servicio*",
    modNewRadio: "¿Eres dueñ@ de una radio?",
    downloadMess:
      "ChatMurcianys está disponible para tu dispositivo en Google PlayStore",
    download: "Descargar",
    voiceMessage: "Mensaje de voz",
    picture: "Foto",
    video: "Video",
    gif: "Gif",
    you: "Tu",
    errorSendPetition: "Error enviando la peticion. intenta más tarde.",
    successPetitionPlay: "Song marked as unplayed",
    songPlayed: "Canción marcada como sonada",
    yourSong: "Tu canción ",
    isPlaying: '" está sonando. Gracias!\n',
    requestReviewed: "He revisado tu peticion. ",
    yoursTruly: "Gracias!\n",
    errorSendingMessage: "Error al enviar mensaje. Inténtalo más tarde.",
    playingSent: "Mensaje enviado con éxito",
    petitionDeleted: "Peticion borrada con éxito",
    errorMess: "Hubo un error. Intétalo de nuevo más tarde.",
    errorEmail: "Por favor provee un correo electrónico valido",
    welcomeBack: "¡Bienvenid@ de nuevo! Ingresa la contraseña para esta cuenta",
    createPass: "Crea una contraseña para proteger tu cuenta",
    errorPass: "Por favor, proporciona una contraseña para tu cuenta.",
    registerMes: "Inicia sesión para aprovechar al máximo nuestro chat",
    continue: "Continua con...",
    next: "Siguiente",
    rememberMe: "Recúerdame",
    infoLog:
      "Utilizaremos la información anterior para iniciar sesión o para crear una nueva cuenta si no tiene una.",
    disclaimer:
      'Al continuar, aceptas nuestros <a href="about.html#terms">Términos y Condiciones</a>, y <a href="about.html">Política de Seguridad</a>',
    live: "En vivo: ",
    announceLive: "¡Estoy en vivo!",
    announceEnd: "Estoy fuera del aire",
    liveStarted: "Notificación enviada",
    liveEnded: "Emisión finalizada",
    sendNotification: "Enviar notificación",
    liveMessage: "Este mensaje será enviado a tus oyentes:",
    isLive: "está en vivo en ",
    today: "Hoy",
    yesterday: "Ayer",
    menu: "Menú",
    translate: "Traducir",
    idiom: "Es",
    petNewUser: "Inicia sesión para ver las solicitudes de canciones",
    chatNewUser: "Inicia sesión para ver el chat",
    mesInstruc:
      "Use el menú de la izquierda para iniciar una conversación o descrubir grupos.",
    listenHere: "Escucha la radio aquí",
    searchGiphy: "Buscar GIFs...",
    providedBy: "Proveído por GIPHY",
    chatRemoved: "fue eliminado de tu historial de chat",
    radioNotExist: "Lo siento. La radio que estabas buscando no existe",
    favorite: "Añadir a favoritos",
    unfavorite: "Remover de favoritos",
    newRequest: "Solicitar canción/envíar comentario",
    requestsLeft: "Quedan num peticion",
    requestsLeftPl: "Quedan num peticiones",
    myRadios: "Mis Radios",
    myFavorites: "Mis Favoritos",
    topTen: "Top 10 Radios",
    searchRadios: "Buscar radios...",
    radioNotFound: "$name no se encontró",
    waitTime:
      "por favor espera hasta la(s) $time antes de solicitar otra canción",
    requestsDenied: "Peticiones no están permitidas en este momento",
    adReward: "¡Felicidades! Has obtenido una petitcion más",
    adModalMessage: "¿Te gustaría ver un anuncio para solicitar una canción?",
    watchAd: "Mirar anuncio",
    watchAdNote: "Mirar un anuncio para más peticiones",
    sendFriendReq: "Enviar solicitud de amistad",
    unfriend: "Eliminar de amigos",
    cancelReq: "Cancelar solicitud de amistad",
    acceptReq: "Aceptar solicitud de amistad",
    declineReq: "Rechazar solicitud de amistad",
    reqSent: "Solicitud de amistad enviada con éxito",
    sendingReq: "Enviando solicitud de amistad...",
    requestCancelled: "Solicitud de amistad cancelada con éxito",
    newFriend: "$name forma parte de tus amistades",
    addingFriend: "Añadiendo a $name a tu lista de amigos...",
    friendRemoved: "$name ya no forma parte de tus amistades",
    removingFriend: "Eliminando a $name de tus amistades...",
    addMessage: "¿Quieres añadir un mensaje a tu solicitud?",
    noDNA: "No, no preguntar de nuevo",
    cancel: "Cancelar",
    searchFriends: "Buscar amigos...",
    searchHint: "Buscar",
    confirmRemove: "¿Quieres remover a $name de tus amistades?",
    searchBkm: "Buscar chats recientes...",
    djHost: "Locutores/DJs",
    goMain: "Ir a la página principal",
    viewRadioInfo: "Ver información de la radio",
    moreOptions: "Más opciones",
    editRadioInfo: "Editar información de la radio",
    locationSpan: '<span class="blueText boldText">Ubicación: </span>',
    admins: "Administradores",
    pOnline: "Participantes en línea",
    radioProblem: "¿Tienes problemas con tu radio?",
    changeBanner: "Cambiar banner",
    changeLogo: "Cambiar logo",
    adminName: "Nombre de administrador",
    editRadioName: "Nombre de la radio",
    slogan: "Eslogan",
    radioURL: "URL de transmisión de la radio",
    noteStream: '*Ejemplo: "https://xxxx:1232"',
    noteSlogan:
      '*Ejemplo: "The Best Variety of Yesterday and Today - Sunny 99.1"',
    description:
      "Describe tu radio...Qué tipo de música reproduce tu radio, horas de emisión, etc.",
    country: "Seleccionar país",
    phoneNo: "Número de Teléfono",
    website: "Sitio web",
    welcomeMessage: "Mensaje de bienvenida",
    updateRadio: "Actualizar información de la radio",
    lblRadioHost: "Locutores de radio/DJs",
    add: "Añadir",
    noAdmins: "No hay información de administrador disponible",
    noDj: "No hay información disponible",
    noUsers: "No hay nadie en línea",
    emailBody:
      "Uid:%20userid%0d%0aReportando%20radio%0d%0aEscribe%20abajo%20de%20la%20línea%0d%0a--------------------------------------%0d%0a",
    emailBodHelp:
      "Uid:%20userid%0d%0aSolicitando%20ayuda%0d%0aEscribe%20abajo%20de%20la%20línea%0d%0a--------------------------------------%0d%0a",
    reportRadio: "Reportar problemas con la radio",
    audioError:
      '*Algunos navegadores tal vez no reproducirán el audio porque no comienza con "https" <a id="aRadioLink" href="" target="_blank">Haz click aquí para probar el audio</a>',
    radioCheck:
      "¿Puedes escuchar la radio? Si no, edita la transmisión de arriba",
    noChanges: "No se realizaron cambios",
    infoUpdating:
      "La información se está actualizando. Se le notificará cuando haya terminado.",
    changesMade: "La información fue actualizada con éxito",
    reply: "Responder",
    forward: "Reenviar",
    share: "Compartir",
    errorUnknown: "Hubo un error desconocido. Intenta nuevamente más tarde",
    errorImage: "No tienes permiso de subir la imagen.",
    errorUploadCancel: "Has cancelado la carga",
    subChanges: "Aplicar cambios",
    upInfo: "Actualizar información",
    currPass: "Contraseña actual",
    changeEmail: "Cambiar correo electrónico",
    changePass: "Cambiar contraseña",
    nameNote:
      "Si cambias tu nombre, no podrás volver a cambiarlo dentro de un año.",
    undoChange: "Deshacer el cambio",
    changeImage: "Cambiar imagen",
    editProfile: "Editar perfil",
    noNameChange: "Espera $days día$s para cambiar tu nombre",
    newPass: "Nueva contraseña",
    errorFpass: "La contraseña no es valida",
    errorFemail: "El correo electrónico no es valido",
    errorFemailUsed: "El correo electrónico ya está en uso",
    noteAuthenticate:
      "Necesitamos autenticarte. Proporciona la contraseña de tu cuenta.",
    emailChanged: "Corre electrónico cambiado con éxito",
    passChanged: "Contraseña cambiada con éxito",
    weakPass: "la contraseña es debil. Provee otra.",
    chats: "Chats",
    metaD: "Envía y recive mensajes desde tu computadora",
    lVideoMessage: "¿Quieres iniciar un video en vivo?",
    start: "Iniciar",
    watchLVideo: "Mirar video en vivo",
    addLVideo: "Iniciar video en vivo",
    liveVideoEnded: "Video en vivo finalizado",
    liveVideoStarted: "Video en vivo iniciado",
    endLiveVideo: "Finalizar video en vivo",
    errLiveVideo: "No se pudo iniciar video en vivo",
    errEndLiveVideo: "No se pudo finalizar video en vivo",
    streamSettings: "Configuración de la transmisión",
    streamPermission:
      "$name está en vivo.\n¿Quieres solicitar permiso para iniciar video en vivo?",
    allowStream: "¿Permitir video en vivo?",
    allow: "Permitir",
    decline: "Declinar",
    streamAllowed: "$name te invita a iniciar video en vivo.",
    permissionGranted: "Permiso otorgado",
    stop: "Detener",
    endVideo: "¿Finalizar video en vivo?",
    exitVideo: "¿Salir del video en vivo?",
    cancelPReq: "Cancelar solicitud de permiso",
    pReqSent:
      "Solicitud de permiso enviada. Se te notificará cuando sea aceptada.",
    missedCall: "Llamada perdida",
    voiceCall: "Llamada de voz",
    videoCall: "Video llamada",
    viewConversations: "Ver conversaciones recientes",
    openMenu: "abrir menu",
    viewProfileOptions: "ver opciones de perfil",
    screenCapture: "Capturar pantalla",
    camera: "Camara",
    recordingDevice: "Dispositivo para grabar:",
    watch_together: "Mirar videos juntos",
    yt_options: "Opciones de video de youtube",
    enter_yt_link: "Ingresa enlace de video de Youtube:",
    load_video: "Cargar video",
    yt_announce: "$name te invita a ver un video juntos",
    watch_invite_sent: "Invitación para ver video enviada",
    stop_yt_video: "Cerrar Youtube",
    remove_yt_videos: "Remover todos mis videos",
    remove_video: "Remover video",
    yt_videos_removed: "$d videos removido",
    yt_video_removed: "1 video removido",
    yt_watch_your_video: "¿Mirar video de Youtube?",
    ins_watch_together: "Ingresa el enlace del video que quieres compartir:",
    yt_search:
      "Busca un video de Youtube o ingresa el enlace del video que quieres compartir",
    error_yt_link: "El enlace no es valido",
    error_yt_id: "No se pudo obtener el video de Youtube",
    searching: "Buscando",
    play_video: "Reproducir video",
    error_not_found: '"$input" no se encontró',
    search_yt: "Buscar en Youtube",
    play_everyone: "Reproducir para todos",
    video_will_play_everyone: "El video de reproducirá para todos",
    schedule: "Horario",
    mon: "Lun",
    tue: "Mar",
    wed: "Mie",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miercoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    myBroadSched: "Mi horario de transmisión",
    naSkd: "No hay nada programado",
    addSkd: "Agregar horario",
    back: "Regresar",
    viewUserSkd: "Ver mi configuración de transmisión",
    addNewSkd: "Agregar nuevo horario",
    selStartTime: "Seleccionar tiempo de inicio",
    selEndTime: "Seleccionar tiempo de salida",
    selBcastDays: "Seleccionar días de transmisión",
    bcastName: "Nombre de la transmisión:",
    selBcastIcon: "Seleccionar ícono de presentación",
    verifyInfo: "Verificar información",
    verify: "Verificar",
    happyBcast: "¡Feliz transmisión!",
    cont: "Continuar",
    hour: "Hora",
    minute: "Minuto",
    am: "AM",
    pm: "PM",
    submit: "Enviar",
    imgIcon: "Icono de imagen",
    bCastIcon: "Icono de transmisión",
    errorHr: "Por favor selecciona una hora válida",
    errorMin: "Por favor selecciona un minuto válido",
    errorDays: "Por favor selecciona un día",
    errorName: "Por favor provee un nombre válido",
    errorBcastIcon: "Por favor selecciona una imagen",
    clockFormat: "El tiempo proporcionado utiliza el reloj de 12 horas",
    successSkdAdded: "¡Felicidades! ¡Nuevo horario agregado!",
    upIcon: "Subiendo ícono...",
    upSkdInfo: "Subiendo nuevo horario...",
    delSkd: "¿Borrar este horario?",
    removing: "Removiendo...",
    skdRemoved: "Horario removido",
    delete: "Borrar",
    fullSkd: "Ver horario completo",
    onAir: "Al-Aire",
    reqTitle:
      "Solicita canciones o envía un mensaje para reproducir en la radio",
    djOptionTitle:
      "Anuncia que estás en vivo, comienza un video en vivo o mira un video con tu audiencia en el chat",
    magnify: "Agrandar",
    discover: "Descubre",
    profileImg: "Imagen de perfil",
    home: "Inicio",
    joinChat: "Ir al chat",
    podLogo: "Logo del podcast",
    location: "Ubicación",
    likes: "Gustos",
    play: "Reproducir",
    emptyPlaylist: "La lista de reproducción está vacía",
    empty: "Vacío",
    loading: "Cargando",
    pause: "Pausar",
    readMore: "Leer más",
    close: "Cerrar",
    groupNotFound: "Lo siento. El grupo que estabas buscando no existe",
    previous: "Atrás",
    skdUpdated: "Horario actualizado",
    editSkd: "Editar horario",
    updatingSkg: "Actualizando horario...",
    sendMsg: "Enviar mensaje",
    sendAudioMsg: "Enviar mensaje de voz",
    recordAudioMsg: "Grabar mensaje de voz",
    emojis: "Emojis",
    micPermission:
      "Para grabar audio necesitamos permiso para acceder al micrófono",
    picPermission:
      "Para tomar fotos necesitamos permiso para acceder a la camara",
    vidPermission:
      "Para grabar video necesitamos permiso para acceder a la camara",
    checkSettings: "Revisa tu configuración para darnos permiso",
    permissionDenied: "Permiso denegado",
    permissionGranted:
      "Permiso concedido. Es posible que deba refrescar la página.",
    warnLink: "No se permiten enlaces en este chat",
    manageChatRules: "Administrar reglas del chat",
    linkPosting: "Publicación de enlaces",
    blockedForEveryone: "Bloqueado para todos",
    allowAdminDJ: "Bloqueado para todos excepto administradores y locutores",
    allowedForEveryone: "Permitido para todos",
    moreFuture:
      "Más opciones estarán disponibles a futuro para mejorar la seguridad de todos",
    updated_successfully: "Actualizado con éxito",
    voiceMsgDeleted: "Mensaje de voz eliminado",
    searchEmojis: "Buscar emojis",
    searchYt: "Buscar en YouTube",
    markFulfilled: "Marcar como cumplido",
    markUnfulfilled: "Marcar como incumplido",
    manageSkd: "Administrar horarios",
    scrollRight: "Mover a la derecha",
    scrollLeft: "Mover a la izquierda",
    createGroup: "Crear grupo",
    searchRadio: "Buscar radios",
    searchPods: "Buscar podcasts",
    viewMyGroups: "Ver mis grupos",
    welLogin:
      "Inicia sesión para acceder a las salas de chat y otras funciones",
    welNewUser: "Usa el menú de la izquierda para descubrir grupos",
    enterPhone: "Introduce tu número de teléfono",
    resetPass: "Restablecer contraseña",
    getRadioWidget: "Obtener widget de mi radio",
    copied: "Copiado",
    addWidget: "Añade este widget a tu sitio web",
    copyWidget: "Copiar widget",
    pasteWidgetWeb: "Pega el widget copiado en cualquier lugar de tu sitio web",
    removeLive: "Remover en vivo",
    errorSubToken: "No se pudo activar las notificaciones",
    notificationOff: "Notificaciones desactivadas para este chat",
    notificationOffError: "No se pudo desactivar la notificación",
    notificationOn: "Notificaciones activadas para este chat",
    notificationOnError: "No se pudieron activar las notificaciones",
  },
};

function translatePage(lang) {
  var translate = false;
  if (lang) {
    if (lang.includes("es")) {
      if (trans && trans.idiom == "Es") {
        return;
      }
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      // if (currentChatType) {
      //     document.body.innerHTML.replace(/Today/g, trans.today);
      //     document.body.innerHTML.replace(/Yesterday/g, trans.yesterday);
      // }
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className = langs[0].className.replace(" set", "");
      langs[1].className += " set";
      setCookie("lang", "es", 365);
    } else {
      if (trans && trans.idiom == "En") {
        return;
      }
      trans = language.eng;
      document.getElementsByTagName("html")[0].setAttribute("lang", "en");
      // if (currentChatType) {
      //     document.body.innerHTML = document.body.innerHTML.replace(/Hoy/g, trans.today);
      //     document.body.innerHTML = document.body.innerHTML.replace(/Ayer/g, trans.yesterday);
      // }
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className += " set";
      langs[1].className = langs[1].className.replace(" set", "");
      setCookie("lang", "en", 365);
    }
    translate = true;
  } else if (getCookie("lang") != "") {
    if (getCookie("lang").includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className = langs[0].className.replace(" set", "");
      langs[1].className += " set";
      translate = true;
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
    }
  } else if (navigator.language && navigator.language.includes("es")) {
    trans = language.es;
    document.getElementsByTagName("html")[0].setAttribute("lang", "es");
    var langs = langDropdown.querySelectorAll("a");
    langs[0].className = langs[0].className.replace(" set", "");
    langs[1].className += " set";
    translate = true;
  } else {
    trans = language.eng;
  }

  if (translate) {
    btnNext.textContent = trans.next;
    if (userName == null) {
      username.textContent = trans.welcome;
    }
    var menuTexts = smallNav.querySelectorAll(".menuText");
    menuTexts[0].textContent = trans.menu;
    menuTexts[1].textContent = trans.chats;
    menuTexts[2].textContent = trans.profile;
    menuTexts[3].textContent = trans.translate;
    //menuLang.querySelector("span").textContent = trans.idiom;
    panSearch.textContent = trans.search;
    panFriend.textContent = trans.Requests;
    panMyRadios.textContent = trans.manageRadios;
    panAddRadio.textContent = trans.addRadio;
    more.textContent = trans.more;
    panProfile.textContent = trans.profile;
    panSettings.textContent = trans.settings;
    panLogout.textContent = trans.signOut;
    panAbout.textContent = trans.about;
    myModal.querySelector("h2").textContent = trans.modLogout;
    myModal.querySelector(".btnBlue").textContent = trans.yes;
    myModal.querySelector(".btnGray").textContent = trans.no;
    registerModal.querySelector("p").textContent = trans.accConf;
    registerModal.querySelector(".blueText").textContent = trans.nameUse;
    registerModal.querySelector(".lblUpload").textContent = trans.uploadImg;
    btnRegister.textContent = trans.register;
    registerModal.querySelector(".regWelcome").textContent = trans.greeting;
    inName.placeholder = trans.name;
    var navButtons = navBox.querySelectorAll("button");
    navButtons[0].textContent = trans.Chats;
    navButtons[1].textContent = trans.discover;
    navButtons[2].textContent = trans.Friends;
    navButtons[3].textContent = trans.Requests;
    noChats.textContent = trans.noChats;
    requests.querySelector(".in").textContent = trans.received;
    requests.querySelector(".out").textContent = trans.sent;
    noneReceived.textContent = trans.noInRequests;
    noneSent.textContent = trans.noOutRequests;
    btnTabRadio.textContent = trans.home;
    btnTabPet.textContent = trans.booth;
    btnTabChat.textContent = trans.chat;
    petitionBox.querySelector(".boldText").textContent = trans.requestInfo;
    inSong.placeholder = trans.song;
    inArtist.placeholder = trans.artist;
    inComment.placeholder = trans.comment;
    btnSendRequest.textContent = trans.send;
    var userPs = newUserBox.querySelectorAll("p");
    userPs[0].textContent = trans.welcome;
    //userPs[1].textContent = trans.or;
    userPs[1].textContent = trans.newUserInfo;
    btnNewUser.textContent = trans.register;

    normMessagesNone.textContent = trans.noMessages;
    divTypeHere.textContent = trans.typeHere;
    divWelcome.querySelector(".boldText").textContent = trans.greet.replace(
      "@name",
      userInfo ? userInfo.name : ""
    );
    //divWelcome.querySelector(".updateDis").textContent = trans.updateInfo;
    divWelcome.querySelector("#instructWelcome span").textContent =
      trans.mesInstruc;
    noRequests.textContent = trans.noSongRequests;
    radioMes.textContent = trans.modNewRadio;
    downloadApp.querySelector("p").textContent = trans.downloadMess;
    downloadApp.querySelector(".btnBlue").textContent = trans.download;
    btnLoginNew.textContent = trans.login;
    if (newUser) {
      divPassInfo.textContent = trans.createPass;
    } else {
      divPassInfo.textContent = trans.welcomeBack;
    }
    var registerPs = registerUser.querySelectorAll("p");
    registerPs[0].textContent = trans.registerMes;
    registerPs[1].textContent = trans.continue;
    registerPs[2].textContent = trans.infoLog;
    registerPs[3].innerHTML = trans.disclaimer;
    btnPhoneLogin.textContent = trans.phone;
    btnEmailLogin.textContent = trans.email;
    etEmail.placeholder = trans.email;
    etPassword.placeholder = trans.password;
    //btnLogin.textContent = trans.login;
    registerUser.querySelector(".boldText").textContent = trans.rememberMe;
    liveDJ.textContent = trans.live + hostName;
    if (hostName != "") {
      btnGoLive.textContent = trans.announceEnd;
    } else {
      btnGoLive.textContent = trans.announceLive;
    }

    btnSendLive.textContent = trans.sendNotification;
    goLiveModal.querySelector(".liveMessage").textContent = trans.liveMessage;
    endMessage.textContent = trans.isLive;
    inGifSearch.placeholder = trans.searchGiphy;
    gifView.querySelector(".notes").textContent = trans.providedBy;
    if (isFavorite) {
      divFavorite.querySelector("div").textContent = trans.unfavorite;
      imgFavorite.title = trans.unfavorite;
    } else {
      divFavorite.querySelector("div").textContent = trans.favorite;
      imgFavorite.title = trans.favorite;
    }
    btnNewRequest.querySelector("span").textContent = trans.newRequest;
    userRadios.textContent = trans.myRadios;
    favs.textContent = trans.myFavorites;
    topRadios.textContent = trans.topTen;
    inRadioSearch.placeholder =
      GroupType.radio == group ? trans.searchRadios : trans.searchPods;
    requestAdModal.querySelector(".adMessage").textContent =
      trans.adModalMessage;
    const btnWatchAd = document.getElementById("btnWatchAd");
    btnWatchAd.querySelector("span").textContent = trans.watchAd;
    divAdNote.textContent = trans.watchAdNote;
    requestAdModal.querySelector(".btnBlue").textContent = trans.yes;
    requestAdModal.querySelector(".redBtn").textContent = trans.no;
    addMessageModal.querySelector(".message").textContent = trans.addMessage;
    var radOptions = addMessageModal.querySelectorAll("span");
    radOptions[1].textContent = trans.yes;
    radOptions[2].textContent = trans.no;
    radOptions[3].textContent = trans.noDNA;
    addMessageModal.querySelector(".btnBlue").textContent = trans.send;
    addMessageModal.querySelector(".redBtn").textContent = trans.cancel;
    addMessageModal.querySelector('input[type="text"]').placeholder =
      trans.typeHere;
    inFSearch.placeholder = trans.searchFriends;
    btnSearchF.title = trans.searchHint;
    btnSearchRad.title = trans.searchHint;
    btnSearchChat.title = trans.searchHint;
    inChatSearch.placeholder = trans.searchBkm;
    djs.querySelector(".topHead").textContent = trans.djHost;
    if (currentUserId) {
      messageNone.textContent = trans.noMessages;
    } else {
      messageNone.textContent = trans.chatNewUser;
    }
    cmHome.querySelector("img").title = trans.goMain;
    divRadioInfo.textContent = trans.viewRadioInfo;
    imgMore.title = trans.moreOptions;
    imgSettings.title = trans.editRadioInfo;
    radioLocation.querySelector("span").textContent = trans.locationSpan;
    var topHeads = radioInfoModal.querySelectorAll(".topHead");
    topHeads[0].textContent = trans.admins;
    topHeads[1].textContent = trans.lblRadioHost;
    topHeads[2].textContent = trans.pOnline;
    radioInfoModal.querySelector(".redBtn").textContent = trans.radioProblem;
    editRadioModal.querySelector(".mainTop").textContent = trans.editRadioInfo;
    divUpdateBanner.textContent = trans.changeBanner;
    upLogo.textContent = trans.changeLogo;
    inAdminName.placeholder = trans.adminName;
    inRadioName.placeholder = trans.editRadioName;
    inSlogan.placeholder = trans.slogan;
    var notes = editRadioModal.querySelectorAll(".notes");
    notes[0].textContent = trans.noteSlogan;
    notes[1].textContent = trans.noteStream;
    notes[2].innerHTML = trans.audioError;
    inDescription.placeholder = trans.description;
    opIns.textContent = trans.country;
    inPhone.placeholder = trans.phoneNo;
    inRadioEmail.placeholder = trans.email;
    inWebsite.placeholder = trans.website;
    inWMessage.placeholder = trans.welcomeMessage;
    inRadioStream.placeholder = trans.radioURL;
    editRadioModal.querySelector(".btn-blue").textContent = trans.updateRadio;
    addHost.querySelector("div").textContent = trans.add;
    addAdmin.querySelector("div").textContent = trans.add;
    updatingLoaderModal.querySelector(".message").textContent =
      trans.infoUpdating;
    divEditInfo.textContent = trans.editRadioInfo;
    aRadioLink.href = inRadioStream.value.trim();

    $(".messageReply").text(trans.reply);
    $(".phHolder .rep").attr("title", trans.reply);
    $(".phHolder .sha").attr("title", trans.share);
    $(".phHolder .for").attr("title", trans.forward);
    $(".phHolder .dow").attr("title", trans.download);
    $(".t-cancel").attr("title", trans.cancel);
    $(".tc").text(trans.cancel);
    $("#userEditModal .mainTop.centerItems.top").text(trans.editProfile);
    $("#userEditModal .img-thumbnail").attr("title", trans.changeImage);
    $("#userEditModal .boldText.lblBlack").text(trans.changeImage);
    $("#userEditModal .undo").text(trans.undoChange);
    $("#userEditModal .notes.redText").text(trans.nameNote);
    $("#userEditModal .notes.redText.xc").attr("title", trans.noNameChange);
    $(".nameP").attr("placeholder", trans.name);
    var edits = userEditModal.querySelectorAll(".blueText.point.under.hov");
    edits[0].textContent = trans.changeEmail;
    edits[1].textContent = trans.changePass;
    userEditModal.querySelector('input[type="email"]').placeholder =
      trans.email;
    userEditModal.querySelector(
      'input[type="password"].redBorder'
    ).placeholder = trans.currPass;
    userEditModal.querySelector(
      'input[type="password"].blueBorder'
    ).placeholder = trans.newPass;
    userEditModal.querySelector(".redBtn.tc").textContent = trans.cancel;
    var editBtns = userEditModal.querySelectorAll(".btn-blue");
    editBtns[0].textContent = trans.upInfo;
    editBtns[1].textContent = trans.subChanges;
    liveVideoModal.querySelector(".redBtn").textContent = trans.start;
    liveVideoModal.querySelector(".liveMessage").textContent =
      trans.lVideoMessage;
    btnWatchVideo.textContent = trans.watchLVideo;
    btnLiveVideo.textContent = trans.addLVideo;
    btnStopStream.textContent = trans.endLiveVideo;
    var imgHostSettings = liveVideoContainerHeader.querySelector("img");
    imgHostSettings.alt = trans.streamSettings;
    imgHostSettings.title = trans.streamSettings;
    reqVideoModal.querySelector(".redBtn").textContent = trans.yes;
    requestDiv.querySelector(".tt").textContent = trans.allowStream;
    $("#requestItems .allow").text(trans.allow);
    $("#requestItems .decline").text(trans.decline);
    endLiveModal.querySelector(".redBtn").textContent = trans.yes;
    btnCancelReq.textContent = trans.cancelPReq;
    mnuChats.title = trans.viewConversations;
    mnuMenu.title = trans.openMenu;
    mnuProfile.title = trans.viewProfileOptions;
    btnTranslate.title = trans.translate;
    var radBtns = liveVideoModal.querySelectorAll("label");
    radBtns[0].textContent = trans.camera;
    radBtns[1].textContent = trans.screenCapture;
    $("#liveVideoModal .device").text(trans.recordingDevice);
    if (isYtwatching) {
      imgWatchVideos.textContent = trans.yt_options;
      imgWatchVideos.title = trans.yt_options;
    } else {
      imgWatchVideos.textContent = trans.watch_together;
      imgWatchVideos.title = trans.watch_together;
    }
    btnCloseYtPlayer.textContent = trans.stop_yt_video;
    btnRemoveMyVideos.textContent = trans.remove_yt_videos;
    btnWatchTogether.textContent = trans.watch_together;
    divIns.textContent = trans.yt_search;
    inSearch.placeholder = trans.search_yt;
    divYtSearch.querySelector("label").textContent = trans.play_everyone;
    $(".btn-back").attr("title", trans.back);
    secSchedule.querySelector(".pTitle").textContent = trans.myBroadSched;
    skdEmpty.querySelector("p").textContent = trans.naSkd;
    bSchedule.querySelector(".pTitle").textContent = trans.schedule;
    var lstDays = ulDays.querySelectorAll("li");
    lstDays[0].textContent = trans.mon;
    lstDays[1].textContent = trans.tue;
    lstDays[2].textContent = trans.wed;
    lstDays[3].textContent = trans.thu;
    lstDays[4].textContent = trans.fri;
    lstDays[5].textContent = trans.sat;
    lstDays[6].textContent = trans.sun;
    dNone.querySelector("p").textContent = trans.naSkd;
    btnAddSkd.querySelector("span").textContent = trans.addSkd;
    divAddSkd.querySelector(".pTitle").textContent = copyShowKey
      ? trans.editSkd
      : trans.addNewSkd;
    var subTitles = divAddSkd.querySelectorAll(".pSubTitle");
    subTitles[0].textContent = trans.selStartTime;
    subTitles[1].textContent = trans.selEndTime;
    subTitles[2].textContent = trans.selBcastDays;
    subTitles[3].textContent = trans.bcastName;
    subTitles[4].textContent = trans.selBcastIcon;
    subTitles[5].textContent = trans.verifyInfo;
    $('[name="hour"]').attr("placeholder", trans.hour);
    $('[name="minute"]').attr("placeholder", trans.minute);
    $('[value="am"]').attr("placeholder", trans.am);
    $('[value="pm"]').attr("placeholder", trans.pm);
    btnSkdPre.textContent = trans.back;
    btnSkdCont.textContent = trans.cont;
    btnSkdSubmit.textContent = trans.addSkd;
    var skdChks = divAddSkd.querySelectorAll('p[role="checkbox"] span');
    skdChks[0].textContent = trans.monday;
    skdChks[1].textContent = trans.tuesday;
    skdChks[2].textContent = trans.wednesday;
    skdChks[3].textContent = trans.thursday;
    skdChks[4].textContent = trans.friday;
    skdChks[5].textContent = trans.saturday;
    skdChks[6].textContent = trans.sunday;
    inBcastName.placeholder = trans.typeHere;
    btnSkdUpImg.textContent = trans.uploadImg;
    imgSkdIcon.alt = trans.imgIcon;
    divSkdVerify.querySelector("img").alt = trans.bCastIcon;
    $(".clock-format").text(trans.clockFormat);
    $("#addSkdModal p").text(trans.successSkdAdded);
    $(".delete").attr("title", trans.delete);
    btnFullSkd.textContent = trans.fullSkd;
    $(".onAir").text(trans.onAir);
    if (vCoins != null && vCoins > 1) {
      divReqLeft.textContent = trans.requestsLeftPl.replace("num", vCoins);
    } else {
      divReqLeft.textContent = trans.requestsLeft.replace("num", vCoins);
    }
    document.querySelector(".reqs").querySelector(".tHead").textContent =
      trans.reqTitle;
    divDjOptions.querySelector(".tHead").textContent = trans.djOptionTitle;
    $(".tMoreOpt").attr("title", trans.moreOptions);
    $(".tMagnify").attr("title", trans.magnify);
    $(".xListen").text(trans.listen);
    $(".xHome").text(trans.home);
    $(".xJoinChat").text(trans.joinChat);
    $(".tMagnify").attr("alt", trans.podLogo);
    $(".altLocation").attr("alt", trans.location);
    $(".altLikes").attr("alt", trans.likes);
    $(".xAddFav").text(trans.favorite);
    $(".xPlay").text(trans.play);
    $(".xEmptyPlay").text(trans.emptyPlaylist);
    $(".altEmpty").attr("alt", trans.empty);
    $(".altLoading").attr("alt", trans.loading);
    $(".readMore").text(trans.readMore);
    $(".xClose").text(trans.close);
    $(".tClose").attr("title", trans.close);
    $(".tPlay").attr("title", trans.play);
    $(".tPrev").attr("title", trans.previous);
    $(".tNext").attr("title", trans.next);
    $(podNoMsgs).text(trans.noMessages);
    $(btnSend).attr("title", trans.sendMsg);
    $(btnRecordAudio).attr("title", trans.recordAudioMsg);
    $(btnMoji).attr("title", trans.emojis);
    $("#chatRulesModal .t-title").text(trans.manageChatRules);
    $(".mng-chat-rules").text(trans.manageChatRules);
    var emojiRoot = document.getElementById("emojiRoot");
    if (emojiRoot != null) {
      var inEmojiSearch = emojiRoot.querySelector("input.emoji-picker__search");
      if (inEmojiSearch != null) {
        inEmojiSearch.placeholder = trans.searchEmojis;
      }
    }
    $(".sp-searchYt").text(trans.searchYt);
    $(".sp-fulfilled").text(trans.markFulfilled);
    $(".sp-unfulfilled").text(trans.markUnfulfilled);
    $(".sp-delete").text(trans.delete);
    $(".tc-manageSkd").text(trans.manageSkd);
    $(".tc-viewBcastSet").text(trans.viewUserSkd);
    $(".tc-naSkd").text(trans.naSkd);
    $(".scroll-right").attr("title", trans.scrollRight);
    $(".scroll-left").attr("title", trans.scrollLeft);
    $(".sp-create-group").text(trans.createGroup);
    $(".alt-create-group").attr("alt", trans.createGroup);
    $(".txt-search-radios").text(trans.searchRadio);
    $(".alt-search-radios").attr("alt", trans.searchRadio);
    $(".txt-search-pods").text(trans.searchPods);
    $(".alt-search-pods").attr("alt", trans.searchPods);
    $(".txt-view-my-groups").text(trans.viewMyGroups);
    $(".alt-view-my-groups").attr("alt", trans.viewMyGroups);
    $(".txt-login").text(trans.login);
    $(".txt-wel-login").text(trans.welLogin);
    $(".firebaseui-title").text(trans.enterPhone);
    $(".firebaseui-title").text(trans.enterPhone);
    $(".mdl-textfield__label").text(trans.phoneNo);
    $(".firebaseui-id-submit").text(trans.verify);
    $(".txt-reset-pass").text(trans.resetPass);
    $("#dGetRadioWidget").text(trans.getRadioWidget);
    $("#radioWidgetModal p.mainTop").text(trans.addWidget);
    $("#btnCopyWidget").text(trans.copyWidget);
    $("#radioWidgetModal p.c-m-blue").text(trans.pasteWidgetWeb);
    $(".tc-removeLive").text(trans.removeLive);
  }
}
